import { IJournalConfigSeedData } from '../seed';
import { bmmData } from '../seed/biomedicalmaterials/bmm-seed-data';
import { cpgrData } from '../seed/climatepolicygovernancereview/cpgr-seed-data';
import { bfbData } from '../seed/biofabrication/bfb-seed-data';
import { bpeeData } from '../seed/bpee/bpee-seed-data';
import { testData } from '../seed/test-journal/test-seed-data';
import { bibmData } from '../seed/bibm/bibm-seed-data';
import { pbData } from '../seed/physicalbiology/pb-seed-data';
import { irreiData } from '../seed/irrei/irrei-seed-data';
import { jripData } from '../seed/jrip/jrip-seed-data';
import { riseData } from '../seed/rise/rise-seed-data';
import { morressierTestData } from '../seed/morressier-test/test-seed-data';
import { bjrData } from '../seed/boneandjointresearch/bnjr-seed-data';
import { bnjtestData } from '../seed/bnjtest/bnjtest-seed-data';
import { bjjData } from '../seed/boneandjointjournal/bjj-seed-data';
import { bjoData } from '../seed/boneandjointopen/bjo-seed-data';
import { tfbData } from '../seed/scup/nordicjournalhousingresearch/tfb-seed-data';
import { joneData } from '../seed/morressier/journalone/jone-seed-data';
import { jtwoData } from '../seed/morressier/journaltwo/jtwo-seed-data';
import { nsfData } from '../seed/scup/nordicnursingresearch/nsf-seed-data';
import { nptData } from '../seed/scup/norsk-pedagogisk-tidsskrift/npt-seed-data';
import { samtalData } from '../seed/scup/samtal/samtal-seed-data';

import { bseData } from '../seed/scup/basejournal/bse-seed-data';
import { jthreeData } from '../seed/morressier/journalthree/jthree-seed-data';
import { baseData } from '../seed/morressier/basejournal/base-seed-data';
import { nsfQCData } from '../seed/scup/nordicnursingresearch-qc/nsf-qc-seed-data';
import { tfbQCData } from '../seed/scup/nordicjournalhousingresearch-qc/tfb-qc-seed-data';
import { bjmhData } from '../seed/mag/britishjournalofmentalhealthnursing/bjmh-seed-data';
import { magBaseData } from '../seed/mag/basejournal/bse-seed-data';
import { berghahnBaseData } from '../seed/berghahn/basejournal/bse-seed-data';
import { projData } from '../seed/berghahn/Projections/proj-seed-data';
import { gssData } from '../seed/berghahn/germanscreenstudies/gss-seed-data';
import { theoriaData } from '../seed/berghahn/theoria/theoria-seed-data';

export const ORG_ID_BNJ = '22J1EYBTYTPJ8JHZ7Z5ZYZDBNJ';
export const ORG_ID_AWP = '22J1EYBTYTPJ8JHZ7Z5ZYZDAZB';
export const ORG_ID_MORRESSIER = '01J1F13JQMXHC5N0YH4C9GWAS3';
export const ORG_ID_SCUP = '22J1EYBTYTPJ8JHZ7Z5ZYZDSCP';
export const ORG_ID_MAG = '22J1EYBTYTPJ8JHZ7Z5ZYZDMAG';
export const ORG_ID_BERGHAHN = '22J1EYBTYTPJ8JHZ7Z5ZYZDBGN';

export const AWP_WORKSPACE_ID = '01K2HJG35WHVSZCYE9YJH5KHZA';
export const MORRESSIER_WORKSPACE_ID = '01K2HJG35WHVSZCYE9YJH5KHZB';
export const MORRESSIER_WORKSPACE_ID_2 = '01K343W1AX2RG93M5E9B3C8N8W';
export const BNJ_WORKSPACE_ID = '02K2HJG35WHVSZCYE9YJH5KBNJ';
export const SCUP_WORKSPACE_ID = '02K2HJG35WHVSZCYE9YJH5KSCP';
export const MAG_WORKSPACE_ID = '02K2HJG35WHVSZCYE9YJH5KMAG';
export const BERGHAHN_WORKSPACE_ID = '02K2HJG35WHVSZCYE9YJH5KBGN';

export const SUB_CTX_ID_CLIMATE_POLICY = '01J1EYBTYJXJ8JHZ7Z5ZYZDAZB';
export const SUB_CTX_ID_EXTREME_WEATHER = '11J1EYBTYJXJ8JHZ7Z5ZYZDAZD';
export const SUB_CTX_ID_BIO_HAZARD = '01JNKEADCR73NYM6JZKDQKGEEZ';
export const SUB_CTX_ID_MORRESSIER_JOURNAL = '31J1EYBTYJXJ8JHZ7Z5ZYZBBBB';
export const SUB_CTX_ID_MORRESSIER_JRIP = '31J1EYBTYJXJ8JHZ7Z5ZYZBBBA';
export const SUB_CTX_ID_MORRESSIER_IRREI = '31J1EYBTYJXJ8JHZ7Z5ZYZBBBC';
export const SUB_CTX_ID_MORRESSIER_RISE = '31J1EYBTYJXJ8JHZ7Z5ZYZBBBD';
export const SUB_CTX_ID_BNJ_POLICY = '01J1EYBTYJXJ8JHZ7Z5ZYZAAA';
export const SUB_CTX_ID_SCUP_POLICY = '01J1EYBTYJXJ8JHZ7Z5ZYZAAB';
export const SUB_CTX_ID_MAG_POLICY = '01J1EYBTYJXJ8JHZ7Z5ZYZAAC';
export const SUB_CTX_ID_BERGHAHN_POLICY = '01J1EYBTYJXJ8JHZ7Z5ZYZAAD';

export const SIGNUP_FORM_SCHEMA_ID_BNJ = '01K38K9CCYDV01WJR6EATM6PGC';
export const SIGNUP_FORM_SCHEMA_ID_SCUP = '01K38K9CCYDV01WJR6EATM6PLC';
export const SIGNUP_FORM_SCHEMA_ID_MORRESSIER = '01K48K9CCYDV01WJR6EATM6PGC';
export const SIGNUP_FORM_SCHEMA_ID_MAG = '01K38K9CCYDV01WJR6EATM6PMA';
export const SIGNUP_FORM_SCHEMA_ID_BERGHAHN = '01K38K9CCYDV01WJR6EATM6BGN';

export const articleCategoryPaperAWP = '01JA0Y9D4CB75KEJBMVCJ39GWD';
export const articleCategoryLetterAWP = '0HJ1F23JQMXHC5N1YH4C9GWAW4';
export const articleCategoryTopicalReviewAWP = '01JNKDDKAB07YGKFYQD7TK7JDK';
export const articleCategoryTutorialAWP = '01JNKDDSHBZ455GPFC444X757G';
export const articleCategoryCommentAWP = '01JNKDDZK1YGF7KBRPBPDCSJX3';
export const articleCategoryNoteAWP = '01JA0Y9D4CB75KEJBMVCJ39GWC';
export const articleCategoryEditorialOtherAWP = '01JV89PFGMDSXM9TXXKNEF14YC';
export const articleCategoryPerspectiveAWP = '01JV89PPM597MC093Z1R79H1YP';
export const articleCategoryReplyAWP = '01JV89XB22N6N63K403D58FNDM';
export const articleCategoryAddendumAWP = '01JV89XB23PD98782J0RYWNPMH';
export const articleCategoryCorrigendumAWP = '01JV89XB23NBJ840H5PBVNXDP1';
export const articleCategoryErratumAWP = '01JV89XB23EEM2E9K7TFR6YQFQ';
export const articleCategoryRetractionAWP = '01JV89XB232EEE8RAAPBP9FP55';
export const articleCategoryRoadmapAWP = '01JWE135R1EY7Z7YRQN7E6T8EK';
export const articleCategoryExpressionofconcernAWP =
  '01JWE135R1EY7Z7YRQN7E7T7EK';

export const articleCategoryPaperMorressier = '01JA0YA0ED2C5BB4BVH7AQ00SK';
export const articleCategoryLetterMorressier = '01JA0YA0ED2C5BB4BVH7AQ00SC';

export const articleWorkflowPaperId = '01J7XT3HBJCJ69DW2F5Z5F2M75';
export const articleWorkflowJebsPaperId = '01JP8HD1DKJ789T2VTG18J1E79';
export const articleWorkflowLetterId = '01J7XT3WKPV4ZT5GMN8R7RPPH2';

export const articleWorkflowPaperMorressierId = '01J7XT3HBJCJ69DW2F5Z5F2M76';
export const articleWorkflowRisePaperMorressierId =
  '01J7XT3HBJCJ69DW2F5Z5F2M77';
export const articleWorkflowRiseLetterMorressierId =
  '01J7XT3HBJCJ69DW2F5Z5F2M7B';

export const articleWorkflowTopicalReviewId = '01JNKD4148H4EBQJPAYVG054PC';
export const articleWorkflowTutorialId = '01JNKD4QCJVYGWTHPWP8XEHMJH';
export const articleWorkflowCommentId = '01JNKD4X2BTPSSHZQREPQ2B3CN';
export const articleWorkflowRoadmapId = '01JWE1NSDG5VP44AD83R275ERT';

export const articleCategoryOriginalArticleBNJ = '02JA0Y9D4CB75KEJBMVCJ39GWD';
export const articleCategorySystematicReviewArticleBNJ =
  '02JA0Y9D4CB75KEJBMVCJ40GWD';
export const articleCategoryMetaAnalysisBNJ = '02JA0Y9D4CB75KEJBMVCJ41GWD';
export const articleCategoryEditorialBNJ = '02JA0Y9D4CB75KEJBMVCJ42GWD';
export const articleCategoryInstructionalReviewBNJ =
  '02JA0Y9D4CB75KEJBMVCJ43GWD';
export const articleCategoryRandomisedControlledTrialBNJ =
  '02JA0Y9D4CB75KEJBMVCJ44GWD';
export const articleCategoryAnnotationBNJ = '02JA0Y9D4CB75KEJBMVCJ45GWD';
export const articleCategoryOthersBNJ = '02JA0Y9D4CH55KEJBMVCJ45GWD';
export const articleCategoryProtocolBNJ = '02JA0Y9D6CH55KEJBMVCJ45GWD';
export const articleCategoryReviewArticleBNJ = '02JA0Y9D6CH75KEJBMVCJ45GWD';

export const articleCategoryArticleMORRESSIER = '03JA0Y9D4CB75KEJBMBCJ45GWD';
export const articleCategoryArticleSCUP = '03JA0Y9D4CB75KEJBMVCJ45GWD';
export const articleCategoryArticleForPeerReviewSCUP =
  '03JA0Y9D4CH55KEJBMVCJ45GWD';
export const articleCategoryProtocolForPeerReviewSCUP =
  '03JA0Y9D4CH55KEJBMVCJ46GWD';
export const articleCategoryBookReviewSCUP = '03JA0Y9D6CH55KEJBMVCJ45GWD';
export const articleCategoryEditorialSCUP = '03JA0Y9D6CH75KEJBMVCJ45GWD';
export const articleCategoryResearchCommentarySCUP =
  '03JA0Y9D6CH75KFJBMVCJ45GWD';
export const articleCategoryBaseArticleSCUP = '03JA0Y9D6CH85KFJBMVCJ45GWD';
export const articleCategoryFeatureArticleSCUP = '04JA0Y9D6CH85KFJBMVCJ45GWD';
export const articleCategoryEssaySCUP = '05JA0Y9D6CH85KFJBMVCJ45GWD';

export const articleCategoryOriginalArticleMOR = '02JA0Y9D4CB75KEJBMVCJ31GWD';
export const articleCategorySystematicReviewArticleMOR =
  '02JA0Y9D4CB75KEJBMVCJ10GWD';
export const articleCategoryMetaAnalysisMOR = '02JA0Y1D4CB75KEJBMVCJ41GWD';
export const articleCategoryEditorialMOR = '01JA0Y1D4CB75KEJBMVCJ41GWD';
export const articleCategoryOthersMOR = '02JA0Y9D4CH55KEJBMVCJ41GWD';
export const articleCategoryResearchArticleMOR = '02JA0Y9D4CH55KEJBMVCJ42GWD';
export const articleCategoryReviewArticleMOR = '02JA0Y9D4CH55KEJBMVCJ43GWD';
export const articleCategoryHypothesisMOR = '02JA0Y9D4CH55KEJBMVCJ44GWD';
export const articleCategoryMethodsAndProtocolsMOR =
  '02JA0Y9D4CH55KEJBMVCJ45GWD';
export const articleCategoryResearchReproducibilityReportMOR =
  '02JA0Y9D4CH55KEJBMVCJ46GWD';
export const articleCategoryPerspectiveMOR = '02JA0Y9D4CH55KEJBMVCJ47GWD';
export const articleCategoryResearchLetterMOR = '02JA0Y9D4CH55KEJBMVCJ48GWD';
export const articleCategoryBaseArticleMOR = '02JA0Y9D4CB75KEJBMVCJ21GWD';

//MAG
export const articleCategoryResearchMAG = '04JA0Y9D4CB75KEJBMVCJ45GWD';
export const articleCategoryLiteratureReviewMAG = '04JA0Y9D4CB75KEJBMVCJ46GWD';
export const articleCategoryServiceImprovementMAG =
  '04JA0Y9D4CB75KEJBMVCJ47GWD';
export const articleCategoryPracticeMAG = '04JA0Y9D4CB75KEJBMVCJ48GWD';
export const articleCategoryCommentMAG = '04JA0Y9D4CB75KEJBMVCJ49GWD';
export const articleCategoryFundamentalsMAG = '04JA0Y9D4CB75KEJBMVCJ50GWD';
export const articleCategoryBaseArticleMAG = '04JA0Y9D4CB75KEJBMVCJ51GWD';

//BERGHAHN
export const articleCategoryBaseArticleBERGHAHN = '05JA0Y9D4CB75KEJBMVCJ01GWD';
export const articleCategoryResearchArticleBERGHAHN =
  '05JA0Y9D4CB75KEJBMVCJ02GWD';
export const articleCategoryBookReviewBERGHAHN = '05JA0Y9D4CB75KEJBMVCJ03GWD';

export const BNJTEST_JOURNAL_ID = '01JV64RKX5M0SB4QFTC45HFB6T';
export const BJR_JOURNAL_ID = '01JV64RKX5M0SB4QFTC45HFB7T';
export const BJJ_JOURNAL_ID = '01JV64RKX5M0SB4QFTC45HFB8T';
export const BJO_JOURNAL_ID = '01JV64RKX5M0SB4QFTC45HFB9T';

export const BMM_JOURNAL_ID = '01JV64RKX5M0SB4QFTC45HFP5T';
export const CPGR_JOURNAL_ID = '01JV64RKX5M0SB4QFTC45HFP6T'; // "new" CPGR, following BMM data setup model.
export const BFB_JOURNAL_ID = '01JV64RKX5M0SB4QFTC45HFP7T';
export const BPEE_JOURNAL_ID = '01JV64RKX5M0SB4QFTC45HFP8T';
export const BIBM_JOURNAL_ID = '01JV64RKX5M0SB4QFTC45HFP9T';
export const PB_JOURNAL_ID = '01JV64RKX5M0SB4QFTC45HFP0A';
export const TEST_JOURNAL_ID = '01K1ZXN5MN3YFB4T48B6W6MQ9J';

//SCUP Journals
export const TFB_JOURNAL_ID = '01JV64RKX5M0SB4QFTC45HFQ1T';
export const NSF_JOURNAL_ID = '01JV64RKX5M0SB4QFTC45HFQ2T';
export const BSE_JOURNAL_ID = '01JV64RKX5M0SB4QFTC45HFQ3T';
export const NSF_QC_JOURNAL_ID = '01JV64RKX5M0SB4QFTC45HFQ4T';
export const TFB_QC_JOURNAL_ID = '01JV64RKX5M0SB4QFTC45HFQ5T';
export const NPT_JOURNAL_ID = '01JV64RKX5M0SB4QFTC45HFQ6T';
export const SAMTAL_JOURNAL_ID = '01JV64RKX5M0SB4QFTC45HFQ7T';

//Morressier Journals
export const JONE_JOURNAL_ID = '01JV64RKX5M0SB4QFTC45HFJ1T';
export const JTWO_JOURNAL_ID = '01JV64RKX5M0SB4QFTC45HFJ2T';
export const JTHREE_JOURNAL_ID = '01JV64RKX5M0SB4QFTC45HFJ3T';
export const BASE_JOURNAL_ID = '01JV64RKX5M0SB4QFTC45HFJ4T';

//MAH Journals(MAG Group)
export const BJMH_JOURNAL_ID = '01JV64RKX5M0SB4QFTC45HFQ1M';
export const PROJ_JOURNAL_ID = '01JV64RKX5M0SB4QFTC45HFR1M';
export const GSS_JOURNAL_ID = '01JV64RKX5M0SB4QFTC45HFR2M';
export const THEORIA_JOURNAL_ID = '01JV64RKX5M0SB4QFTC45HFR3M';

export const MAG_BASE_JOURNAL_ID = '01JV64RKX5M0SB4QFTC55HFQ1M';
export const BERGHAHN_BASE_JOURNAL_ID = '01JV64RKX5M0SB4QFTD55HFQ1M';

export type SeedDataStaticIds<
  SeedData extends IJournalConfigSeedData = IJournalConfigSeedData
> = {
  baseFormSchemas: Record<keyof SeedData['baseFormSchemas'], string>;
  articleWorkflows: {
    [AW in keyof SeedData['articleWorkflows']]: {
      id: string;
      formSchemas: {
        [FS in
          | keyof SeedData['articleWorkflows'][AW]['formSchemas']
          | keyof SeedData['derivedFormSchemas']]: string;
      };
      checklists: {
        initialAssessment: string;
        immediateRevision?: string;
        revision: string;
        revisionAssessment: string;
        preProduction: string;
      };
    };
  };
};

export const bmmStaticIds: SeedDataStaticIds<typeof bmmData> = {
  baseFormSchemas: {
    editorRevisionRequest: '01JXW2T7HW6HQCKXMJP7JXB8AH',
    editorialWithdrawSubmission: '01JXW2T7HW87T8BQBMA2ZFZP8D',
    editorialOfferTransfer: '01JXW2T7HXMNDKZWDERS9PC3KG',
    editorialRejectSubmission: '01JXW2T7HXPCE56WJENRBY13H4',
    authorWithdrawSubmission: '01JXW2T7HXJK7YC9QR76K895QC',
    editorialUnsubmit: '01JXW2T7HXCW0Y5C1E4Q03P787',
    reviewerFirstAssessment: '01JXW2T7J1KX3CVDX1YH3F0NM4',
    reviewerRevisionAssessment: '01JXW2T7J450QP8CXHN5KD8N8Y',
    editorialLicensing: '01JXW2T7J4G5X2B9FC248NZCRS',
    externalEarlyAssessment: '01JXW2T7J5MMQDTXCXJEZY01CT',
    expertAssessment: '01JXW2T7J5X7DE3YJ7CRJE7NWF',
    externalAdjudication: '01JXW2T7J5TAKHAV6V1C6HWTE2',
    adjudicationAssessment: '01JXW2T7J57H26HSGXZ7RFAZVN',
    authorCopyrightSubmission: '01JXW2T7J52W0NV7DWKMV9PE2R',
    editorialUploadCopyright: '01JXW2T7J6JB2SFQGQRE9B9TCB',
    inviteCoReviewer: '01JXW2T7J60TNCHDT3M9FPAXGS',
    authorSubmission: 'unused?',
    authorRevision: 'unused?'
  },
  articleWorkflows: {
    Paper: {
      id: '01JXW2T8036P9JP1VF8P6DSW4S',
      formSchemas: {
        authorSubmission: '01JXW2T7JBZC3BTTWFZ8KR1RVP',
        authorRevision: '01JXW2T7JE13TY91Z6KH5NGKC9',
        authorChangeRequest: '01JXW2T7JGE4GKH5ZY8R1EGSKV',
        reviewerFirstAssessment: '01JXW2T7JBNG3HGH7SGH71KVWB'
      },
      checklists: {
        initialAssessment: '01JXW2T70JF3X880P1VRA1TND9',
        revision: '01JXW2T70JXBGNTEBNPF9PPXJP',
        revisionAssessment: '01JXW2T70J3MJ2Z3700HW1456D',
        preProduction: '01JXW2T70JSZAHG0YPVP7PMRJV'
      }
    },
    Note: {
      id: '01JXW2T8CCZ081D82KB61C8NMC',
      formSchemas: {
        authorSubmission: '01JXW2T82TQKS3JJFSRCNRH2GN',
        authorRevision: '01JXW2T82XR0DT9SVVGFXDMY6W',
        authorChangeRequest: '01JXW2T82ZB48KEKRVEER30060',
        reviewerFirstAssessment: '01JXW2T82VHKH1854FTER1ZVXM'
      },
      checklists: {
        initialAssessment: '01JXW2T70JYN2ADZBCV4DG82TJ',
        revision: '01JXW2T70JR360FJ2N7QTSQ1CP',
        revisionAssessment: '01JXW2T70JN32TX8ZYTR7HAXD8',
        preProduction: '01JXW2T70KKSCGEQEYRTJS1F8W'
      }
    },
    'Topical Review': {
      id: '01JXW2T93TH9EZJM8XPPTZAR6X',
      formSchemas: {
        authorSubmission: '01JXW2T8FHNXP276ZM52C9JRRT',
        authorRevision: '01JXW2T8FKP9KK8N8JFC8VBWFA',
        authorChangeRequest: '01JXW2T8FMY8F8TGN7TJCQS2EK'
      },
      checklists: {
        initialAssessment: '01JXW2T70KFF2VVCH9P5TWDHGA',
        revision: '01JXW2T70KPKXM69T19QVT15C8',
        revisionAssessment: '01JXW2T70K50173Z38GJR6MF8B',
        preProduction: '01JXW2T70K46FYQNZD4595AW6T'
      }
    },
    Comment: {
      id: '01JXW2T9VN8DCDS979NPDV74ZZ',
      formSchemas: {
        authorSubmission: '01JXW2T95X40DEQ0GM1HZH62QG',
        authorRevision: '01JXW2T95ZXC5C6YRGV9J67SDD',
        authorChangeRequest: '01JXW2T9619W8XBMZWXF47HK1E'
      },
      checklists: {
        initialAssessment: '01JXW2T70K9VAAWEBA2TYPPHZM',
        revision: '01JXW2T70KX1Y0ENH6TS9ZSKVY',
        revisionAssessment: '01JXW2T70KGE49PM5FFAV9GJWG',
        preProduction: '01JXW2T70K31A23G1BGK0CVC2G'
      }
    },
    'Editorial/Other': {
      id: '01JXW2TA60YVP7R4Q4KD6T7TK6',
      formSchemas: {
        authorSubmission: '01JXW2T9YHA06A4HSD4B2833Z9',
        authorRevision: '01JXW2T9YK81V1M411EAE1RQXD',
        authorChangeRequest: '01JXW2T9YMWV6099ED9HK5JWMV'
      },
      checklists: {
        initialAssessment: '01JXW2T70KQE3Y0D64BXXQAG8B',
        revision: '01JXW2T70MC1SEKVPVVESPY3GG',
        revisionAssessment: '01JXW2T70M4AQVF6WTG8WY40PZ',
        preProduction: '01JXW2T70M47RW9MFQ3S4HP9N8'
      }
    },
    Reply: {
      id: '01JXW2TAVXFT5WB20CAH4215PE',
      formSchemas: {
        authorSubmission: '01JXW2TAKNM7VRPV5N2P62W06N',
        authorRevision: '01JXW2TAKP0S5DHHXVQE5J8F0Y',
        authorChangeRequest: '01JXW2TAKQS4JYBJJ8WAHZ3Q9Q'
      },
      checklists: {
        initialAssessment: '01JXW2T70MS4K0NCQCB4E5KV1C',
        revision: '01JXW2T70MB5EWET3RRY9M6GC5',
        revisionAssessment: '01JXW2T70MY0A9EZTDAYE3SGVM',
        preProduction: '01JXW2T70MS02PK9F15GWB5CWG'
      }
    },
    Addendum: {
      id: '01JXW2TB7MHE0XK8PKPK4J594A',
      formSchemas: {
        authorSubmission: '01JXW2TAZ2SSPFJQ1MWCSN6SDE',
        authorRevision: '01JXW2TAZ3P1N1SFMAQ8DNC9B0',
        authorChangeRequest: '01JXW2TAZ43K1ADETQYZNBHFDY'
      },
      checklists: {
        initialAssessment: '01JXW2T70NG730XSNY345DGC6N',
        revision: '01JXW2T70N94EQK7GVHC4A1A8S',
        revisionAssessment: '01JXW2T70NZJ06FHV9Q508ABD7',
        preProduction: '01JXW2T70NVT5882JZPE9V65SP'
      }
    },
    Corrigendum: {
      id: '01JXW2TBZDM2M6GCW7N1SHYRV1',
      formSchemas: {
        authorSubmission: '01JXW2TBARMF1D6EBAECW26WZ7',
        authorRevision: '01JXW2TBASKD866BN32XJM3CSS',
        authorChangeRequest: '01JXW2TBAS7J1NA3J4Y91QX63K'
      },
      checklists: {
        initialAssessment: '01JXW2T70N5T3APY54TJH9W8A4',
        revision: '01JXW2T70N6FVZPXAWFY5KP95P',
        revisionAssessment: '01JXW2T70N5CJRW6K6V2B37Z46',
        preProduction: '01JXW2T70NNMJANDVPGYPPYSAS'
      }
    },
    Erratum: {
      id: '01JXW2TCS07WJ6WKRM94K5710E',
      formSchemas: {
        authorSubmission: '01JXW2TC1MDDJV8G4F70920RDB',
        authorRevision: '01JXW2TC1NKCA42VYNYRKR21MX',
        authorChangeRequest: '01JXW2TC1P0RH3CFCY8CVXRKKB'
      },
      checklists: {
        initialAssessment: '01JXW2T70PXPKBDDX537FF3P98',
        revision: '01JXW2T70PP3P183HMFY03MG3E',
        revisionAssessment: '01JXW2T70P8E1T1DNESS2CK36J',
        preProduction: '01JXW2T70PNRMKY9HGP9MWM3CQ'
      }
    },
    Retraction: {
      id: '01JXW2TD1NXEWV89ENNEYZDZQQ',
      formSchemas: {
        authorSubmission: '01JXW2TCVJD45CBEK8QB0AGRXS',
        authorRevision: '01JXW2TCVK2E1YJ901SDT0TG5B',
        authorChangeRequest: '01JXW2TCVNRHR7F8XE4T824JEJ'
      },
      checklists: {
        initialAssessment: '01JXW2T70NSMV9B7SBATZQAMHP',
        revision: '01JXW2T70NKDEJY69V04Y3WXXE',
        revisionAssessment: '01JXW2T70P3BJH1Z724YC7V6J2',
        preProduction: '01JXW2T70PJHFV81ZWCP3T04WC'
      }
    }
  }
};

export const cpgrStaticIds: SeedDataStaticIds<typeof cpgrData> = {
  baseFormSchemas: {
    editorRevisionRequest: '01JXW2TG9ZJND5CA36EVVQR10N',
    editorialWithdrawSubmission: '01JXW2TGA0PSTX94CPA0N5GB2D',
    editorialOfferTransfer: '01JXW2TGA04FCHGNSFY8491QSB',
    editorialRejectSubmission: '01JXW2TGA08DGNHFJKFWZJFXAY',
    authorWithdrawSubmission: '01JXW2TGA06P81E64E6SS8FY6Q',
    editorialUnsubmit: '01JXW2TGA0PH2A588XWEYK424K',
    reviewerFirstAssessment: '01JXW2TGA61P77YY50WVQW8BGN',
    reviewerRevisionAssessment: '01JXW2TGA7S9ZRYJTRC7V6PCDZ',
    editorialLicensing: '01JXW2TGA7Q13EDGGQDTEQMAEW',
    externalEarlyAssessment: '01JXW2TGA7DMSPDT69381Q8H2E',
    expertAssessment: '01JXW2TGA8NQJXQRH7XVRSTW9P',
    externalAdjudication: '01JXW2TGA85ZYKJYN2ES1X9VAX',
    adjudicationAssessment: '01JXW2TGA8JDQ5W19HGTK5QT5V',
    authorCopyrightSubmission: '01JXW2TGA9YXYN2DW2HAGHKKMC',
    editorialUploadCopyright: '01JXW2TGA9ZA30YRFMXBRRGS58',
    inviteCoReviewer: '01JXW2TGAADY8FXAJ3R7PZ4W8T',
    authorSubmission: 'unused?',
    authorRevision: 'unused?'
  },
  articleWorkflows: {
    Paper: {
      id: '01JXW2TGKQXNPNSXNAS625FV42',
      formSchemas: {
        authorSubmission: '01JXW2TGAF7631N96M7KMVYPSS',
        authorRevision: '01JXW2TGAJ9J5R1TRVW1DKY6DA',
        authorChangeRequest: '01JXW2TGAMTW0GJSQRVDDC4QFM',
        reviewerFirstAssessment: '01JXW2TGAF8EPFANFT0AJR6WWW'
      },
      checklists: {
        initialAssessment: '01JXW2T70QMN01M86PRS0M96T1',
        revision: '01JXW2T70QNKPXDS7T9NSGQGWA',
        revisionAssessment: '01JXW2T70QQ3CVKDXD313D6WBW',
        preProduction: '01JXW2T70QPMEC6CKV17AJ04QP'
      }
    },
    Note: {
      id: '01JXW2TGXMA4NRDF1AR78STPRF',
      formSchemas: {
        authorSubmission: '01JXW2TGPE8Q98MTYJPM400Z3Q',
        authorRevision: '01JXW2TGPH60ZQFK29DMWSEVH2',
        authorChangeRequest: '01JXW2TGPJS7562XWR3NZCYTA9',
        reviewerFirstAssessment: '01JXW2TGPFMKH9XNTWYHNEFGWJ'
      },
      checklists: {
        initialAssessment: '01JXW2T70QB2TSRHHN06Z4NRGV',
        revision: '01JXW2T70QG4CC0JAQASVP4XGY',
        revisionAssessment: '01JXW2T70QTGCZYBZ1J18HY761',
        preProduction: '01JXW2T70Q4R6NQFTFN4MYCE4R'
      }
    },
    'Topical Review': {
      id: '01JXW2THP72A5VFXKH6D88468C',
      formSchemas: {
        authorSubmission: '01JXW2TH0FXHHBBB01RBN3GDNE',
        authorRevision: '01JXW2TH0H0KDC5S6NDZ3M50DW',
        authorChangeRequest: '01JXW2TH0K8G2GBVMD7XHE6JQ4'
      },
      checklists: {
        initialAssessment: '01JXW2T70R2YAYFJNKGNBFY44Y',
        revision: '01JXW2T70RMCQAENDFDYXFQMMD',
        revisionAssessment: '01JXW2T70R7K6PVXHT4AKV8NST',
        preProduction: '01JXW2T70RN5NS674V78SV4P5S'
      }
    },
    Comment: {
      id: '01JXW2THZ8PA311NFAW7ADK7GK',
      formSchemas: {
        authorSubmission: '01JXW2THRHHCY5MKZ44C9WY2ZQ',
        authorRevision: '01JXW2THRKZ6AF061M0XYSZQQ1',
        authorChangeRequest: '01JXW2THRMB4TJ5Q9QY2PFE6V4'
      },
      checklists: {
        initialAssessment: '01JXW2T70RQVNGNP90XQQSDKZK',
        revision: '01JXW2T70R012V8X7J374VX5MQ',
        revisionAssessment: '01JXW2T70RSTA9SAFD4NNZG2K7',
        preProduction: '01JXW2T70RTV80AH1GE4ZMZCHH'
      }
    },
    'Editorial/Other': {
      id: '01JXW2TJQNNMKQJ3A64DAGZCHE',
      formSchemas: {
        authorSubmission: '01JXW2TJ1D041W9Q6F07F06WC2',
        authorRevision: '01JXW2TJ1FYW0R7C4AXZQRWQKH',
        authorChangeRequest: '01JXW2TJ1GAPWQAMRZYE0JRDZ1'
      },
      checklists: {
        initialAssessment: '01JXW2T70R99YQQFZJW0WQAW1D',
        revision: '01JXW2T70RKAHGXD3KASJ1ERTQ',
        revisionAssessment: '01JXW2T70RGC8Y0GNYM6AAABPM',
        preProduction: '01JXW2T70RCJMFTYRD6NRX5FNF'
      }
    },
    Reply: {
      id: '01JXW2TKQQMV4F46M20AVWNF3X',
      formSchemas: {
        authorSubmission: '01JXW2TK30X67P9AVAA3WR35X8',
        authorRevision: '01JXW2TK32J4WM5W3C84NGPV2J',
        authorChangeRequest: '01JXW2TK33322DHX99QJM95T0R'
      },
      checklists: {
        initialAssessment: '01JXW2T70SHHPJ861Z8QAN8ZBA',
        revision: '01JXW2T70SSVS88X77XTQP3F5Y',
        revisionAssessment: '01JXW2T70SFMJ8VER2APWHMR5Q',
        preProduction: '01JXW2T70STSHZKANPS9RV7GF6'
      }
    },
    Addendum: {
      id: '01JXW2TM13VJF4APYTQNHYR1QK',
      formSchemas: {
        authorSubmission: '01JXW2TKTPD2MGHH30F8Y0Z347',
        authorRevision: '01JXW2TKTRBJX3RKS44J9P2X86',
        authorChangeRequest: '01JXW2TKTS0NSE8QHANZHYA0Q6'
      },
      checklists: {
        initialAssessment: '01JXW2T70S5Y06PRMCQWCRMG3K',
        revision: '01JXW2T70S2TCKTNCX0C0FF0F4',
        revisionAssessment: '01JXW2T70SWW3X9RTH9FP0TZ75',
        preProduction: '01JXW2T70TWM52XP9HN06SZD4H'
      }
    },
    Corrigendum: {
      id: '01JXW2TMRSE3YF1Q43YRJMAJXN',
      formSchemas: {
        authorSubmission: '01JXW2TM3D9W0RBCC1QYZ3FFCB',
        authorRevision: '01JXW2TM3EG4MYRQ0MJZ8Z92JF',
        authorChangeRequest: '01JXW2TM3FZ5P9BY9EMYBK92J8'
      },
      checklists: {
        initialAssessment: '01JXW2T70TK178GF8MEEQ9Z10Y',
        revision: '01JXW2T70TXAAMFNZ1WE59MAZX',
        revisionAssessment: '01JXW2T70TT8JVCZFS6DP2KVHQ',
        preProduction: '01JXW2T70TCPW6JS5DHKEZCG1K'
      }
    },
    Erratum: {
      id: '01JXW2TNH84D7XJF0KXJTKFXAP',
      formSchemas: {
        authorSubmission: '01JXW2TMWDN9A1NDDMVSTJQ5JR',
        authorRevision: '01JXW2TMWESBP6QB0E2K64PWV7',
        authorChangeRequest: '01JXW2TMWF8MJY8G64MH651W21'
      },
      checklists: {
        initialAssessment: '01JXW2T70TSZ2VS7FHGZYFBGCF',
        revision: '01JXW2T70T5A9TMPK5JQMAH7A9',
        revisionAssessment: '01JXW2T70T4JZVBW8XGPY27QAC',
        preProduction: '01JXW2T70T6ZZM4PE3K3FNEVCC'
      }
    },
    Retraction: {
      id: '01JXW2TNT9ZWW51DXRDPS2YN9P',
      formSchemas: {
        authorSubmission: '01JXW2TNKN56XGP2808G2F9D8E',
        authorRevision: '01JXW2TNKQ5ZG27A94FY41WVPF',
        authorChangeRequest: '01JXW2TNKR98Q1VHS13XS9DA6K'
      },
      checklists: {
        initialAssessment: '01JXW2T70T26CJ0NESFH6DMEV8',
        revision: '01JXW2T70TPMDRP25XNG4JBATQ',
        revisionAssessment: '01JXW2T70TTKGCK2STEXYW1ZTK',
        preProduction: '01JXW2T70TJW3HXGC9BEF17TX5'
      }
    },
    Perspective: {
      id: '01JXW2TK0G4JDBK10DQ8F799MR',
      formSchemas: {
        authorSubmission: '01JXW2TJSNHVHCQHMNP8SKDYJY',
        authorRevision: '01JXW2TJSR3MGKCTMAR87G8DXE',
        authorChangeRequest: '01JXW2TJSSPQFJS7B7HYZH9VBD'
      },
      checklists: {
        initialAssessment: '01JXW2T70R39A11AXMGACGN1MR',
        revision: '01JXW2T70STVV3PYDSC0TZ4MGZ',
        revisionAssessment: '01JXW2T70SNG70DV25S9AN0MZN',
        preProduction: '01JXW2T70SE1T74BJWESCTX0FB'
      }
    }
  }
};

export const bfbStaticIds: SeedDataStaticIds<typeof bfbData> = {
  baseFormSchemas: {
    editorRevisionRequest: '01JXW2TPBW6HQCKXMJP7JXBFBH',
    editorialWithdrawSubmission: '01JXW2TPBW87T8BQBMA2ZFZFBD',
    editorialOfferTransfer: '01JXW2TPBXMNDKZWDERS9PCFBG',
    editorialRejectSubmission: '01JXW2TPBXPCE56WJENRBY1FB4',
    authorWithdrawSubmission: '01JXW2TPBXJK7YC9QR76K89FBC',
    editorialUnsubmit: '01JXW2TPBXCW0Y5C1E4Q03PFB7',
    reviewerFirstAssessment: '01JXW2TPB1KX3CVDX1YH3F0FB4',
    reviewerRevisionAssessment: '01JXW2TPB450QP8CXHN5KD8FBY',
    editorialLicensing: '01JXW2TPB4G5X2B9FC248NZFBS',
    externalEarlyAssessment: '01JXW2TPB5MMQDTXCXJEZY0FBT',
    expertAssessment: '01JXW2TPB5X7DE3YJ7CRJE7FBF',
    externalAdjudication: '01JXW2TPB5TAKHAV6V1C6HWFB2',
    adjudicationAssessment: '01JXW2TPB57H26HSGXZ7RFAFBN',
    authorCopyrightSubmission: '01JXW2TPB52W0NV7DWKMV9PFB2',
    editorialUploadCopyright: '01JXW2TPB6JB2SFQGQRE9B9FBB',
    inviteCoReviewer: '01JXW2TPB60TNCHDT3M9FPAFBS',
    authorSubmission: 'unused?',
    authorRevision: 'unused?'
  },
  articleWorkflows: {
    Paper: {
      id: '01JXW2TP036P9JP1VF8P6DSWFB',
      formSchemas: {
        authorSubmission: '01JXW2TPBBZC3BTTWFZ8KR1FBP',
        authorRevision: '01JXW2TPBE13TY91Z6KH5NGFB9',
        authorChangeRequest: '01JXW2TPBGE4GKH5ZY8R1EGFBV',
        reviewerFirstAssessment: '01JXW2TPBBNG3HGH7SGH71KFBB'
      },
      checklists: {
        initialAssessment: '01JXW2TP0JF3X880P1VRA1TFBD',
        revision: '01JXW2TP0JXBGNTEBNPF9PPFBP',
        revisionAssessment: '01JXW2TP0J3MJ2Z3700HW14FBD',
        preProduction: '01JXW2TP0JSZAHG0YPVP7PMFBV'
      }
    },
    Note: {
      id: '01JXW2TPCCZ081D82KB61C7FBC',
      formSchemas: {
        authorSubmission: '01JXW2TP2TQKS3JJFSRCNRHFBN',
        authorRevision: '01JXW2TP2XR0DT9SVVGFXDMFBW',
        authorChangeRequest: '01JXW2TP2ZB48KEKRVEER30FB0',
        reviewerFirstAssessment: '01JXW2TP2VHKH1854FTER1ZFBM'
      },
      checklists: {
        initialAssessment: '01JXW2TP0JYN2ADZBCV4DG8FBJ',
        revision: '01JXW2TP0JR360FJ2N7QTSQFBP',
        revisionAssessment: '01JXW2TP0JN32TX8ZYTR7HAFB8',
        preProduction: '01JXW2TP0KKSCGEQEYRTJS1FBW'
      }
    },
    'Topical Review': {
      id: '01JXW2TP3TH9EZJM8XPPTZAFBX',
      formSchemas: {
        authorSubmission: '01JXW2TPFHNXP276ZM52C9JFBT',
        authorRevision: '01JXW2TPFKP9KK8N8JFC8VBFBA',
        authorChangeRequest: '01JXW2TPFMY8F8TGN7TJCQSFBK'
      },
      checklists: {
        initialAssessment: '01JXW2TP0KFF2VVCH9P5TWDFBA',
        revision: '01JXW2TP0KPKXM69T19QVT1FB8',
        revisionAssessment: '01JXW2TP0K50173Z38GJR6MFBB',
        preProduction: '01JXW2TP0K46FYQNZD4595AFBT'
      }
    },
    Comment: {
      id: '01JXW2TPVN8DCDS979NPDV7FBZ',
      formSchemas: {
        authorSubmission: '01JXW2TP5X40DEQ0GM1HZH6FBG',
        authorRevision: '01JXW2TP5ZXC5C6YRGV9J67FBD',
        authorChangeRequest: '01JXW2TP619W8XBMZWXF47HFBE'
      },
      checklists: {
        initialAssessment: '01JXW2TP0K9VAAWEBA2TYPPFBM',
        revision: '01JXW2TP0KX1Y0ENH6TS9ZSFBY',
        revisionAssessment: '01JXW2TP0KGE49PM5FFAV9GFBG',
        preProduction: '01JXW2TP0K31A23G1BGK0CVFBG'
      }
    },
    'Editorial/Other': {
      id: '01JXW2TPA0YVP7R4Q4KD6T7FB7',
      formSchemas: {
        authorSubmission: '01JXW2TPYHA06A4HSD4B283FB9',
        authorRevision: '01JXW2TPYK81V1M411EAE1RFBD',
        authorChangeRequest: '01JXW2TPYMWV6099ED9HK5JFBV'
      },
      checklists: {
        initialAssessment: '01JXW2TP0KQE3Y0D64BXXQAFBB',
        revision: '01JXW2TP0MC1SEKVPVVESPYFBG',
        revisionAssessment: '01JXW2TP0M4AQVF6WTG8WY4FBZ',
        preProduction: '01JXW2TP0M47RW9MFQ3S4HPFB8'
      }
    },
    Perspective: {
      id: '01JXW2TPAXFT5WB20CAH421FBE',
      formSchemas: {
        authorSubmission: '01JXW2TPANM7VRPV5N2P62WFB6',
        authorRevision: '01JXW2TPAP0S5DHHXVQE5J8FBY',
        authorChangeRequest: '01JXW2TPAQS4JYBJJ8WAHZ3FBQ'
      },
      checklists: {
        initialAssessment: '01JXW2TP0MS4K0NCQCB4E5KFB1',
        revision: '01JXW2TP0MB5EWET3RRY9M6FB5',
        revisionAssessment: '01JXW2TP0MY0A9EZTDAYE3SFBM',
        preProduction: '01JXW2TP0MS02PK9F15GWB5FBG'
      }
    },
    Reply: {
      id: '01JXW2TPBXFT5WB20CAH421FBR',
      formSchemas: {
        authorSubmission: '01JXW2TPBNM7VRPV5N2P62WFB7',
        authorRevision: '01JXW2TPBP0S5DHHXVQE5J8FBZ',
        authorChangeRequest: '01JXW2TPBQS4JYBJJ8WAHZ3FBR'
      },
      checklists: {
        initialAssessment: '01JXW2TP1MS4K0NCQCB4E5KFB2',
        revision: '01JXW2TP1MB5EWET3RRY9M6FB6',
        revisionAssessment: '01JXW2TP1MY0A9EZTDAYE3SFBN',
        preProduction: '01JXW2TP1MS02PK9F15GWB5FBH'
      }
    },
    Addendum: {
      id: '01JXW2TPB7MHE0XK8PKPK4J5FB',
      formSchemas: {
        authorSubmission: '01JXW2TPZ2SSPFJQ1MWCSN6FBE',
        authorRevision: '01JXW2TPZ3P1N1SFMAQ8DNCFB0',
        authorChangeRequest: '01JXW2TPZ43K1ADETQYZNBHFBY'
      },
      checklists: {
        initialAssessment: '01JXW2TP0NG730XSNY345DGFBN',
        revision: '01JXW2TP0N94EQK7GVHC4A1FBS',
        revisionAssessment: '01JXW2TP0NZJ06FHV9Q508AFBD',
        preProduction: '01JXW2TP0NVT5882JZPE9V6FBP'
      }
    },
    Corrigendum: {
      id: '01JXW2TPZDM2M6GCW7N1SHYFB7',
      formSchemas: {
        authorSubmission: '01JXW2TPARMF1D6EBAECW26FB7',
        authorRevision: '01JXW2TPASKD866BN32XJM3FBS',
        authorChangeRequest: '01JXW2TPAS7J1NA3J4Y91QXFBK'
      },
      checklists: {
        initialAssessment: '01JXW2TP0N5T3APY54TJH9WFB4',
        revision: '01JXW2TP0N6FVZPXAWFY5KPFBP',
        revisionAssessment: '01JXW2TP0N5CJRW6K6V2B37FB6',
        preProduction: '01JXW2TP0NNMJANDVPGYPPYFBS'
      }
    },
    Erratum: {
      id: '01JXW2TPS07WJ6WKRM94K57FBE',
      formSchemas: {
        authorSubmission: '01JXW2TP1MDDJV8G4F70920FBB',
        authorRevision: '01JXW2TP1NKCA42VYNYRKR2FBX',
        authorChangeRequest: '01JXW2TP1P0RH3CFCY8CVXRFBB'
      },
      checklists: {
        initialAssessment: '01JXW2TP0PXPKBDDX537FF3FB8',
        revision: '01JXW2TP0PP3P183HMFY03MFB3',
        revisionAssessment: '01JXW2TP0P8E1T1DNESS2CKFBJ',
        preProduction: '01JXW2TP0PNRMKY9HGP9MWMFBQ'
      }
    },
    Retraction: {
      id: '01JXW2TP1NXEWV89ENNEYZDZBQ',
      formSchemas: {
        authorSubmission: '01JXW2TPVJD45CBEK8QB0AGFBS',
        authorRevision: '01JXW2TPVK2E1YJ901SDT0TFB5',
        authorChangeRequest: '01JXW2TPVNRHR7F8XE4T824FBJ'
      },
      checklists: {
        initialAssessment: '01JXW2TP0NSMV9B7SBATZQAFBP',
        revision: '01JXW2TP0NKDEJY69V04Y3WFBE',
        revisionAssessment: '01JXW2TP0P3BJH1Z724YC7VFB2',
        preProduction: '01JXW2TP0PJHFV81ZWCP3T0FBC'
      }
    },
    'Expression of Concern': {
      id: '01JXW2TP2NXEWV89ENNEYZDFBQ',
      formSchemas: {
        authorSubmission: '01JXW2TPWJD45CBEK8QB0AGFBT',
        authorRevision: '01JXW2TPWK2E1YJ901SDT0TFB6',
        authorChangeRequest: '01JXW2TPWNRHR7F8XE4T824FBK'
      },
      checklists: {
        initialAssessment: '01JXW2TP1NSMV9B7SBATZQAFBQ',
        revision: '01JXW2TP1NKDEJY69V04Y3WFBF',
        revisionAssessment: '01JXW2TP1P3BJH1Z724YC7VFB3',
        preProduction: '01JXW2TP1PJHFV81ZWCP3T0FBD'
      }
    }
  }
};

export const testStaticIds: SeedDataStaticIds<typeof testData> = {
  baseFormSchemas: {
    editorRevisionRequest: '01K1ZXN5MFZ484HKR25DTRG22F',
    editorialWithdrawSubmission: '01K1ZXN5MGERYJ48CJM5VNNVK8',
    editorialOfferTransfer: '01K1ZXN5MG2GY8EG0636XHQ3MJ',
    editorialRejectSubmission: '01K1ZXN5MHBP771H31YP2WSF4K',
    authorWithdrawSubmission: '01K1ZXN5MHVM4X2WCXPX4ZBBX2',
    editorialUnsubmit: '01K1ZXN5MH6CTT51XNK6QVDN7R',
    reviewerFirstAssessment: '01K1ZXN5MHVKVES4P7EH2ZQF30',
    reviewerRevisionAssessment: '01K1ZXN5MH7RF73E1RGXT5Q1XN',
    editorialLicensing: '01K1ZXN5MHN82SDY2ZENDH12ND',
    externalEarlyAssessment: '01K1ZXN5MH1GFF410YDNM4WETV',
    expertAssessment: '01K1ZXN5MHAZ6AB00GJSDD7TH7',
    externalAdjudication: '01K1ZXN5MHFDKDZCABDTSAMSF9',
    adjudicationAssessment: '01K1ZXN5MHYF9M2WCR877K1FN5',
    authorCopyrightSubmission: '01K1ZXN5MJZFMV5H5RF9ANTBB4',
    editorialUploadCopyright: '01K1ZXN5MJJREP1DY4P62WG2HT',
    inviteCoReviewer: '01K1ZXN5MJJBN1C3BBZT93YEAJ',
    authorSubmission: 'unused?',
    authorRevision: 'unused?'
  },
  articleWorkflows: {
    Paper: {
      id: '01K1ZXN5MJPAWS24FWR8CYCDR9',
      formSchemas: {
        authorSubmission: '01K1ZXN5MJDJMZMJ1RFENMX2PQ',
        authorRevision: '01K1ZXN5MJ27P15GTJX2F3VZRW',
        authorChangeRequest: '01K1ZXN5MJMB6AN23NSND65DE4',
        reviewerFirstAssessment: '01K1ZXN5MJT20RVQG79P837EDR'
      },
      checklists: {
        initialAssessment: '01K1ZXN5MJSVP6CVZQPD622HTE',
        revision: '01K1ZXN5MJJTQWH29YBV2HBBYE',
        revisionAssessment: '01K1ZXN5MJP5XZD86RT9A87T37',
        preProduction: '01K1ZXN5MJKKWJ2HP0A2RWYX5J'
      }
    },
    Note: {
      id: '01K1ZXN5MJZYTMS7RWMN2CX0ZZ',
      formSchemas: {
        authorSubmission: '01K1ZXN5MJ00VER63A97HENSH8',
        authorRevision: '01K1ZXN5MJQMP5EC0YNXW0Y13N',
        authorChangeRequest: '01K1ZXN5MJSM2TBPRZYGE8HM4X',
        reviewerFirstAssessment: '01K1ZXN5MKHPMG32C5W8B6GEA0'
      },
      checklists: {
        initialAssessment: '01K1ZXN5MKANPXGGAZC9AMY41D',
        revision: '01K1ZXN5MKFQ0TE0V5E0S9JSMS',
        revisionAssessment: '01K1ZXN5MKW060XMQCFJFG65J3',
        preProduction: '01K1ZXN5MK0NCYKGFJ8TN6G872'
      }
    },
    'Topical Review': {
      id: '01K1ZXN5MKDF476GR8ETBHB676',
      formSchemas: {
        authorSubmission: '01K1ZXN5MK5N092TR6TQPKPV8R',
        authorRevision: '01K1ZXN5MKQ3HY6WCJXWQMECP2',
        authorChangeRequest: '01K1ZXN5MKFP33F289ADNHH1HS'
      },
      checklists: {
        initialAssessment: '01K1ZXN5MK52GN1H7MTBG0XDSQ',
        revision: '01K1ZXN5MKWJZ7PCZ340H3DHR2',
        revisionAssessment: '01K1ZXN5MKHGMM3KC42T07TDW1',
        preProduction: '01K1ZXN5MKG91Z2MSVVNS8ND4N'
      }
    },
    Comment: {
      id: '01K1ZXN5MKSYFHNGPDK1Q3392F',
      formSchemas: {
        authorSubmission: '01K1ZXN5MK07K9SP61F9D9Y3R2',
        authorRevision: '01K1ZXN5MMFETHQA640F1NFD7Z',
        authorChangeRequest: '01K1ZXN5MMRH9FYCZHR9S85C3G'
      },
      checklists: {
        initialAssessment: '01K1ZXN5MM5K54R5QGJAZ2DJYG',
        revision: '01K1ZXN5MMSV77JEEFG3RY54DV',
        revisionAssessment: '01K1ZXN5MMRET1GPP92SGZTH4M',
        preProduction: '01K1ZXN5MM7PQD011PQ8NVP2ZJ'
      }
    },
    'Editorial/Other': {
      id: '01K1ZXN5MM9DJ6HWDKQN10MH1K',
      formSchemas: {
        authorSubmission: '01K1ZXN5MMGTDAFCHYS1F8R60W',
        authorRevision: '01K1ZXN5MM8FMBRRBZ0R4Y9C2X',
        authorChangeRequest: '01K1ZXN5MMGZS08A0MXED30WGM'
      },
      checklists: {
        initialAssessment: '01K1ZXN5MMS7S2QDR0Y4CP13S7',
        revision: '01K1ZXN5MMGJ1ZE0Y5Q2BZ0KCK',
        revisionAssessment: '01K1ZXN5MME78CZJCJE4QEWHGN',
        preProduction: '01K1ZXN5MMBYFK8495ZCA0ARTH'
      }
    },
    Reply: {
      id: '01K1ZXN5MM0MBQDK4SDZGFMFR9',
      formSchemas: {
        authorSubmission: '01K1ZXN5MM3DE6AH6K7B05C2AG',
        authorRevision: '01K1ZXN5MMPKNEAKK0NE8PKWEE',
        authorChangeRequest: '01K1ZXN5MMG7FK4MEZX3R83918'
      },
      checklists: {
        initialAssessment: '01K1ZXN5MMRD11VJYYSNA69DZ0',
        revision: '01K1ZXN5MMFATV04YHSQDQVCWV',
        revisionAssessment: '01K1ZXN5MMZ2ETN6BW4MJNVH64',
        preProduction: '01K1ZXN5MM2BD63QNQBNDQERDX'
      }
    },
    Addendum: {
      id: '01K1ZXN5MMNB1T6YH0X8WD8C1J',
      formSchemas: {
        authorSubmission: '01K1ZXN5MMEDSQNG7HPA6E9BRF',
        authorRevision: '01K1ZXN5MMSSAJMHCZ4JF3086V',
        authorChangeRequest: '01K1ZXN5MMRBP6S89GWGY2KWM9'
      },
      checklists: {
        initialAssessment: '01K1ZXN5MM75PTGS5GYQQKYCDP',
        revision: '01K1ZXN5MMJ44HECNSK31JN9ST',
        revisionAssessment: '01K1ZXN5MNZV8JYBCACQ58XK3G',
        preProduction: '01K1ZXN5MN08A2N85YN41B1A8Q'
      }
    },
    Corrigendum: {
      id: '01K1ZXN5MNYQPJ36MSNJY5NAV3',
      formSchemas: {
        authorSubmission: '01K1ZXN5MNPZME5N70A2R6X4WB',
        authorRevision: '01K1ZXN5MN375NSJ8QSY5F58KB',
        authorChangeRequest: '01K1ZXN5MN18BKB7CTTP1XYYG0'
      },
      checklists: {
        initialAssessment: '01K1ZXN5MN4RJKD5Y7SW94E162',
        revision: '01K1ZXN5MNEA4N50Z5SGFPDVGM',
        revisionAssessment: '01K1ZXN5MN2PS5523THPGQFHXW',
        preProduction: '01K1ZXN5MN5NV2DWZBYQSP9CB3'
      }
    },
    Erratum: {
      id: '01K1ZXN5MNAG6AVC6NTF6TRS79',
      formSchemas: {
        authorSubmission: '01K1ZXN5MN7V3V3EYFS0QMTHW3',
        authorRevision: '01K1ZXN5MN0JAE7G4Z501QS24T',
        authorChangeRequest: '01K1ZXN5MN0YJ4H6PAMQN277DG'
      },
      checklists: {
        initialAssessment: '01K1ZXN5MNH2CW3Q4ZQMXK038T',
        revision: '01K1ZXN5MNPESMQF8SJ1HZG4EA',
        revisionAssessment: '01K1ZXN5MNCF17QGXKWPZ93N75',
        preProduction: '01K1ZXN5MNN6M9DRGRD0SFTG4A'
      }
    },
    Retraction: {
      id: '01K1ZXN5MNMB11ZFW7Q2TANBMP',
      formSchemas: {
        authorSubmission: '01K1ZXN5MNPAKQFSS986NMAT3Q',
        authorRevision: '01K1ZXN5MNGFVV54R8Z62PZHBB',
        authorChangeRequest: '01K1ZXN5MNRM8STG2QRFTFZZVV'
      },
      checklists: {
        initialAssessment: '01K1ZXN5MNEPV0H6XC7FB4C0RS',
        revision: '01K1ZXN5MN5ZTYP3MX4BV9HMPF',
        revisionAssessment: '01K1ZXN5MNP8QXND253412WNG3',
        preProduction: '01K1ZXN5MN062GQAY3TGVJK9QY'
      }
    }
  }
};

export const bpeeStaticIds: SeedDataStaticIds<typeof bpeeData> = {
  baseFormSchemas: {
    editorRevisionRequest: '01JXW2TQBW6HQCKXMJP7JXBEAH',
    editorialWithdrawSubmission: '01JXW2TQBW87T8BQBMA2ZFZEAD',
    editorialOfferTransfer: '01JXW2TQBXMNDKZWDERS9PCEAG',
    editorialRejectSubmission: '01JXW2TQBXPCE56WJENRBY1EA4',
    authorWithdrawSubmission: '01JXW2TQBXJK7YC9QR76K89EAC',
    editorialUnsubmit: '01JXW2TQBXCW0Y5C1E4Q03PEA7',
    reviewerFirstAssessment: '01JXW2TQB1KX3CVDX1YH3F0EA4',
    reviewerRevisionAssessment: '01JXW2TQB450QP8CXHN5KD8EAY',
    editorialLicensing: '01JXW2TQB4G5X2B9FC248NZEAS',
    externalEarlyAssessment: '01JXW2TQB5MMQDTXCXJEZY0EAT',
    expertAssessment: '01JXW2TQB5X7DE3YJ7CRJE7EAF',
    externalAdjudication: '01JXW2TQB5TAKHAV6V1C6HWEA2',
    adjudicationAssessment: '01JXW2TQB57H26HSGXZ7RFAEAN',
    authorCopyrightSubmission: '01JXW2TQB52W0NV7DWKMV9PEA2',
    editorialUploadCopyright: '01JXW2TQB6JB2SFQGQRE9B9EAB',
    inviteCoReviewer: '01JXW2TQB60TNCHDT3M9FPAEAS',
    authorSubmission: 'unused?',
    authorRevision: 'unused?'
  },
  articleWorkflows: {
    Paper: {
      id: '01JXW2TQ036P9JP1VF8P6DSWEA',
      formSchemas: {
        authorSubmission: '01JXW2TQBBZC3BTTWFZ8KR1EAP',
        authorRevision: '01JXW2TQBE13TY91Z6KH5NGEA9',
        authorChangeRequest: '01JXW2TQBGE4GKH5ZY8R1EGEAV',
        reviewerFirstAssessment: '01JXW2TQBBNG3HGH7SGH71KEAB'
      },
      checklists: {
        initialAssessment: '01JXW2TQ0JF3X880P1VRA1TEAD',
        revision: '01JXW2TQ0JXBGNTEBNPF9PPEAP',
        revisionAssessment: '01JXW2TQ0J3MJ2Z3700HW14EAD',
        preProduction: '01JXW2TQ0JSZAHG0YPVP7PMEAV'
      }
    },
    Note: {
      id: '01JXW2TQCCZ081D82KB61C7EAC',
      formSchemas: {
        authorSubmission: '01JXW2TQ2TQKS3JJFSRCNRHEAN',
        authorRevision: '01JXW2TQ2XR0DT9SVVGFXDMEAW',
        authorChangeRequest: '01JXW2TQ2ZB48KEKRVEER30EA0',
        reviewerFirstAssessment: '01JXW2TQ2VHKH1854FTER1ZEAM'
      },
      checklists: {
        initialAssessment: '01JXW2TQ0JYN2ADZBCV4DG8EAJ',
        revision: '01JXW2TQ0JR360FJ2N7QTSQEAP',
        revisionAssessment: '01JXW2TQ0JN32TX8ZYTR7HAEA8',
        preProduction: '01JXW2TQ0KKSCGEQEYRTJS1EAW'
      }
    },
    'Topical Review': {
      id: '01JXW2TQ3TH9EZJM8XPPTZAEAX',
      formSchemas: {
        authorSubmission: '01JXW2TQFHNXP276ZM52C9JEAT',
        authorRevision: '01JXW2TQFKP9KK8N8JFC8VBEAA',
        authorChangeRequest: '01JXW2TQFMY8F8TGN7TJCQSEAK'
      },
      checklists: {
        initialAssessment: '01JXW2TQ0KFF2VVCH9P5TWDEAA',
        revision: '01JXW2TQ0KPKXM69T19QVT1EA8',
        revisionAssessment: '01JXW2TQ0K50173Z38GJR6MEAB',
        preProduction: '01JXW2TQ0K46FYQNZD4595AEAT'
      }
    },
    Tutorial: {
      id: '01JXW2TQATH9EZJM8XPPTZAEAT',
      formSchemas: {
        authorSubmission: '01JXW2TQGHNXP276ZM52C9JEAS',
        authorRevision: '01JXW2TQGKP9KK8N8JFC8VBEAB',
        authorChangeRequest: '01JXW2TQGMY8F8TGN7TJCQSEA6',
        reviewerFirstAssessment: '01JXW2TQGNG3HGH7SGH71KEAAB'
      },
      checklists: {
        initialAssessment: '01JXW2TQ1KFF2VVCH9P5TWDEAB',
        revision: '01JXW2TQ1KPKXM69T19QVT1EA9',
        revisionAssessment: '01JXW2TQ1K50173Z38GJR6MEAC',
        preProduction: '01JXW2TQ1K46FYQNZD4595AEAF'
      }
    },
    Comment: {
      id: '01JXW2TQVN8DCDS979NPDV7EAZ',
      formSchemas: {
        authorSubmission: '01JXW2TQ5X40DEQ0GM1HZH6EAG',
        authorRevision: '01JXW2TQ5ZXC5C6YRGV9J67EAD',
        authorChangeRequest: '01JXW2TQ619W8XBMZWXF47HEAE'
      },
      checklists: {
        initialAssessment: '01JXW2TQ0K9VAAWEBA2TYPPEAM',
        revision: '01JXW2TQ0KX1Y0ENH6TS9ZSEAY',
        revisionAssessment: '01JXW2TQ0KGE49PM5FFAV9GEAG',
        preProduction: '01JXW2TQ0K31A23G1BGK0CVEAG'
      }
    },
    'Editorial/Other': {
      id: '01JXW2TQA0YVP7R4Q4KD6T7EA7',
      formSchemas: {
        authorSubmission: '01JXW2TQYHA06A4HSD4B283EA9',
        authorRevision: '01JXW2TQYK81V1M411EAE1REAC',
        authorChangeRequest: '01JXW2TQYMWV6099ED9HK5JEAV'
      },
      checklists: {
        initialAssessment: '01JXW2TQ0KQE3Y0D64BXXQAEAB',
        revision: '01JXW2TQ0MC1SEKVPVVESPYEAG',
        revisionAssessment: '01JXW2TQ0M4AQVF6WTG8WY4EAZ',
        preProduction: '01JXW2TQ0M47RW9MFQ3S4HPEA8'
      }
    },
    Reply: {
      id: '01JXW2TQAXFT5WB20CAH421EAE',
      formSchemas: {
        authorSubmission: '01JXW2TQANM7VRPV5N2P62WEA6',
        authorRevision: '01JXW2TQAP0S5DHHXVQE5J8EAY',
        authorChangeRequest: '01JXW2TQAQS4JYBJJ8WAHZ3EAQ'
      },
      checklists: {
        initialAssessment: '01JXW2TQ0MS4K0NCQCB4E5KEA1',
        revision: '01JXW2TQ0MB5EWET3RRY9M6EA5',
        revisionAssessment: '01JXW2TQ0MY0A9EZTDAYE3SEAM',
        preProduction: '01JXW2TQ0MS02PK9F15GWB5EAG'
      }
    },
    Addendum: {
      id: '01JXW2TQB7MHE0XK8PKPK4J5EA',
      formSchemas: {
        authorSubmission: '01JXW2TQZ2SSPFJQ1MWCSN6EAE',
        authorRevision: '01JXW2TQZ3P1N1SFMAQ8DNCEA0',
        authorChangeRequest: '01JXW2TQZ43K1ADETQYZNBHEAY'
      },
      checklists: {
        initialAssessment: '01JXW2TQ0NG730XSNY345DGEAN',
        revision: '01JXW2TQ0N94EQK7GVHC4A1EAS',
        revisionAssessment: '01JXW2TQ0NZJ06FHV9Q508AEAD',
        preProduction: '01JXW2TQ0NVT5882JZPE9V6EAP'
      }
    },
    Corrigendum: {
      id: '01JXW2TQZDM2M6GCW7N1SHYEA7',
      formSchemas: {
        authorSubmission: '01JXW2TQARMF1D6EBAECW26EA7',
        authorRevision: '01JXW2TQASKD866BN32XJM3EAS',
        authorChangeRequest: '01JXW2TQAS7J1NA3J4Y91QXEAK'
      },
      checklists: {
        initialAssessment: '01JXW2TQ0N5T3APY54TJH9WEA4',
        revision: '01JXW2TQ0N6FVZPXAWFY5KPEA5',
        revisionAssessment: '01JXW2TQ0N5CJRW6K6V2B37EA6',
        preProduction: '01JXW2TQ0NNMJANDVPGYPPYEAS'
      }
    },
    Erratum: {
      id: '01JXW2TQS07WJ6WKRM94K57EAE',
      formSchemas: {
        authorSubmission: '01JXW2TQ1MDDJV8G4F70920EAB',
        authorRevision: '01JXW2TQ1NKCA42VYNYRKR2EAX',
        authorChangeRequest: '01JXW2TQ1P0RH3CFCY8CVXREAB'
      },
      checklists: {
        initialAssessment: '01JXW2TQ0PXPKBDDX537FF3EA8',
        revision: '01JXW2TQ0PP3P183HMFY03MEA3',
        revisionAssessment: '01JXW2TQ0P8E1T1DNESS2CKEAJ',
        preProduction: '01JXW2TQ0PNRMKY9HGP9MWMEAQ'
      }
    },
    Retraction: {
      id: '01JXW2TQ1NXEWV89ENNEYZDEBQ',
      formSchemas: {
        authorSubmission: '01JXW2TQVJD45CBEK8QB0AGEAS',
        authorRevision: '01JXW2TQVK2E1YJ901SDT0TEA5',
        authorChangeRequest: '01JXW2TQVNRHR7F8XE4T824EAJ'
      },
      checklists: {
        initialAssessment: '01JXW2TQ0NSMV9B7SBATZQAEAP',
        revision: '01JXW2TQ0NKDEJY69V04Y3WEAE',
        revisionAssessment: '01JXW2TQ0P3BJH1Z724YC7VEA2',
        preProduction: '01JXW2TQ0PJHFV81ZWCP3T0EAC'
      }
    },
    'Expression of Concern': {
      id: '01JXW2TQ2NXEWV89ENNEYZDEAQ',
      formSchemas: {
        authorSubmission: '01JXW2TQWJD45CBEK8QB0AGEAT',
        authorRevision: '01JXW2TQWK2E1YJ901SDT0TEA6',
        authorChangeRequest: '01JXW2TQWNRHR7F8XE4T824EAK'
      },
      checklists: {
        initialAssessment: '01JXW2TQ1NSMV9B7SBATZQAEAQ',
        revision: '01JXW2TQ1NKDEJY69V04Y3WEAF',
        revisionAssessment: '01JXW2TQ1P3BJH1Z724YC7VEA3',
        preProduction: '01JXW2TQ1PJHFV81ZWCP3T0EAD'
      }
    }
  }
};

export const bibmStaticIds: SeedDataStaticIds<typeof bibmData> = {
  baseFormSchemas: {
    editorRevisionRequest: '01JXW2TRBW6HQCKXMJP7JXBHAH',
    editorialWithdrawSubmission: '01JXW2TRBW87T8BQBMA2ZFZHAD',
    editorialOfferTransfer: '01JXW2TRBXMNDKZWDERS9PCHAG',
    editorialRejectSubmission: '01JXW2TRBXPCE56WJENRBY1HA4',
    authorWithdrawSubmission: '01JXW2TRBXJK7YC9QR76K89HAC',
    editorialUnsubmit: '01JXW2TRBXCW0Y5C1E4Q03PHA7',
    reviewerFirstAssessment: '01JXW2TRB1KX3CVDX1YH3F0HA4',
    reviewerRevisionAssessment: '01JXW2TRB450QP8CXHN5KD8HAY',
    editorialLicensing: '01JXW2TRB4G5X2B9FC248NZHAS',
    externalEarlyAssessment: '01JXW2TRB5MMQDTXCXJEZY0HAT',
    expertAssessment: '01JXW2TRB5X7DE3YJ7CRJE7HAF',
    externalAdjudication: '01JXW2TRB5TAKHAV6V1C6HWHA2',
    adjudicationAssessment: '01JXW2TRB57H26HSGXZ7RFAHAN',
    authorCopyrightSubmission: '01JXW2TRB52W0NV7DWKMV9PHA2',
    editorialUploadCopyright: '01JXW2TRB6JB2SFQGQRE9B9HAB',
    inviteCoReviewer: '01JXW2TRB60TNCHDT3M9FPAHAS',
    authorSubmission: 'unused?',
    authorRevision: 'unused?'
  },
  articleWorkflows: {
    Paper: {
      id: '01JXW2TR036P9JP1VF8P6DSWHA',
      formSchemas: {
        authorSubmission: '01JXW2TRBBZC3BTTWFZ8KR1HAP',
        authorRevision: '01JXW2TRBE13TY91Z6KH5NGHA9',
        authorChangeRequest: '01JXW2TRBGE4GKH5ZY8R1EGHAV',
        reviewerFirstAssessment: '01JXW2TRBBNG3HGH7SGH71KHAB'
      },
      checklists: {
        initialAssessment: '01JXW2TR0JF3X880P1VRA1THAD',
        revision: '01JXW2TR0JXBGNTEBNPF9PPHAP',
        revisionAssessment: '01JXW2TR0J3MJ2Z3700HW14HAD',
        preProduction: '01JXW2TR0JSZAHG0YPVP7PMHAV'
      }
    },
    Note: {
      id: '01JXW2TRCCZ081D82KB61C7HAC',
      formSchemas: {
        authorSubmission: '01JXW2TR2TQKS3JJFSRCNRHHAN',
        authorRevision: '01JXW2TR2XR0DT9SVVGFXDMHAW',
        authorChangeRequest: '01JXW2TR2ZB48KEKRVEER30HA0',
        reviewerFirstAssessment: '01JXW2TR2VHKH1854FTER1ZHAM'
      },
      checklists: {
        initialAssessment: '01JXW2TR0JYN2ADZBCV4DG8HAJ',
        revision: '01JXW2TR0JR360FJ2N7QTSQHAP',
        revisionAssessment: '01JXW2TR0JN32TX8ZYTR7HAHA8',
        preProduction: '01JXW2TR0KKSCGEQEYRTJS1HAW'
      }
    },
    'Topical Review': {
      id: '01JXW2TR3TH9EZJM8XPPTZAHAX',
      formSchemas: {
        authorSubmission: '01JXW2TRFHNXP276ZM52C9JHAT',
        authorRevision: '01JXW2TRFKP9KK8N8JFC8VBHAA',
        authorChangeRequest: '01JXW2TRFMY8F8TGN7TJCQSHAK'
      },
      checklists: {
        initialAssessment: '01JXW2TR0KFF2VVCH9P5TWDHAA',
        revision: '01JXW2TR0KPKXM69T19QVT1HA8',
        revisionAssessment: '01JXW2TR0K50173Z38GJR6MHAB',
        preProduction: '01JXW2TR0K46FYQNZD4595AHAT'
      }
    },
    Tutorial: {
      id: '01JXW2TRATH9EZJM8XPPTZAHAT',
      formSchemas: {
        authorSubmission: '01JXW2TRGHNXP276ZM52C9JHAS',
        authorRevision: '01JXW2TRGKP9KK8N8JFC8VBHAB',
        authorChangeRequest: '01JXW2TRGMY8F8TGN7TJCQSHAJ',
        reviewerFirstAssessment: '01JXW2TRGNG3HGH7SGH71KHAAB'
      },
      checklists: {
        initialAssessment: '01JXW2TR1KFF2VVCH9P5TWDHAB',
        revision: '01JXW2TR1KPKXM69T19QVT1HA9',
        revisionAssessment: '01JXW2TR1K50173Z38GJR6MHAC',
        preProduction: '01JXW2TR1K46FYQNZD4595AHAS'
      }
    },
    Comment: {
      id: '01JXW2TRVN8DCDS979NPDV7HAZ',
      formSchemas: {
        authorSubmission: '01JXW2TR5X40DEQ0GM1HZH6HAG',
        authorRevision: '01JXW2TR5ZXC5C6YRGV9J67HAD',
        authorChangeRequest: '01JXW2TR619W8XBMZWXF47HHAE'
      },
      checklists: {
        initialAssessment: '01JXW2TR0K9VAAWEBA2TYPPHAM',
        revision: '01JXW2TR0KX1Y0ENH6TS9ZSHAY',
        revisionAssessment: '01JXW2TR0KGE49PM5FFAV9GHAG',
        preProduction: '01JXW2TR0K31A23G1BGK0CVHAG'
      }
    },
    'Editorial/Other': {
      id: '01JXW2TRA0YVP7R4Q4KD6T7HA7',
      formSchemas: {
        authorSubmission: '01JXW2TRYHA06A4HSD4B283HA9',
        authorRevision: '01JXW2TRYK81V1M411EAE1RHAC',
        authorChangeRequest: '01JXW2TRYMWV6099ED9HK5JHAV'
      },
      checklists: {
        initialAssessment: '01JXW2TR0KQE3Y0D64BXXQAHAB',
        revision: '01JXW2TR0MC1SEKVPVVESPYHAG',
        revisionAssessment: '01JXW2TR0M4AQVF6WTG8WY4HAZ',
        preProduction: '01JXW2TR0M47RW9MFQ3S4HPHA8'
      }
    },
    Perspective: {
      id: '01JXW2TR2NXEWV89ENNEYZDHAQ',
      formSchemas: {
        authorSubmission: '01JXW2TRWJD45CBEK8QB0AGHAT',
        authorRevision: '01JXW2TRWK2E1YJ901SDT0THA6',
        authorChangeRequest: '01JXW2TRWNRHR7F8XE4T824HAK'
      },
      checklists: {
        initialAssessment: '01JXW2TR1NSMV9B7SBATZQAHAQ',
        revision: '01JXW2TR1NKDEJY69V04Y3WHAF',
        revisionAssessment: '01JXW2TR1P3BJH1Z724YC7VHA3',
        preProduction: '01JXW2TR1PJHFV81ZWCP3T0HAD'
      }
    },
    Reply: {
      id: '01JXW2TRAXFT5WB20CAH421HAE',
      formSchemas: {
        authorSubmission: '01JXW2TRANM7VRPV5N2P62WHA6',
        authorRevision: '01JXW2TRAP0S5DHHXVQE5J8HAY',
        authorChangeRequest: '01JXW2TRAQS4JYBJJ8WAHZ3HAQ'
      },
      checklists: {
        initialAssessment: '01JXW2TR0MS4K0NCQCB4E5KHA1',
        revision: '01JXW2TR0MB5EWET3RRY9M6HA5',
        revisionAssessment: '01JXW2TR0MY0A9EZTDAYE3SHAM',
        preProduction: '01JXW2TR0MS02PK9F15GWB5HAG'
      }
    },
    Addendum: {
      id: '01JXW2TRB7MHE0XK8PKPK4J5HA',
      formSchemas: {
        authorSubmission: '01JXW2TRZ2SSPFJQ1MWCSN6HAE',
        authorRevision: '01JXW2TRZ3P1N1SFMAQ8DNCHA0',
        authorChangeRequest: '01JXW2TRZ43K1ADETQYZNBHHAY'
      },
      checklists: {
        initialAssessment: '01JXW2TR0NG730XSNY345DGHAN',
        revision: '01JXW2TR0N94EQK7GVHC4A1HAS',
        revisionAssessment: '01JXW2TR0NZJ06FHV9Q508AHAD',
        preProduction: '01JXW2TR0NVT5882JZPE9V6HAP'
      }
    },
    Corrigendum: {
      id: '01JXW2TRZDM2M6GCW7N1SHYHA7',
      formSchemas: {
        authorSubmission: '01JXW2TRARMF1D6EBAECW26HA7',
        authorRevision: '01JXW2TRASKD866BN32XJM3HAS',
        authorChangeRequest: '01JXW2TRAS7J1NA3J4Y91QXHAK'
      },
      checklists: {
        initialAssessment: '01JXW2TR0N5T3APY54TJH9WHA4',
        revision: '01JXW2TR0N6FVZPXAWFY5KPHA5',
        revisionAssessment: '01JXW2TR0N5CJRW6K6V2B37HA6',
        preProduction: '01JXW2TR0NNMJANDVPGYPPYHAS'
      }
    },
    Erratum: {
      id: '01JXW2TRS07WJ6WKRM94K57HAE',
      formSchemas: {
        authorSubmission: '01JXW2TR1MDDJV8G4F70920HAB',
        authorRevision: '01JXW2TR1NKCA42VYNYRKR2HAX',
        authorChangeRequest: '01JXW2TR1P0RH3CFCY8CVXRHAB'
      },
      checklists: {
        initialAssessment: '01JXW2TR0PXPKBDDX537FF3HA8',
        revision: '01JXW2TR0PP3P183HMFY03MHA3',
        revisionAssessment: '01JXW2TR0P8E1T1DNESS2CKHAJ',
        preProduction: '01JXW2TR0PNRMKY9HGP9MWMHAQ'
      }
    },
    Retraction: {
      id: '01JXW2TR1NXEWV89ENNEYZDHBQ',
      formSchemas: {
        authorSubmission: '01JXW2TRVJD45CBEK8QB0AGHAS',
        authorRevision: '01JXW2TRVK2E1YJ901SDT0THA5',
        authorChangeRequest: '01JXW2TRVNRHR7F8XE4T824HAJ'
      },
      checklists: {
        initialAssessment: '01JXW2TR0NSMV9B7SBATZQAHAP',
        revision: '01JXW2TR0NKDEJY69V04Y3WHAE',
        revisionAssessment: '01JXW2TR0P3BJH1Z724YC7VHA2',
        preProduction: '01JXW2TR0PJHFV81ZWCP3T0HAC'
      }
    }
  }
};

export const pbStaticIds: SeedDataStaticIds<typeof pbData> = {
  baseFormSchemas: {
    editorRevisionRequest: '01JXW2TSBW6HQCKXMJP7JXBPAH',
    editorialWithdrawSubmission: '01JXW2TSBW87T8BQBMA2ZFZPAD',
    editorialOfferTransfer: '01JXW2TSBXMNDKZWDERS9PCPAG',
    editorialRejectSubmission: '01JXW2TSBXPCE56WJENRBY1PA4',
    authorWithdrawSubmission: '01JXW2TSBXJK7YC9QR76K89PAC',
    editorialUnsubmit: '01JXW2TSBXCW0Y5C1E4Q03PPA7',
    reviewerFirstAssessment: '01JXW2TSB1KX3CVDX1YH3F0PA4',
    reviewerRevisionAssessment: '01JXW2TSB450QP8CXHN5KD8PAY',
    editorialLicensing: '01JXW2TSB4G5X2B9FC248NZPAS',
    externalEarlyAssessment: '01JXW2TSB5MMQDTXCXJEZY0PAT',
    expertAssessment: '01JXW2TSB5X7DE3YJ7CRJE7PAF',
    externalAdjudication: '01JXW2TSB5TAKHAV6V1C6HWPA2',
    adjudicationAssessment: '01JXW2TSB57H26HSGXZ7RFAPAN',
    authorCopyrightSubmission: '01JXW2TSB52W0NV7DWKMV9PPA2',
    editorialUploadCopyright: '01JXW2TSB6JB2SFQGQRE9B9PAB',
    inviteCoReviewer: '01JXW2TSB60TNCHDT3M9FPAPAS',
    authorSubmission: 'unused?',
    authorRevision: 'unused?'
  },
  articleWorkflows: {
    Paper: {
      id: '01JXW2TS036P9JP1VF8P6DSWHA',
      formSchemas: {
        authorSubmission: '01JXW2TSBBZC3BTTWFZ8KR1PAP',
        authorRevision: '01JXW2TSBE13TY91Z6KH5NGPA9',
        authorChangeRequest: '01JXW2TSBGE4GKH5ZY8R1EGPAV',
        reviewerFirstAssessment: '01JXW2TSBBNG3HGH7SGH71KPAB'
      },
      checklists: {
        initialAssessment: '01JXW2TS0JF3X880P1VRA1TPAD',
        revision: '01JXW2TS0JXBGNTEBNPF9PPPAP',
        revisionAssessment: '01JXW2TS0J3MJ2Z3700HW14PAD',
        preProduction: '01JXW2TS0JSZAHG0YPVP7PMPAV'
      }
    },
    Note: {
      id: '01JXW2TSCCZ081D82KB61C7PAC',
      formSchemas: {
        authorSubmission: '01JXW2TS2TQKS3JJFSRCNRHPAN',
        authorRevision: '01JXW2TS2XR0DT9SVVGFXDMPAW',
        authorChangeRequest: '01JXW2TS2ZB48KEKRVEER30PA0',
        reviewerFirstAssessment: '01JXW2TS2VHKH1854FTER1ZPAM'
      },
      checklists: {
        initialAssessment: '01JXW2TS0JYN2ADZBCV4DG8PAJ',
        revision: '01JXW2TS0JR360FJ2N7QTSQPAP',
        revisionAssessment: '01JXW2TS0JN32TX8ZYTR7HAPA8',
        preProduction: '01JXW2TS0KKSCGEQEYRTJS1PAW'
      }
    },
    Letter: {
      id: '01JXW2TSDC2081D82KB61C7PCT',
      formSchemas: {
        authorSubmission: '01JXW2TS3TQKS3JJFSRCNRHP5T',
        authorRevision: '01JXW2TS3XR0DT9SVVGFXDMP3T',
        authorChangeRequest: '01JXW2TS3ZB48KEKRVEER30PJT',
        reviewerFirstAssessment: '01JXW2TS3VHKH1854FTER1ZPMT'
      },
      checklists: {
        initialAssessment: '01JXW2TS1JYN2ADZBCV4DG8PRT',
        revision: '01JXW2TS1JR360FJ2N7QTSQPKT',
        revisionAssessment: '01JXW2TS1JN32TX8ZYTR7HAP6T',
        preProduction: '01JXW2TS1KKSCGEQEYRTJS1PCT'
      }
    },
    'Topical Review': {
      id: '01JXW2TS3TH9EZJM8XPPTZAPAX',
      formSchemas: {
        authorSubmission: '01JXW2TSFHNXP276ZM52C9JPAT',
        authorRevision: '01JXW2TSFKP9KK8N8JFC8VBPAA',
        authorChangeRequest: '01JXW2TSFMY8F8TGN7TJCQSPAK'
      },
      checklists: {
        initialAssessment: '01JXW2TS0KFF2VVCH9P5TWDPAA',
        revision: '01JXW2TS0KPKXM69T19QVT1PA8',
        revisionAssessment: '01JXW2TS0K50173Z38GJR6MPAB',
        preProduction: '01JXW2TS0K46FYQNZD4595APAT'
      }
    },
    Tutorial: {
      id: '01JXW2TSATH9EZJM8XPPTZAPAT',
      formSchemas: {
        authorSubmission: '01JXW2TSGHNXP276ZM52C9JPAS',
        authorRevision: '01JXW2TSGKP9KK8N8JFC8VBPAB',
        authorChangeRequest: '01JXW2TSGMY8F8TGN7TJCQSPAX',
        reviewerFirstAssessment: '01JXW2TSGNG3HGH7SGH71KPAAB'
      },
      checklists: {
        initialAssessment: '01JXW2TS1KFF2VVCH9P5TWDPAB',
        revision: '01JXW2TS1KPKXM69T19QVT1PA9',
        revisionAssessment: '01JXW2TS1K50173Z38GJR6MPAC',
        preProduction: '01JXW2TS1K46FYQNZD4595APAG'
      }
    },
    Comment: {
      id: '01JXW2TSVN8DCDS979NPDV7PAZ',
      formSchemas: {
        authorSubmission: '01JXW2TS5X40DEQ0GM1HZH6PAG',
        authorRevision: '01JXW2TS5ZXC5C6YRGV9J67PAD',
        authorChangeRequest: '01JXW2TS619W8XBMZWXF47HPAE'
      },
      checklists: {
        initialAssessment: '01JXW2TS0K9VAAWEBA2TYPPPAM',
        revision: '01JXW2TS0KX1Y0ENH6TS9ZSPAY',
        revisionAssessment: '01JXW2TS0KGE49PM5FFAV9GPAG',
        preProduction: '01JXW2TS0K31A23G1BGK0CVPAG'
      }
    },
    'Editorial/Other': {
      id: '01JXW2TSA0YVP7R4Q4KD6T7PA7',
      formSchemas: {
        authorSubmission: '01JXW2TSYHA06A4HSD4B283PA9',
        authorRevision: '01JXW2TSYK81V1M411EAE1RPAC',
        authorChangeRequest: '01JXW2TSYMWV6099ED9HK5JPAV'
      },
      checklists: {
        initialAssessment: '01JXW2TS0KQE3Y0D64BXXQAPAB',
        revision: '01JXW2TS0MC1SEKVPVVESPYPAG',
        revisionAssessment: '01JXW2TS0M4AQVF6WTG8WY4PAZ',
        preProduction: '01JXW2TS0M47RW9MFQ3S4HPPA8'
      }
    },
    Perspective: {
      id: '01JXW2TS2NXEWV89ENNEYZDPAQ',
      formSchemas: {
        authorSubmission: '01JXW2TSWJD45CBEK8QB0AGPAT',
        authorRevision: '01JXW2TSWK2E1YJ901SDT0TPA6',
        authorChangeRequest: '01JXW2TSWNRHR7F8XE4T824PAK'
      },
      checklists: {
        initialAssessment: '01JXW2TS1NSMV9B7SBATZQAPAQ',
        revision: '01JXW2TS1NKDEJY69V04Y3WPAF',
        revisionAssessment: '01JXW2TS1P3BJH1Z724YC7VPA3',
        preProduction: '01JXW2TS1PJHFV81ZWCP3T0PAD'
      }
    },
    Reply: {
      id: '01JXW2TSAXFT5WB20CAH421PAE',
      formSchemas: {
        authorSubmission: '01JXW2TSANM7VRPV5N2P62WPA6',
        authorRevision: '01JXW2TSAP0S5DHHXVQE5J8PAY',
        authorChangeRequest: '01JXW2TSAQS4JYBJJ8WAHZ3PAQ'
      },
      checklists: {
        initialAssessment: '01JXW2TS0MS4K0NCQCB4E5KPA1',
        revision: '01JXW2TS0MB5EWET3RRY9M6PA5',
        revisionAssessment: '01JXW2TS0MY0A9EZTDAYE3SPAM',
        preProduction: '01JXW2TS0MS02PK9F15GWB5PAG'
      }
    },
    Addendum: {
      id: '01JXW2TSB7MHE0XK8PKPK4J5PA',
      formSchemas: {
        authorSubmission: '01JXW2TSZ2SSPFJQ1MWCSN6PAE',
        authorRevision: '01JXW2TSZ3P1N1SFMAQ8DNCPA0',
        authorChangeRequest: '01JXW2TSZ43K1ADETQYZNBHPAY'
      },
      checklists: {
        initialAssessment: '01JXW2TS0NG730XSNY345DGPAN',
        revision: '01JXW2TS0N94EQK7GVHC4A1PAS',
        revisionAssessment: '01JXW2TS0NZJ06FHV9Q508APAD',
        preProduction: '01JXW2TS0NVT5882JZPE9V6PAP'
      }
    },
    Corrigendum: {
      id: '01JXW2TSZDM2M6GCW7N1SHYPA7',
      formSchemas: {
        authorSubmission: '01JXW2TSARMF1D6EBAECW26PA7',
        authorRevision: '01JXW2TSASKD866BN32XJM3PAS',
        authorChangeRequest: '01JXW2TSAS7J1NA3J4Y91QXPAK'
      },
      checklists: {
        initialAssessment: '01JXW2TS0N5T3APY54TJH9WPA4',
        revision: '01JXW2TS0N6FVZPXAWFY5KPPA5',
        revisionAssessment: '01JXW2TS0N5CJRW6K6V2B37PA6',
        preProduction: '01JXW2TS0NNMJANDVPGYPPYPAS'
      }
    },
    Erratum: {
      id: '01JXW2TSS07WJ6WKRM94K57PAE',
      formSchemas: {
        authorSubmission: '01JXW2TS1MDDJV8G4F70920PAB',
        authorRevision: '01JXW2TS1NKCA42VYNYRKR2PAX',
        authorChangeRequest: '01JXW2TS1P0RH3CFCY8CVXRPAB'
      },
      checklists: {
        initialAssessment: '01JXW2TS0PXPKBDDX537FF3PA8',
        revision: '01JXW2TS0PP3P183HMFY03MPA3',
        revisionAssessment: '01JXW2TS0P8E1T1DNESS2CKPAJ',
        preProduction: '01JXW2TS0PNRMKY9HGP9MWMPAQ'
      }
    },
    Roadmap: {
      id: '01JXW2TS1NXEWV89ENNEYZDHBQ',
      formSchemas: {
        authorSubmission: '01JXW2TSVJD45CBEK8QB0AGPAS',
        authorRevision: '01JXW2TSVK2E1YJ901SDT0TPA5',
        authorChangeRequest: '01JXW2TSVNRHR7F8XE4T824PAJ',
        reviewerFirstAssessment: '01JXW2TSBBNG3HGY7SGH71KPAB',
        authorCopyrightSubmission: '01K4QP63J7VJVSAN1M25VNM96J'
      },
      checklists: {
        initialAssessment: '01JXW2TS0NSMV9B7SBATZQAPAP',
        revision: '01JXW2TS0NKDEJY69V04Y3WPAE',
        revisionAssessment: '01JXW2TS0P3BJH1Z724YC7VPA2',
        preProduction: '01JXW2TS0PJHFV81ZWCP3T0PAC'
      }
    },
    Retraction: {
      id: '01JXW2TS1NXEWV89ENNEYZDHBQ',
      formSchemas: {
        authorSubmission: '01JXW2TSVJD45CBEK8QB0AGPAS',
        authorRevision: '01JXW2TSVK2E1YJ901SDT0TPA5',
        authorChangeRequest: '01JXW2TSVNRHR7F8XE4T824PAJ'
      },
      checklists: {
        initialAssessment: '01JXW2TS0NSMV9B7SBATZQAPAP',
        revision: '01JXW2TS0NKDEJY69V04Y3WPAE',
        revisionAssessment: '01JXW2TS0P3BJH1Z724YC7VPA2',
        preProduction: '01JXW2TS0PJHFV81ZWCP3T0PAC'
      }
    }
  }
};

export const irreiStaticIds: SeedDataStaticIds<typeof irreiData> = {
  baseFormSchemas: {
    editorRevisionRequest: '01K344F9HCRBF5VXQJC8Q8SMZR',
    editorialWithdrawSubmission: '01K344F9HCWKG26TVX6ZNJD5X8',
    editorialOfferTransfer: '01K344F9HCQATX2WG71FNY14ZR',
    editorialRejectSubmission: '01K344F9HAA9PZHY3GQ9Y8ZRWP',
    authorWithdrawSubmission: '01K344F9HC98N0DG2HEXARB791',
    editorialUnsubmit: '01K344F9HDVY4ADXDX4WKW4NEH',
    reviewerFirstAssessment: '01K344F9HDZTGSFRZWWN8M5R3B',
    reviewerRevisionAssessment: '01K344F9HD4G08DHZQCH6ZZ4A4',
    editorialLicensing: '01K344F9HDE1EMAMSHQ27FEJDH',
    externalEarlyAssessment: '01K344F9HDTYXGVPDF7P83168F',
    expertAssessment: '01K344F9HDZR8CF2F1DY0PTPH6',
    externalAdjudication: '01K344F9HD0EBK4B70TR0Z3ZB0',
    adjudicationAssessment: '01K344F9HDXFT8AJRN3CXTFXD0',
    authorCopyrightSubmission: '01K344F9HDQ371VSBR4GJ24D7K',
    editorialUploadCopyright: '01K344F9HDE8DN3ME1A73ZDXX0',
    inviteCoReviewer: '01K344F9HD80MRBE0FY6590B2E',
    authorSubmission: 'unused?',
    authorRevision: 'unused?'
  },
  articleWorkflows: {
    Paper: {
      id: '01K344F9HD0WTJ13RYY0VACG3Y',
      formSchemas: {
        authorSubmission: '01K344F9HEBVRY6GS0A2B9V7K1',
        authorRevision: '01K344F9HEYMVQMKHJHAEQ4MVR',
        authorChangeRequest: '01K344F9HETCP88JQD40TPWYQA',
        reviewerFirstAssessment: '01K344F9HEWBDFNJDNMKNCYNPN'
      },
      checklists: {
        initialAssessment: '01K344F9HETSWG027GKH5B0Q0N',
        revision: '01K344F9HE3WHDD872FP3VZR6G',
        revisionAssessment: '01K344F9HER0EKCCS3H8V8PD3J',
        preProduction: '01K344F9HE1025JJE3WF9ACSG0'
      }
    }
  }
};

export const jripStaticIds: SeedDataStaticIds<typeof jripData> = {
  baseFormSchemas: {
    editorRevisionRequest: '01K344F9H96YRTBVYHDJP7E10J',
    editorialWithdrawSubmission: '01K344F9HANHJBQCWJC23WRQKB',
    editorialOfferTransfer: '01K344F9HAV97NZ5V2BJ5YBW4S',
    editorialRejectSubmission: '01K344F9HAA9PZHY3GQ9Y8ZRWP',
    authorWithdrawSubmission: '01K344F9HA5PBN1CJ2ZW8JV870',
    editorialUnsubmit: '01K344F9HAD2M1V39S8SEVGDMG',
    reviewerFirstAssessment: '01K344F9HBMV5DT2S5F628VSCP',
    reviewerRevisionAssessment: '01K344F9HB8N0BTYTDXHDX4KM8',
    editorialLicensing: '01K344F9HB1AEQ4FMBBW8WP43Q',
    externalEarlyAssessment: '01K344F9HB1NHWN5CD409JB7FY',
    expertAssessment: '01K344F9HBTN6PM5JEM75NNKBW',
    externalAdjudication: '01K344F9HB7XQRV9KDYZ40SSQB',
    adjudicationAssessment: '01K344F9HB5AC0MPFPXS70B9X4',
    authorCopyrightSubmission: '01K344F9HBGD6PV4295RDDFC4P',
    editorialUploadCopyright: '01K344F9HB0TJPP6VXVR1FN90M',
    inviteCoReviewer: '01K344F9HCZ65C63KVSREQCDY8',
    authorSubmission: 'unused?',
    authorRevision: 'unused?'
  },
  articleWorkflows: {
    Paper: {
      id: '01K344F9HC0DDVMFYFVN667E3S',
      formSchemas: {
        authorSubmission: '01K344F9HC3VWE4Z54D72BRP58',
        authorRevision: '01K344F9HCCWDVWEBH97CMZGTT',
        authorChangeRequest: '01K344F9HCMQXXGW6KJVD42KWJ',
        reviewerFirstAssessment: '01K344F9HCA2D8D3XEX9AR74CG'
      },
      checklists: {
        initialAssessment: '01K344F9HCFRA7GN8NR8NZPDRV',
        revision: '01K344F9HCSWWRW67XCKKKMC81',
        revisionAssessment: '01K344F9HCZB09PW30GDW97HZW',
        preProduction: '01K344F9HCVRSQZSKYMMA8F5Y6'
      }
    }
  }
};

export const riseStaticIds: SeedDataStaticIds<typeof riseData> = {
  baseFormSchemas: {
    editorRevisionRequest: '01K44RKGE873E5Q0B3D195NXQ0',
    editorialWithdrawSubmission: '01K44RKGE9BFBNCYYFZ222GYGK',
    editorialOfferTransfer: '01K344F9HAV97NZ5V2BJ5YBW4S',
    editorialRejectSubmission: '01K44RKGE949CXG5HK5QDXJQWX',
    authorWithdrawSubmission: '01K44RKGE9R428DXVV40G0D7DF',
    editorialUnsubmit: '01K44RKGE9TSYWP6NANZ4K1ZJE',
    reviewerFirstAssessment: '01K44RKGE9Q9SFMA9589KB0HSV',
    reviewerRevisionAssessment: '01K44RKGEAHD0JEAZMK7KH917T',
    editorialLicensing: '01K44RKGEAAH5RE0M3SD5Q9J5V',
    externalEarlyAssessment: '01K44RKGEAAMXDSATMVSCT5E5R',
    expertAssessment: '01K44RKGEA34Q8P5Y8HVMA95R5',
    externalAdjudication: '01K44RKGEA7840ZV6GYQW6TM09',
    adjudicationAssessment: '01K44RKGEAYNQP1GYP29KWA8JK',
    authorCopyrightSubmission: '01K44RKGEA4J4PNZN1D1Y915C9',
    editorialUploadCopyright: '01K44RKGEAACZQNR9G4H1K7P2D',
    inviteCoReviewer: '01K44RKGEAFNSY32F2P06KXK61',
    authorSubmission: 'unused?',
    authorRevision: 'unused?'
  },
  articleWorkflows: {
    Paper: {
      id: '01J7XT3HBJCJ69DW2F5Z5F2M77',
      formSchemas: {
        authorSubmission: '01K44RKGEAP0ZXXNTAXY6EG6GZ',
        authorRevision: '01K44RKGEAT7DEN1RA57QRAGMW',
        authorChangeRequest: '01K44RKGEA07XMVBVTJ8T2N2Z0',
        reviewerFirstAssessment: '01K44RKGEBSGT1VQ5M564HCF05'
      },
      checklists: {
        initialAssessment: '01K44RKGEB38RAN1T89D9NYVQ0',
        revision: '01K44RKGEBSWJ7MVW5198KDZGG',
        revisionAssessment: '01K44RKGEBKP2NCNJCYEKPYJXW',
        preProduction: '01K44RKGEBX1DQM467FR8Q9JBJ'
      }
    },
    Letter: {
      id: '01J7XT3HBJCJ69DW2F5Z5F2M7B',
      formSchemas: {
        authorSubmission: '01K44RKGEB6M0B8HCNQW52PXWE',
        authorRevision: '01K44RKGEB5VHTHKSC9A3HRCWS',
        authorChangeRequest: '01K44RKGEB0FMAZ09HCSNG0P6K',
        reviewerFirstAssessment: '01K44RKGEBH94SXZG8PKPT9Q6V'
      },
      checklists: {
        initialAssessment: '01K44RKGEB5C3KKJTFRYMNX763',
        revision: '01K44RKGEB8MVNC2QE7N0E22VG',
        revisionAssessment: '01K44RKGEBVEGBN6TGXNPJFPR4',
        preProduction: '01K44RKGEBK144FXMG70CSS73C'
      }
    }
  }
};

export const morressierTestStaticIds: SeedDataStaticIds<
  typeof morressierTestData
> = {
  baseFormSchemas: {
    editorRevisionRequest: '01K44RKGECPFQG474D65RVW8W3',
    editorialWithdrawSubmission: '01K44RKGECQZQ7KH1Z9VS7Y07Q',
    editorialOfferTransfer: '01K44RKGEC12G7HBXT5FYYX6MQ',
    editorialRejectSubmission: '01K44RKGECW2VJAX1QE7JF2EER',
    authorWithdrawSubmission: '01K44RKGECPVJXEAT4XDS8B6HV',
    editorialUnsubmit: '01K44RKGECZ2J78CYHBXJWV8JE',
    reviewerFirstAssessment: '01K44RKGECJ018S0SQPVCWQJJR',
    reviewerRevisionAssessment: '01K44RKGECJ018S0SQPVCWQJJR',
    editorialLicensing: '01K44RKGEC4Y3JNV8WHZBGCARK',
    externalEarlyAssessment: '01K44RKGECSXV2ZRFCWE6J5HFN',
    expertAssessment: '01K44RKGECFE4HNMV8EGS2Z47P',
    externalAdjudication: '01K44RKGECBS7BB5N04W25SV6A',
    adjudicationAssessment: '01K44RKGEC14VNJA8YE19TQRQH',
    authorCopyrightSubmission: '01K44RKGECNRVG49S76G3SYV53',
    editorialUploadCopyright: '01K44RKGECQTTYMRGJNHBDB652',
    inviteCoReviewer: '01K44RKGECZ7ZMXYNZAB9Q3ZQ2',
    authorSubmission: 'unused?',
    authorRevision: 'unused?'
  },
  articleWorkflows: {
    Paper: {
      id: '01J7XT3HBJCJ69DW2F5Z5F2M76',
      formSchemas: {
        authorSubmission: '01K44RKGEDGZK5YXTGCDSGXM3F',
        authorRevision: '01K44RKGED2PVNQ3QWZD93R4AA',
        authorChangeRequest: '01K44RKGEDMNCN2S04GVAFGD20',
        reviewerFirstAssessment: '01K44RKGEDP2VY5SJV62S7ZTSK'
      },
      checklists: {
        initialAssessment: '01K44RKGEDRTQ3XGCFT7TB5PYM',
        revision: '01K44RKGED6PANVQ08GM7FRVWE',
        revisionAssessment: '01K44RKGEDBKVWY5ZRB1VFGS0P',
        preProduction: '01K44RKGEDH6KTAE06PA1FB868'
      }
    }
  }
};

export function getBaseFormSchemaId(
  baseFormSchemaName: string,
  ids: SeedDataStaticIds
) {
  const id =
    ids.baseFormSchemas[
      baseFormSchemaName as keyof SeedDataStaticIds['baseFormSchemas']
    ];

  if (!id) {
    throw new Error(
      `getBaseFormSchemaId(): unable to retrieve ${baseFormSchemaName}, got ${JSON.stringify(
        ids.baseFormSchemas
      )}`
    );
  }

  return id;
}

export function getArticleWorkflowFormSchemaId(
  articleWorkflowName: string,
  formSchemaName: string,
  ids: SeedDataStaticIds
) {
  const articleWorkflowIds = ids.articleWorkflows[articleWorkflowName];

  if (!articleWorkflowIds) {
    throw new Error(
      `getArticleWorkflowFormSchemaId(): unable to retrieve ${articleWorkflowName}, got ${JSON.stringify(
        Object.keys(ids.articleWorkflows)
      )}`
    );
  }

  const formSchemaId =
    articleWorkflowIds.formSchemas[
      formSchemaName as keyof typeof articleWorkflowIds.formSchemas
    ];

  if (!formSchemaId) {
    throw new Error(
      `getArticleWorkflowFormSchemaId(): unable to retrieve ${formSchemaName}, got ${JSON.stringify(
        Object.keys(articleWorkflowIds.formSchemas)
      )}`
    );
  }

  return formSchemaId;
}

export function getArticleWorkflowId(
  articleWorkflowName: string,
  ids: SeedDataStaticIds
) {
  const articleWorkflowId = ids.articleWorkflows[articleWorkflowName]?.id;

  if (!articleWorkflowId) {
    throw new Error(
      `getArticleWorkflowId(): unable to retrieve id for ${articleWorkflowName}, got ${JSON.stringify(
        Object.keys(ids.articleWorkflows)
      )}`
    );
  }

  return articleWorkflowId;
}

export function getEditorialChecklistId(
  articleWorkflowName: string,
  phaseName: string,
  ids: SeedDataStaticIds
) {
  const articleWorkflowIds = ids.articleWorkflows[articleWorkflowName];

  if (!articleWorkflowIds) {
    throw new Error(
      `getArticleWorkflowFormSchemaId(): unable to retrieve ${articleWorkflowName}, got ${JSON.stringify(
        Object.keys(ids.articleWorkflows)
      )}`
    );
  }

  const checklistId =
    articleWorkflowIds.checklists[
      phaseName as keyof typeof articleWorkflowIds.checklists
    ];

  if (!checklistId) {
    throw new Error(
      `getArticleWorkflowId(): unable to retrieve id for checklist ${articleWorkflowName} - ${phaseName}, got checklists ${JSON.stringify(
        articleWorkflowIds.checklists
      )}`
    );
  }

  return checklistId;
}

export const bjrStaticIds: SeedDataStaticIds<typeof bjrData> = {
  baseFormSchemas: {
    editorRevisionRequest: '01JXW2T7HW6HQCKXMJP7JXB9AH',
    editorialWithdrawSubmission: '01JXW2T7HW87T8BQBMA2ZFZP9D',
    editorialOfferTransfer: '01JXW2T7HXMNDKZWDERS9PC9KG',
    editorialRejectSubmission: '01JXW2T7HXPCE56WJENRBY19H4',
    authorWithdrawSubmission: '01JXW2T7HXJK7YC9QR76K899QC',
    editorialUnsubmit: '01JXW2T7HXCW0Y5C1E4Q03P987',
    reviewerFirstAssessment: '01JXW2T7J1KX3CVDX1YH3F0NM8',
    reviewerRevisionAssessment: '01KXW2T7J450QP8CXHN5KD8N8Y',
    editorialLicensing: '01JXW2T7J4G5X2B9FC248NZ7RS',
    externalEarlyAssessment: '01JXW2T7J5MMQDTXCXJEZY03CT',
    expertAssessment: '01JXW2T7J5X7DE3YJ7CRJE8NWF',
    externalAdjudication: '01JXW2T7J5TAKHAV6V1C6HWTE5',
    adjudicationAssessment: '01JXW3T7J57H26HSGXZ7RFAZVN',
    authorCopyrightSubmission: '01JXW2T7J52W0NV7DWKMV9PE3R',
    editorialUploadCopyright: '01JXW2T7J6JB2SFQGQRE9B7TCB',
    editorialUploadICMJE: '01JXW2T7J60TNCHDT3M9FPAUON',
    inviteCoReviewer: '01JXW2T7J60TNCHDT3M9FPAXTS',
    authorSubmission: 'unused?',
    authorRevision: 'unused?',
    authorUploadCopyright: '01JXW2T7J6JB2SFQGQRE9B8PCM',
    authorUploadICMJE: '01JXW2T7J6JB2SFQGQRE9B9PCB'
  },
  articleWorkflows: {
    'Original Article': {
      id: '01JXW2T8036P9JP1VF8P6DSX5S',
      formSchemas: {
        authorSubmission: '01K3QMRYH5TH9GHHN7FCB50X4S',
        authorRevision: '01K3QMRYHC406KKQKC9ZSTJ2QF',
        authorChangeRequest: '01K3QMRYHEXJXJX0SRANXSKE1E',
        reviewerFirstAssessment: '01K3QMRYHE46ATAD1EKV4GHRR3'
      },
      checklists: {
        initialAssessment: '01JXW2T70JF3X880P1VRA1TN9',
        immediateRevision: '01JXW2T70JXBGNTEBNPF9PPBNO',
        revision: '01JXW2T70JXBGNTEBNPF9PPBNP',
        revisionAssessment: '01JXW2T70J3MJ2Z3700HW1435D',
        preProduction: '01JXW2T70JSZAHG0YPVP7BNRJV'
      }
    },
    'Systematic Review': {
      id: '01JXW2T8CCZ081D82KB61C7GMC',
      formSchemas: {
        authorSubmission: '01K3QMRYHG1XQ22N4569X2YQK9',
        authorRevision: '01K3QMRYHGT64PN7ZJ3JF1APJC',
        authorChangeRequest: '01K3QMRYHGWG901D37S7VA93AS',
        reviewerFirstAssessment: '01K3QMRYHHKWV634DAQP6MM3GY'
      },
      checklists: {
        initialAssessment: '01JXW2T70JYN2ADZBCV4DGBNJ1',
        immediateRevision: '01JXW2T70JYN2ADZBCV4DGBNJ5',
        revision: '01JXW2T70JYN2ADZBCV4DGBNJ2',
        revisionAssessment: '01JXW2T70JYN2ADZBCV4DGBNJ3',
        preProduction: '01JXW2T70JYN2ADZBCV4DGBNJ4'
      }
    },
    'Meta-Analysis': {
      id: '4WTBVB7YZMDPTHTE2B8GGRQACB',
      formSchemas: {
        authorSubmission: '23A6ZWZPKGBRYKH35AKDA74A68',
        authorRevision: '5PWN2S4BDR68RH58AGS2SMKPR6',
        authorChangeRequest: '6M27WX2WA1JTXX5N2D13HJHT7P',
        reviewerFirstAssessment: '63KPVZV8SFSM6FFK15CC1VXS9M'
      },
      checklists: {
        initialAssessment: '6YNHPNG4CCJJSKPT8M92RZJYWX',
        immediateRevision: '6YNHPNG4CCJJSKPT8M92RZJYWY',
        revision: '4Z9H5991PX5BCAHVV7J7WGQ1WF',
        revisionAssessment: '0TJANEHW0Z3N8CEXKFX9H2VNRK',
        preProduction: '1RFV4SNK68J92XNEWW2Z3P5Y5N'
      }
    },
    Editorial: {
      id: '5Y19TNA2PS69NWHTYD9F9B693J',
      formSchemas: {
        authorSubmission: '1YFBXNHGRP3GZMN44DZYBNRHZR',
        authorRevision: '0D7BKG8NDXF1ADZXV0EY5J2TH7',
        authorChangeRequest: '0CJAABQ7T1Y0NPF9JFN1BY4XQB',
        reviewerFirstAssessment: '3E6N4DXKDPYDK7A27VWJKWRPD6'
      },
      checklists: {
        initialAssessment: '702JSXN2WVQ3NMWNY37E1KVEA5',
        immediateRevision: '702JSXN2WVQ3NMWNY37E1KVEA6',
        revision: '1NFX6576JY9QFCDWQAQYF7291C',
        revisionAssessment: '7KPDT4H69B7NG428GMWXHMZ1W3',
        preProduction: '17P5XYZTGEDV5BJ9V8KF5319GE'
      }
    },
    'Instructional Review': {
      id: '0TBTZRW0GQ2ZE17BRSSJFGJ47Y',
      formSchemas: {
        authorSubmission: '1PHBJ76GWBDM05RSZAMNZ95V2A',
        authorRevision: '0WKQAZRDXCSFM2DFQKWGD78B72',
        authorChangeRequest: '09EX9NSCVRRV6QH1N46130QKBD',
        reviewerFirstAssessment: '0PQWFMKQY5TBQT4NHJ3VK59Q0X'
      },
      checklists: {
        initialAssessment: '241F048WMRC5GKFVVZP53XVY4A',
        immediateRevision: '241F048WMRC5GKFVVZP53XVY4B',
        revision: '6HPJ6Z4YZPWBNPJ4XHX587W2J0',
        revisionAssessment: '7CTG1W05ECZCC27DT5N7NVX03N',
        preProduction: '5XN5YHB9KWDD4P4DC4N0FAVTB6'
      }
    },
    'Randomised Controlled Trial': {
      id: '3KDETT8FR5SDQHMSEE15C31FET',
      formSchemas: {
        authorSubmission: '60NEFSSKJVDRBR6FE0VF8M22NJ',
        authorRevision: '5RFKMGAKWJWV080SKTS717P64C',
        authorChangeRequest: '4ADENMCC321Q4NR2200423W824',
        reviewerFirstAssessment: '74541P7Y4535XH67V9T7CP3NH5'
      },
      checklists: {
        initialAssessment: '18YX0X7BGV30CK2EN3HH17X2GH',
        immediateRevision: '18YX0X7BGV30CK2EN3HH17X2GI',
        revision: '64MMRF9JH3GZC49T0PH4DWVBJV',
        revisionAssessment: '6RDGWWWNK1SQ67SR46MD5RBTYY',
        preProduction: '06SSJ2430AS1GS6P9QDMR989GM'
      }
    },
    Annotation: {
      id: '3SE0BD0WC6A5RGHKF6QEKXM9G5',
      formSchemas: {
        authorSubmission: '32NXVY6KS83PASF3EFZBNM8WRT',
        authorRevision: '4Z6D51M3Z0NQCM93WE8AB6QN4X',
        authorChangeRequest: '4VKY7DHXVJW0M82QTDKX4021DH',
        reviewerFirstAssessment: '7W750KFJW0MZFK4R0FSGMF16VN'
      },
      checklists: {
        initialAssessment: '0E3Z2JGX5MDHEH4A66VD658EKD',
        immediateRevision: '0E3Z2JGX5MDHEH4A66VD658EKE',
        revision: '3KCJ4R5C51TNZPXH1GWS0XNY0H',
        revisionAssessment: '22PF09Y06XHXA66XYM91V09ETM',
        preProduction: '2Q4A7N4XT5KPCQ0N9HBP4C7HTX'
      }
    },
    Others: {
      id: '3SE0BD0WC6A5RGHKF6GEKXM9G5',
      formSchemas: {
        authorSubmission: '32NXVY6KS83WASF3EFZBNM8WRT',
        authorRevision: '4Z6D51M3U0NQCM93WE8AB6QN4X',
        authorChangeRequest: '4VKY7DIXVJW0M82QTDKX4021DH',
        reviewerFirstAssessment: '7W750KFJI0MZFK4R0FSGMF16VN'
      },
      checklists: {
        initialAssessment: '0E3Z2JGX5MPHEH4A66VD658EKD',
        immediateRevision: '0E3Z2JGX5MPHEH4A66VD658EKF',
        revision: '3KCJ4R5C51TNZPXP1GWS0XNY0H',
        revisionAssessment: '22PF09O06XHXA66XYM91V09ETM',
        preProduction: '2Q4A7N4TT5KPCQ0N9HBP4C7HTX'
      }
    }
  }
};

export const bjjStaticIds: SeedDataStaticIds<typeof bjjData> = {
  baseFormSchemas: {
    editorRevisionRequest: '01K974MS6CJ357PM87M0JNFK9D',
    editorialWithdrawSubmission: '01K974MS6CRRXG840SY3RMFA1P',
    editorialOfferTransfer: '01K974MS6C585C2PJG9QYYBGCM',
    editorialRejectSubmission: '01K974MS6DMFGRWVV93DXQD1JT',
    authorWithdrawSubmission: '01K974MS6DR3KV3NNK7A9KEB97',
    editorialUnsubmit: '01K974MS6D6SV3QN3ERTEZF0F1',
    reviewerFirstAssessment: '01K974MS6DKFW6BBHNQPFEYBPF',
    reviewerRevisionAssessment: '01K974MS6DRZP5XF74BB7TVE5K',
    editorialLicensing: '01K974MS6D16J7QKQ2GZSGFKH6',
    externalEarlyAssessment: '01K974MS6D1GVVBK07JT7CT58A',
    expertAssessment: '01K974MS6DVS290KS5H65HAV0E',
    externalAdjudication: '01K974MS6DV6FKMEBWGD5QGARN',
    adjudicationAssessment: '01K974MS6DTNM8J6GN2T4N9820',
    authorCopyrightSubmission: '01K974MS6EPYB99A5Q8XD9N31J',
    editorialUploadCopyright: '01K974MS6E9CEQTN24AMWZWF8Z',
    inviteCoReviewer: '01K974MS6EDKV25ZQJMXKCDVA3',
    authorSubmission: 'unused?',
    authorRevision: 'unused?',
    authorUploadCopyright: '01K974MS6ESDKAKFKV3P2FNA5Q'
  },
  articleWorkflows: {
    'Original Article': {
      id: '01K974D6S005M6A83MZE320GG8',
      formSchemas: {
        authorSubmission: '01K974MS6E0R4BXJ8FY06CJFNJ',
        authorRevision: '01K974MS6E3X2B81PQBZYCRBMC',
        authorChangeRequest: '01K974MS6EP1ZT94V4Q0GEGNT0',
        reviewerFirstAssessment: '01K974MS6E4E8JF5J9YS87JGZW'
      },
      checklists: {
        initialAssessment: '01K974MS6E3952TFGR4JB71BQ3',
        revision: '01K974MS6ERB7V1TVGCQKFR04Y',
        revisionAssessment: '01K974MS6E8Q657W9SX19KT5X2',
        preProduction: '01K974MS6EPX84SX5EB9JYD13B'
      }
    },
    Editorial: {
      id: '01K974DK72SRTTH7G74G27SVT2',
      formSchemas: {
        authorSubmission: '01K2M4N6P8Q0R2S4T6U8V0W3B3',
        authorRevision: '01K2M4N6P8Q0R2S4T6U8V0W3B4',
        authorChangeRequest: '01K2M4N6P8Q0R2S4T6U8V0W3B5',
        reviewerFirstAssessment: '01K2M4N6P8Q0R2S4T6U8V0W3B6'
      },
      checklists: {
        initialAssessment: '01K2M4N6P8Q0R2S4T6U8V0W3B7',
        revision: '01K2M4N6P8Q0R2S4T6U8V0W3B8',
        revisionAssessment: '01K2M4N6P8Q0R2S4T6U8V0W3B9',
        preProduction: '01K2M4N6P8Q0R2S4T6U8V0W3C0'
      }
    },
    Annotation: {
      id: '01K974DX1C21PT6R00YC2RX73N',
      formSchemas: {
        authorSubmission: '01K2M4N6P8Q0R2S4T6U8V0W3C4',
        authorRevision: '01K2M4N6P8Q0R2S4T6U8V0W3C5',
        authorChangeRequest: '01K2M4N6P8Q0R2S4T6U8V0W3C6',
        reviewerFirstAssessment: '01K2M4N6P8Q0R2S4T6U8V0W3C7'
      },
      checklists: {
        initialAssessment: '01K2M4N6P8Q0R2S4T6U8V0W3C8',
        revision: '01K2M4N6P8Q0R2S4T6U8V0W3C9',
        revisionAssessment: '01K2M4N6P8Q0R2S4T6U8V0W3D0',
        preProduction: '01K2M4N6P8Q0R2S4T6U8V0W3D1'
      }
    },
    Others: {
      id: '01K974E6V7BVPA428V12MF24KG',
      formSchemas: {
        authorSubmission: '01K2M4N6P8Q0R2S4T6U8V0W3D5',
        authorRevision: '01K2M4N6P8Q0R2S4T6U8V0W3D6',
        authorChangeRequest: '01K2M4N6P8Q0R2S4T6U8V0W3D7',
        reviewerFirstAssessment: '01K2M4N6P8Q0R2S4T6U8V0W3D8'
      },
      checklists: {
        initialAssessment: '01K2M4N6P8Q0R2S4T6U8V0W3D9',
        revision: '01K2M4N6P8Q0R2S4T6U8V0W3E0',
        revisionAssessment: '01K2M4N6P8Q0R2S4T6U8V0W3E1',
        preProduction: '01K2M4N6P8Q0R2S4T6U8V0W3E2'
      }
    },
    'Review Article': {
      id: '01K974EFAHDKVJ6QD74B5H4Q4A',
      formSchemas: {
        authorSubmission: '01K2M4N6P8Q0R2S4T6U8V0W3E6',
        authorRevision: '01K2M4N6P8Q0R2S4T6U8V0W3E7',
        authorChangeRequest: '01K2M4N6P8Q0R2S4T6U8V0W3E8',
        reviewerFirstAssessment: '01K2M4N6P8Q0R2S4T6U8V0W3E9'
      },
      checklists: {
        initialAssessment: '01K2M4N6P8Q0R2S4T6U8V0W3F0',
        revision: '01K2M4N6P8Q0R2S4T6U8V0W3F1',
        revisionAssessment: '01K2M4N6P8Q0R2S4T6U8V0W3F2',
        preProduction: '01K2M4N6P8Q0R2S4T6U8V0W3F3'
      }
    }
  }
};

export const bjoStaticIds: SeedDataStaticIds<typeof bjoData> = {
  baseFormSchemas: {
    editorRevisionRequest: '01K974MS69DZ6F2A2QE4RNT7BZ',
    editorialWithdrawSubmission: '01K974MS6AF858090Q75QPRZG1',
    editorialOfferTransfer: '01K974MS6B4WC25WVKT63Y2X62',
    editorialRejectSubmission: '01K974MS6BS8CG9XZY93S3B0H0',
    authorWithdrawSubmission: '01K974MS6B8NG54NCR20X2F07A',
    editorialUnsubmit: '01K974MS6B5GWAH4W1GSYBQKYM',
    reviewerFirstAssessment: '01K974MS6B9F9EHHRECJWHPPSD',
    reviewerRevisionAssessment: '01K974MS6B2ZWC5RY85FECRD94',
    editorialLicensing: '01K974MS6B3J24WV8GKE5BYWHS',
    externalEarlyAssessment: '01K974MS6B5E65RXQ8KQWQQF2P',
    expertAssessment: '01K974MS6BGE9RMHD5ZVVCR74B',
    externalAdjudication: '01K974MS6C6QV78SB8M4TEPZD4',
    adjudicationAssessment: '01K974MS6C1R7DF3A0N00VCN1E',
    authorCopyrightSubmission: '01K974MS6C482W78AHRP0QGREC',
    editorialUploadCopyright: '01K974MS6C8RHNRH705RVABV90',
    inviteCoReviewer: '01K974MS6CTGKCBYMVPJ5SB9P5',
    authorSubmission: 'unused?',
    authorRevision: 'unused?',
    authorUploadCopyright: '01K974MS6CSE2PHTS1Z29DBWE0'
  },
  articleWorkflows: {
    'Original Article': {
      id: '01K9745TEGH43XSKMJ607M8P3M',
      formSchemas: {
        authorSubmission: '01K974MS6CRT45G3ZBQZMY7WX8',
        authorRevision: '01K974MS6CR342FYJ2CB8Q45F2',
        authorChangeRequest: '01K974MS6CYW4769WN90CJJZXY',
        reviewerFirstAssessment: '01K974MS6CGDQENF1VHWFP0W5V'
      },
      checklists: {
        initialAssessment: '01K2M4N6P8Q0R2S4T6U8V0W4A6',
        revision: '01K2M4N6P8Q0R2S4T6U8V0W4A7',
        revisionAssessment: '01K2M4N6P8Q0R2S4T6U8V0W4A8',
        preProduction: '01K2M4N6P8Q0R2S4T6U8V0W4A9'
      }
    },
    'Systematic Review': {
      id: '03JXW2T8CCZ081D82KB61C8GMC',
      formSchemas: {
        authorSubmission: '01K2M4N6P8Q0R2S4T6U8V0W4B2',
        authorRevision: '01K2M4N6P8Q0R2S4T6U8V0W4B3',
        authorChangeRequest: '01K2M4N6P8Q0R2S4T6U8V0W4B4',
        reviewerFirstAssessment: '01K2M4N6P8Q0R2S4T6U8V0W4B5'
      },
      checklists: {
        initialAssessment: '01K2M4N6P8Q0R2S4T6U8V0W4B6',
        revision: '01K2M4N6P8Q0R2S4T6U8V0W4B7',
        revisionAssessment: '01K2M4N6P8Q0R2S4T6U8V0W4B8',
        preProduction: '01K2M4N6P8Q0R2S4T6U8V0W4B9'
      }
    },
    'Meta-Analysis': {
      id: '01K974A53XYV2YFBGSE0E4FT62',
      formSchemas: {
        authorSubmission: '01K2M4N6P8Q0R2S4T6U8V0W4C2',
        authorRevision: '01K2M4N6P8Q0R2S4T6U8V0W4C3',
        authorChangeRequest: '01K2M4N6P8Q0R2S4T6U8V0W4C4',
        reviewerFirstAssessment: '01K2M4N6P8Q0R2S4T6U8V0W4C5'
      },
      checklists: {
        initialAssessment: '01K2M4N6P8Q0R2S4T6U8V0W4C6',
        revision: '01K2M4N6P8Q0R2S4T6U8V0W4C7',
        revisionAssessment: '01K2M4N6P8Q0R2S4T6U8V0W4C8',
        preProduction: '01K2M4N6P8Q0R2S4T6U8V0W4C9'
      }
    },
    Editorial: {
      id: '01K974AGXXY58CNCQVVCN6S5GF',
      formSchemas: {
        authorSubmission: '01K2M4N6P8Q0R2S4T6U8V0W4D2',
        authorRevision: '0D7BKG8NDXF1ADZXV0EY5J2TH9',
        authorChangeRequest: '0CJAABQ7T1Y0NPF9JFN1BY4XQC',
        reviewerFirstAssessment: '3E6N4DXKDPYDK7A27VWJKWRPD8'
      },
      checklists: {
        initialAssessment: '702JSXN2WVQ3NMWNY37E1KVEN5',
        revision: '1NFX6576JY9QFCDWQIQYF7291C',
        revisionAssessment: '7KPDT4H69B7PG428GMWXHMZ1W3',
        preProduction: '17P5XYZTGEDV5BJ9V0KF5319GE'
      }
    },
    'Instructional Review': {
      id: '0TBTZRW0GQ2ZE17BRSSJFGJ44D',
      formSchemas: {
        authorSubmission: '1PHBJ76GWBDM05RSZAMNZ95V8G',
        authorRevision: '0WKQAZRDXCSFM2DFQKWGD78B09',
        authorChangeRequest: '09EX9NSCVRRV6QH1N46130QKIJ',
        reviewerFirstAssessment: '0PQWFMKQY5TBQT4NHJ3VK59Q9P'
      },
      checklists: {
        initialAssessment: '241F048WMRC5GKFVVZP53XVI8A',
        revision: '6HPJ6Z4YZPWBJPJ4XHX587W2J0',
        revisionAssessment: '7CTG1W05TCZCC27DT5N7NVX03N',
        preProduction: '5XN5YHB9KWDF4P4DC4N0FAVTB6'
      }
    },
    Annotation: {
      id: '01K974B41BWWQS1VQB4SW77ATG',
      formSchemas: {
        authorSubmission: '60NEFSSKJVDRBR6FE0PO8M22NJ',
        authorRevision: '5RFKMGAKWPOV080SKTS717P64C',
        authorChangeRequest: '4ADENMCC091Q4NR2200423W824',
        reviewerFirstAssessment: '74541P7Y4895XH67V9T7CP3NH5'
      },
      checklists: {
        initialAssessment: '18YX0X7BGV89CK2EN3HH17X2GH',
        revision: '64MMRF9JH3GZC67T0PH4DWVBJV',
        revisionAssessment: '6RDGWWWNK1SQ56SR46MD5RBTYY',
        preProduction: '06SPO2430AS1GS6P9QDMR989GM'
      }
    },
    Others: {
      id: '3SE0BD0WC6A5RGHKF0GEKXM9G5',
      formSchemas: {
        authorSubmission: '32NXVY9KS83WASF3EFZBNM8WRT',
        authorRevision: '4Z6D51M6U0NQCM93WE8AB6QN4X',
        authorChangeRequest: '9VKY7DIXVJW0M82QTDKX4021DH',
        reviewerFirstAssessment: '9W750KFJI0MZFK4R0FSGMF16VN'
      },
      checklists: {
        initialAssessment: '0E3Z2JGX5MPHEH9A66VD658EKD',
        revision: '3KCJ4R5C51TNZPXP1GWS0XNY9H',
        revisionAssessment: '22PF09O06XHXA66XYM91V99ETM',
        preProduction: '2Q4A7N4TT5KPCQ0N9HBP0C7HTX'
      }
    },
    Protocol: {
      id: '6SE0BD0WC6A5RGHKF6GEKXM9G5',
      formSchemas: {
        authorSubmission: '62NXVY6KS83WASF3EFZBNM8WRT',
        authorRevision: '4Z6D51M3U0NQCM63WE8AB6QN4X',
        authorChangeRequest: '4VKY7DIXVJW0M62QTDKX4021DH',
        reviewerFirstAssessment: '7W750KFJI0MZFK6R0FSGMF16VN'
      },
      checklists: {
        initialAssessment: '0E3Z2JGX6MPHEH4A66VD658EKD',
        revision: '3KCJ4R5C51TNZPXP6GWS0XNY0H',
        revisionAssessment: '22PF09O66XHXA66XYM91V09ETM',
        preProduction: '2Q4A7N4TT5KPCQ0N9HBP6C7HTX'
      }
    }
  }
};

export const bnjtestStaticIds: SeedDataStaticIds<typeof bnjtestData> = {
  baseFormSchemas: {
    editorRevisionRequest: '01JXW2T7HW6HQCKXMJP7JXB8AH',
    editorialWithdrawSubmission: '01JXW2T7HW87T8BQBMA2ZFZP8D',
    editorialOfferTransfer: '01JXW2T7HXMNDKZWDERS9PC3KG',
    editorialRejectSubmission: '01JXW2T7HXPCE56WJENRBY13H4',
    authorWithdrawSubmission: '01JXW2T7HXJK7YC9QR76K895QC',
    editorialUnsubmit: '01JXW2T7HXCW0Y5C1E4Q03P787',
    reviewerFirstAssessment: '01JXW2T7J1KX3CVDX1YH3F0NM4',
    reviewerRevisionAssessment: '01JXW2T7J450QP8CXHN5KD8N8Y',
    editorialLicensing: '01JXW2T7J4G5X2B9FC248NZCRS',
    externalEarlyAssessment: '01JXW2T7J5MMQDTXCXJEZY01CT',
    expertAssessment: '01JXW2T7J5X7DE3YJ7CRJE7NWF',
    externalAdjudication: '01JXW2T7J5TAKHAV6V1C6HWTE2',
    adjudicationAssessment: '01JXW2T7J57H26HSGXZ7RFAZVN',
    authorCopyrightSubmission: '01JXW2T7J52W0NV7DWKMV9PE2R',
    editorialUploadCopyright: '01JXW2T7J6JB2SFQGQRE9B9TCB',
    inviteCoReviewer: '01JXW2T7J60TNCHDT3M9FPAXGS',
    authorSubmission: 'unused?',
    authorRevision: 'unused?'
  },
  articleWorkflows: {
    'Original Article': {
      id: '01JXW2T8036P9JP1VF8P6DSX7S',
      formSchemas: {
        authorSubmission: '01JXW2T7JBZC3BTTWFZ8KL1RVP',
        authorRevision: '01JXW2T7JE13TY91Z6KH5NGKC9',
        authorChangeRequest: '01JXW2T7JGE4GKH5ZY8R1EGSKV',
        reviewerFirstAssessment: '01JXW2T7JBNG3HGH7SGH71KVWB'
      },
      checklists: {
        initialAssessment: '01JXW2T70JF3X880P1VRA1TND9',
        revision: '01JXW2T70JXBGNTEBNPF9PPXJP',
        revisionAssessment: '01JXW2T70J3MJ2Z3700HW1456D',
        preProduction: '01JXW2T70JSZAHG0YPVP7PMRJV'
      }
    },
    'Systematic Review': {
      id: '01JXW2T8CCZ081D82KB61C7G7C',
      formSchemas: {
        authorSubmission: 'F083FD0801674445AC9C9C57A8',
        authorRevision: '01JXW2T82XR0DT9SVVGFXDMY6W',
        authorChangeRequest: '01JXW2T82ZB48KEKRVEER30060',
        reviewerFirstAssessment: '01JXW2T82VHKH1854FTER1ZVXM'
      },
      checklists: {
        initialAssessment: '01JXW2T70JYN2ADZBCV4DG82TJ',
        revision: '01JXW2T70JR360FJ2N7QTSQ1CP',
        revisionAssessment: '01JXW2T70JN32TX8ZYTR7HAXD8',
        preProduction: '01JXW2T70KKSCGEQEYRTJS1F8W'
      }
    }
  }
};

export const tfbStaticIds: SeedDataStaticIds<typeof tfbData> = {
  baseFormSchemas: {
    editorRevisionRequest: '01JXW2T7HW6HQCKXMJP7JXB9AG',
    editorialWithdrawSubmission: '01JXW2T7HW87T8BQBMA2ZFZP9E',
    editorialOfferTransfer: '01JXW2T7HXMNDKZWDERS9PC9KH',
    editorialRejectSubmission: '01JXW2T7HXPCE56WJENRBY19H5',
    authorWithdrawSubmission: '01JXW2T7HXJK7YC9QR76K899QD',
    editorialUnsubmit: '01JXW2T7HXCW0Y5C1E4Q03P988',
    reviewerFirstAssessment: '01JXW2T7J1KX3CVDX1YH3F0NM9',
    reviewerRevisionAssessment: '01KXW2T7J450QP8CXHN5KD8N8Z',
    editorialLicensing: '01JXW2T7J4G5X2B9FC248NZ7RT',
    externalEarlyAssessment: '01JXW2T7J5MMQDTXCXJEZY03CU',
    expertAssessment: '01JXW2T7J5X7DE3YJ7CRJE8NWG',
    externalAdjudication: '01JXW2T7J5TAKHAV6V1C6HWTE6',
    adjudicationAssessment: '01JXW3T7J57H26HSGXZ7RFAZVO',
    authorCopyrightSubmission: '01JXW2T7J52W0NV7DWKMV9PE3S',
    editorialUploadCopyright: '01JXW2T7J6JB2SFQGQRE9B7TCC',
    editorialUploadICMJE: '01JXW2T7J60TNCHDT3M9FPAUOM',
    inviteCoReviewer: '01JXW2T7J60TNCHDT3M9FPAXTT',
    authorSubmission: 'unused?',
    authorRevision: 'unused?',
    authorUploadCopyright: '01JXW2T7J6JB2SFQGQRE9B8PCN',
    authorUploadICMJE: '01JXW2T7J6JB2SFQGQRE9B9PCC'
  },
  articleWorkflows: {
    'Article for Peer Review': {
      id: '01JXW2T8036P9JP1VF8P6DSX5T',
      formSchemas: {
        authorSubmission: '01K3QMRYH5TH9GHHN7FCB50X4T',
        authorRevision: '01K3QMRYHC406KKQKC9ZSTJ2QG',
        authorChangeRequest: '01K3QMRYHEXJXJX0SRANXSKE1F',
        reviewerFirstAssessment: '01K3QMRYHE46ATAD1EKV4GHRR4'
      },
      checklists: {
        initialAssessment: '01JXW2T70JF3X880P1VRA1TO0',
        immediateRevision: '01JXW2T70JXBGNTEBNPF9PPBMP',
        revision: '01JXW2T70JXBGNTEBNPF9PPBNQ',
        revisionAssessment: '01JXW2T70J3MJ2Z3700HW1435E',
        preProduction: '01JXW2T70JSZAHG0YPVP7BNRJW'
      }
    },
    Article: {
      id: '01JXW2T8036P9JP1VF8P6DSY5S',
      formSchemas: {
        authorSubmission: '01K3QMRYH5TH9GHHN7FCB50Y4S',
        authorRevision: '01K3QMRYHC406KKQKC9ZSTJ3QF',
        authorChangeRequest: '01K3QMRYHEXJXJX0SRANXSKF1E',
        reviewerFirstAssessment: '01K3QMRYHE46ATAD1EKV4GHSR3'
      },
      checklists: {
        initialAssessment: '01JXW2T70JF3X880P1VRA1PN9',
        immediateRevision: '01JXW2T70JXBGNTEBNPF9PPCNT',
        revision: '01JXW2T70JXBGNTEBNPF9PPCNP',
        revisionAssessment: '01JXW2T70J3MJ2Z3700HW1445D',
        preProduction: '01JXW2T70JSZAHG0YPVP7BNSJV'
      }
    },
    'Research Commentary/Essay': {
      id: '01JXW2T8CCZ081D82KB61C7GMD',
      formSchemas: {
        authorSubmission: '01K3QMRYHG1XQ22N4569X2YQR0',
        authorRevision: '01K3QMRYHGT64PN7ZJ3JF1APJD',
        authorChangeRequest: '01K3QMRYHGWG901D37S7VA93AT',
        reviewerFirstAssessment: '01K3QMRYHHKWV634DAQP6MM3GZ'
      },
      checklists: {
        initialAssessment: '01JXW2T70JYN2ADZBCV4DGBNK2',
        immediateRevision: '01JXW2T70JYN2ADZBCV4DGBNK6',
        revision: '01JXW2T70JYN2ADZBCV4DGBNK3',
        revisionAssessment: '01JXW2T70JYN2ADZBCV4DGBNK5',
        preProduction: '01JXW2T70JYN2ADZBCV4DGBNK4'
      }
    },
    'Book Review': {
      id: '4WTBVB7YZMDPTHTE2B8GGRQACC',
      formSchemas: {
        authorSubmission: '23A6ZWZPKGBRYKH35AKDA74A69',
        authorRevision: '5PWN2S4BDR68RH58AGS2SMKPR7',
        authorChangeRequest: '6M27WX2WA1JTXX5N2D13HJHT7Q',
        reviewerFirstAssessment: '63KPVZV8SFSM6FFK15CC1VXS9N'
      },
      checklists: {
        initialAssessment: '6YNHPNG4CCJJSKPT8M92RZJYZZ',
        immediateRevision: '6YNHPNG4CCJJSKPT8M92RZJYWZ',
        revision: '4Z9H5991PX5BCAHVV7J7WGQ1WG',
        revisionAssessment: '0TJANEHW0Z3N8CEXKFX9H2VNRQ',
        preProduction: '1RFV4SNK68J92XNEWW2Z3P5Y5Q'
      }
    },
    Editorial: {
      id: '5Y19TNA2PS69NWHTYD9F9B693K',
      formSchemas: {
        authorSubmission: '1YFBXNHGRP3GZMN44DZYBNRHZS',
        authorRevision: '0D7BKG8NDXF1ADZXV0EY5J2TH8',
        authorChangeRequest: '0CJAABQ7T1Y0NPF9JFN1BY4XRC',
        reviewerFirstAssessment: '3E6N4DXKDPYDK7A27VWJKWRPD7'
      },
      checklists: {
        initialAssessment: '702JSXN2WVQ3NMWNY37E1KVEB6',
        immediateRevision: '702JSXN2WVQ3NMWNY37E1KVEA7',
        revision: '1NFX6576JY9QFCDWQAQYF7291D',
        revisionAssessment: '7KPDT4H69B7NG428GMWXHMZ1W4',
        preProduction: '17P5XYZTGEDV5BJ9V8KF5319GF'
      }
    }
  }
};

export const nsfStaticIds: SeedDataStaticIds<typeof nsfData> = {
  baseFormSchemas: {
    editorRevisionRequest: '01JXW2T7HW6HQCKXMJP7JXB9BG',
    editorialWithdrawSubmission: '01JXW2T7HW87T8BQBMA2ZFZQ9E',
    editorialOfferTransfer: '01JXW2T7HXMNDKZWDERS9PC9CH',
    editorialRejectSubmission: '01JXW2T7HXPCE56WJENRBY19P5',
    authorWithdrawSubmission: '01JXW2T7HXJK7YC9QR76K898QD',
    editorialUnsubmit: '01JXW2T7HXCW0Y5C1E4Q03P978',
    reviewerFirstAssessment: '01JXW2T7J1KX3CVDX1YH3F0NQ9',
    reviewerRevisionAssessment: '01KXW2T7J450QP8CXHN5KD8P8Z',
    editorialLicensing: '01JXW2T7J4G5X2B9FC248NZ7QT',
    externalEarlyAssessment: '01JXW2T7J5MMQDTXCXJEZY03CK',
    expertAssessment: '01JXW2T7J5X7DE3YJ7CRJE8NMG',
    externalAdjudication: '01JXW2T7J5TAKHAV6V1C6HWTN6',
    adjudicationAssessment: '01JXW3T7J57H26HSGXZ7RFAZQK',
    authorCopyrightSubmission: '01JXW2T7J52W0NV7DWKMV9PP3S',
    editorialUploadCopyright: '01JXW2T7J6JB2SFQGQRE9B7QCC',
    editorialUploadICMJE: '01JXW2T7J60TNCHDT3M9FPAPPM',
    inviteCoReviewer: '01JXW2T7J60TNCHDT3M9FPAXWT',
    authorSubmission: 'unused?',
    authorRevision: 'unused?',
    authorUploadCopyright: '01JXW2T7J6JB2SFQGQRE9B8PTN',
    authorUploadICMJE: '01JXW2T7J6JB2SFQGQRE9B9PJC'
  },
  articleWorkflows: {
    'Article for Peer Review': {
      id: '01JXW2T8036P9JP1VF8P6DSY5T',
      formSchemas: {
        authorSubmission: '01K3QMRYH5TH9GHHN7FCB50N4T',
        authorRevision: '01K3QMRYHC406KKQKC9ZSTJ3QG',
        authorChangeRequest: '01K3QMRYHEXJXJX0SRANXSKW1F',
        reviewerFirstAssessment: '01K3QMRYHE46ATAD1EKV4GHMR4'
      },
      checklists: {
        initialAssessment: '01JXW2T70JF3X880P1VRA1TK0',
        immediateRevision: '01JXW2T70JXBGNTEBNPF9PPJMP',
        revision: '01JXW2T70JXBGNTEBNPF9PPBNT',
        revisionAssessment: '01JXW2T70J3MJ2Z3700HW1436E',
        preProduction: '01JXW2T70JSZAHG0YPVP7BNTJW'
      }
    },
    'Protocol for Peer Review': {
      id: '01JXW2T8036P9JP1VF8P6DST5S',
      formSchemas: {
        authorSubmission: '01K3QMRYH5TH9GHHN7FCB50T4S',
        authorRevision: '01K3QMRYHC406KKQKC9ZSTJ5QF',
        authorChangeRequest: '01K3QMRYHEXJXJX0SRANXSKF2E',
        reviewerFirstAssessment: '01K3QMRYHE46ATAD1EKV4GHSR4'
      },
      checklists: {
        initialAssessment: '01JXW2T70JF3X880P1VRA1QN9',
        immediateRevision: '01JXW2T70JXBGNTEBNPF9PPBT',
        revision: '01JXW2T70JXBGNTEBNPF9PPC2P',
        revisionAssessment: '01JXW2T70J3MJ2Z3700HW1465D',
        preProduction: '01JXW2T70JSZAHG0YPVP7BN6JV'
      }
    },
    Editorial: {
      id: '4WTBVB7YZMDPTHTE2B8GGRQABC',
      formSchemas: {
        authorSubmission: '23A6ZWZPKGBRYKH35AKDA74A79',
        authorRevision: '5PWN2S4BDR68RH58AGS2SMKPR8',
        authorChangeRequest: '6M27WX2WA1JTXX5N2D13HJHT8Q',
        reviewerFirstAssessment: '63KPVZV8SFSM6FFK15CC1VXQ9N'
      },
      checklists: {
        initialAssessment: '6YNHPNG4CCJJSKPT8M92RZJY2Z',
        immediateRevision: '6YNHPNG4CCJJSKPT8M92RZJY3Z',
        revision: '4Z9H5991PX5BCAHVV7J7WGQ14G',
        revisionAssessment: '0TJANEHW0Z3N8CEXKFX9H2VN5Q',
        preProduction: '1RFV4SNK68J92XNEWW2Z3P5Y6Q'
      }
    }
  }
};

export const nptStaticIds: SeedDataStaticIds<typeof nptData> = {
  baseFormSchemas: {
    editorRevisionRequest: '04JXW2T7HW6HQCKXMJP7JXB9BG',
    editorialWithdrawSubmission: '04JXW2T7HW87T8BQBMA2ZFZQ9E',
    editorialOfferTransfer: '04JXW2T7HXMNDKZWDERS9PC9CH',
    editorialRejectSubmission: '04JXW2T7HXPCE56WJENRBY19P5',
    authorWithdrawSubmission: '04JXW2T7HXJK7YC9QR76K898QD',
    editorialUnsubmit: '04JXW2T7HXCW0Y5C1E4Q03P978',
    reviewerFirstAssessment: '04JXW2T7J1KX3CVDX1YH3F0NQ9',
    reviewerRevisionAssessment: '04KXW2T7J450QP8CXHN5KD8P8Z',
    editorialLicensing: '04JXW2T7J4G5X2B9FC248NZ7QT',
    externalEarlyAssessment: '04JXW2T7J5MMQDTXCXJEZY03CK',
    expertAssessment: '04JXW2T7J5X7DE3YJ7CRJE8NMG',
    externalAdjudication: '04JXW2T7J5TAKHAV6V1C6HWTN6',
    adjudicationAssessment: '04JXW3T7J57H26HSGXZ7RFAZQK',
    authorCopyrightSubmission: '04JXW2T7J52W0NV7DWKMV9PP3S',
    editorialUploadCopyright: '04JXW2T7J6JB2SFQGQRE9B7QCC',
    editorialUploadICMJE: '04JXW2T7J60TNCHDT3M9FPAPPM',
    inviteCoReviewer: '04JXW2T7J60TNCHDT3M9FPAXWT',
    authorSubmission: 'unused?',
    authorRevision: 'unused?',
    authorUploadCopyright: '04JXW2T7J6JB2SFQGQRE9B8PTN',
    authorUploadICMJE: '04JXW2T7J6JB2SFQGQRE9B9PJC'
  },
  articleWorkflows: {
    'Article for Peer Review': {
      id: '04JXW2T8036P9JP1VF8P6DSY5T',
      formSchemas: {
        authorSubmission: '04K3QMRYH5TH9GHHN7FCB50N4T',
        authorRevision: '04K3QMRYHC406KKQKC9ZSTJ3QG',
        authorChangeRequest: '04K3QMRYHEXJXJX0SRANXSKW1F',
        reviewerFirstAssessment: '04K3QMRYHE46ATAD1EKV4GHMR4'
      },
      checklists: {
        initialAssessment: '04JXW2T70JF3X880P1VRA1TK0',
        immediateRevision: '04JXW2T70JXBGNTEBNPF9PPJMP',
        revision: '04JXW2T70JXBGNTEBNPF9PPBNT',
        revisionAssessment: '04JXW2T70J3MJ2Z3700HW1436E',
        preProduction: '04JXW2T70JSZAHG0YPVP7BNTJW'
      }
    },
    'Book Review': {
      id: '04JXW2T8036P9JP1VF8P6DST5S',
      formSchemas: {
        authorSubmission: '04K3QMRYH5TH9GHHN7FCB50T4S',
        authorRevision: '04K3QMRYHC406KKQKC9ZSTJ5QF',
        authorChangeRequest: '04K3QMRYHEXJXJX0SRANXSKF2E',
        reviewerFirstAssessment: '04K3QMRYHE46ATAD1EKV4GHSR4'
      },
      checklists: {
        initialAssessment: '04JXW2T70JF3X880P1VRA1QN9',
        immediateRevision: '04JXW2T70JXBGNTEBNPF9PPBT',
        revision: '04JXW2T70JXBGNTEBNPF9PPC2P',
        revisionAssessment: '04JXW2T70J3MJ2Z3700HW1465D',
        preProduction: '04JXW2T70JSZAHG0YPVP7BN6JV'
      }
    },
    'Feature Article': {
      id: '04JXB2T8036P9JP1VF8P6DST5S',
      formSchemas: {
        authorSubmission: '04B3QMRYH5TH9GHHN7FCB50T4S',
        authorRevision: '04B3QMRYHC406KKQKC9ZSTJ5QF',
        authorChangeRequest: '04B3QMRYHEXJXJX0SRANXSKF2E',
        reviewerFirstAssessment: '04B3QMRYHE46ATAD1EKV4GHSR4'
      },
      checklists: {
        initialAssessment: '04BXW2T70JF3X880P1VRA1QN9',
        immediateRevision: '04BXW2T70JXBGNTEBNPF9PPBT',
        revision: '04BXW2T70JXBGNTEBNPF9PPC2P',
        revisionAssessment: '04BXW2T70J3MJ2Z3700HW1465D',
        preProduction: '04BXW2T70JSZAHG0YPVP7BN6JV'
      }
    },
    Essay: {
      id: '04JXA2T8036P9JP1VF8P6DST5S',
      formSchemas: {
        authorSubmission: '04A3QMRYH5TH9GHHN7FCB50T4S',
        authorRevision: '04A3QMRYHC406KKQKC9ZSTJ5QF',
        authorChangeRequest: '04A3QMRYHEXJXJX0SRANXSKF2E',
        reviewerFirstAssessment: '04A3QMRYHE46ATAD1EKV4GHSR4'
      },
      checklists: {
        initialAssessment: '04AXW2T70JF3X880P1VRA1QN9',
        immediateRevision: '04AXW2T70JXBGNTEBNPF9PPBT',
        revision: '04AXW2T70JXBGNTEBNPF9PPC2P',
        revisionAssessment: '04AXW2T70J3MJ2Z3700HW1465D',
        preProduction: '04AXW2T70JSZAHG0YPVP7BN6JV'
      }
    }
  }
};

export const samtalStaticIds: SeedDataStaticIds<typeof samtalData> = {
  baseFormSchemas: {
    editorRevisionRequest: '05JXW2T7HW6HQCKXMJP7JXB9BG',
    editorialWithdrawSubmission: '05JXW2T7HW87T8BQBMA2ZFZQ9E',
    editorialOfferTransfer: '05JXW2T7HXMNDKZWDERS9PC9CH',
    editorialRejectSubmission: '05JXW2T7HXPCE56WJENRBY19P5',
    authorWithdrawSubmission: '05JXW2T7HXJK7YC9QR76K898QD',
    editorialUnsubmit: '05JXW2T7HXCW0Y5C1E4Q03P978',
    reviewerFirstAssessment: '05JXW2T7J1KX3CVDX1YH3F0NQ9',
    reviewerRevisionAssessment: '05KXW2T7J450QP8CXHN5KD8P8Z',
    editorialLicensing: '05JXW2T7J4G5X2B9FC248NZ7QT',
    externalEarlyAssessment: '05JXW2T7J5MMQDTXCXJEZY03CK',
    expertAssessment: '05JXW2T7J5X7DE3YJ7CRJE8NMG',
    externalAdjudication: '05JXW2T7J5TAKHAV6V1C6HWTN6',
    adjudicationAssessment: '05JXW3T7J57H26HSGXZ7RFAZQK',
    authorCopyrightSubmission: '05JXW2T7J52W0NV7DWKMV9PP3S',
    editorialUploadCopyright: '05JXW2T7J6JB2SFQGQRE9B7QCC',
    editorialUploadICMJE: '05JXW2T7J60TNCHDT3M9FPAPPM',
    inviteCoReviewer: '05JXW2T7J60TNCHDT3M9FPAXWT',
    authorSubmission: 'unused?',
    authorRevision: 'unused?',
    authorUploadCopyright: '05JXW2T7J6JB2SFQGQRE9B8PTN',
    authorUploadICMJE: '05JXW2T7J6JB2SFQGQRE9B9PJC'
  },
  articleWorkflows: {
    'Article for Peer Review': {
      id: '05JXW2T8036P9JP1VF8P6DSY5T',
      formSchemas: {
        authorSubmission: '05K3QMRYH5TH9GHHN7FCB50N4T',
        authorRevision: '05K3QMRYHC406KKQKC9ZSTJ3QG',
        authorChangeRequest: '05K3QMRYHEXJXJX0SRANXSKW1F',
        reviewerFirstAssessment: '05K3QMRYHE46ATAD1EKV4GHMR4'
      },
      checklists: {
        initialAssessment: '05JXW2T70JF3X880P1VRA1TK0',
        immediateRevision: '05JXW2T70JXBGNTEBNPF9PPJMP',
        revision: '05JXW2T70JXBGNTEBNPF9PPBNT',
        revisionAssessment: '05JXW2T70J3MJ2Z3700HW1436E',
        preProduction: '05JXW2T70JSZAHG0YPVP7BNTJW'
      }
    },
    'Protocol for Peer Review': {
      id: '05JXW2T8036P9JP1VF8P6DST5S',
      formSchemas: {
        authorSubmission: '05K3QMRYH5TH9GHHN7FCB50T4S',
        authorRevision: '05K3QMRYHC406KKQKC9ZSTJ5QF',
        authorChangeRequest: '05K3QMRYHEXJXJX0SRANXSKF2E',
        reviewerFirstAssessment: '05K3QMRYHE46ATAD1EKV4GHSR4'
      },
      checklists: {
        initialAssessment: '05JXW2T70JF3X880P1VRA1QN9',
        immediateRevision: '05JXW2T70JXBGNTEBNPF9PPBT',
        revision: '05JXW2T70JXBGNTEBNPF9PPC2P',
        revisionAssessment: '05JXW2T70J3MJ2Z3700HW1465D',
        preProduction: '05JXW2T70JSZAHG0YPVP7BN6JV'
      }
    },
    Editorial: {
      id: '5XTBVB7YZMDPTHTE2B8GGRQABC',
      formSchemas: {
        authorSubmission: '53A6ZWZPKGBRYKH35AKDA74A79',
        authorRevision: '5SWN2S4BDR68RH58AGS2SMKPR8',
        authorChangeRequest: '5M27WX2WA1JTXX5N2D13HJHT8Q',
        reviewerFirstAssessment: '53KPVZV8SFSM6FFK15CC1VXQ9N'
      },
      checklists: {
        initialAssessment: '5YNHPNG4CCJJSKPT8M92RZJY2Z',
        immediateRevision: '5YNHPNG4CCJJSKPT8M92RZJY3Z',
        revision: '5Z8H5991PX5BCAHVV7J7WGQ14G',
        revisionAssessment: '5TJANEHW0Z3N8CEXKFX9H2VN5Q',
        preProduction: '5RFV4SNK68J92XNEWW2Z3P5Y6Q'
      }
    }
  }
};

export const bseStaticIds: SeedDataStaticIds<typeof bseData> = {
  baseFormSchemas: {
    editorRevisionRequest: '01KM32BRMPSZ5NQMKBS6SQAS7Z',
    editorialWithdrawSubmission: '01KM32BRMRPKZ118NAWHSDZF43',
    editorialOfferTransfer: '01KM32BRMSEV76K3Z8CFPVTHD1',
    editorialRejectSubmission: '01KM32BRMVM9G4Z8J1RJEYS9QF',
    authorWithdrawSubmission: '01KM32BRN0EH7SZXQMJ3M6EB6A',
    editorialUnsubmit: '01KM32BRN3AGKKP02YFMGNJ6CP',
    reviewerFirstAssessment: '01KM32BRN518T08RRFK7S43KXZ',
    reviewerRevisionAssessment: '01KM32BRNAKAVFFY4HWEMTC5DC',
    editorialLicensing: '01KM32BRND6AQ066W82ANDTS8F',
    externalEarlyAssessment: '01KM32BRNE55AYJTD2EPA983AA',
    expertAssessment: '01KM32BRNGDTSDBY7C5CHR53S0',
    externalAdjudication: '01KM32BRNNMBAR9FGKJ3ZXZWSG',
    adjudicationAssessment: '01KM32BRNXJ4G73JG4X018W4KN',
    authorCopyrightSubmission: '01KM32BRP1K0HM575SZQY9NMFX',
    editorialUploadCopyright: '01KM32BRPBAQ1G036V4SV6FB90',
    editorialUploadICMJE: '01KM32BRPDTSFNX7M2Q8J0DSZG',
    inviteCoReviewer: '01KM32BRPMV8GWH9RWHDT6SHHX',
    authorSubmission: '01KM32BRPQHJ168P9Z4NGBN9Q9',
    authorRevision: '01KM32BRPX40P1Y7BY0FXTP5Y4',
    authorUploadCopyright: '01KM32BRPYHT0RHWNB45K11E6J',
    authorUploadICMJE: '01KM32BRQ01DFDBEDJW12SR97M'
  },
  articleWorkflows: {
    'Base Article': {
      id: '01KM32BRQ3HTT7NERJTEH1969V',
      formSchemas: {
        authorSubmission: '01KM32BRQ5GW0HB4V25SP95785',
        authorRevision: '01KM32BRQ7GXQ4Y7CFXDH2TRDX',
        authorChangeRequest: '01KM32BRQD443NBP68HHXC8924',
        reviewerFirstAssessment: '01KM32BRQF1X2H536SE8WKW73A'
      },
      checklists: {
        initialAssessment: '01KM32BRQG436FVNJR507ZN9HZ',
        immediateRevision: '01KM32BRQJ5A1FP0QNNDD77436',
        revision: '01KM32BRQNSCTPA879VKJ31YXB',
        revisionAssessment: '01KM32BRQQWG3RKQ8T3XPJAW9R',
        preProduction: '01KM32BRQRK03QBN1N07XTV9XF'
      }
    }
  }
};

export const joneStaticIds: SeedDataStaticIds<typeof joneData> = {
  baseFormSchemas: {
    editorRevisionRequest: '01JXW2T7HW6HQCKXMJP7JXB1AH',
    editorialWithdrawSubmission: '01JXW2T7HW87T8BQBMA2ZFZP1D',
    editorialOfferTransfer: '01JXW2T7HXMNDKZWDERS9PC1KG',
    editorialRejectSubmission: '01JXW2T7HXPCE56WJENRBY11H4',
    authorWithdrawSubmission: '01JXW2T7HXJK7YC9QR76K891QC',
    editorialUnsubmit: '01JXW2T7HXCW0Y5C1E4Q03P981',
    reviewerFirstAssessment: '01JXW2T7J1KX3CVDX1YH3F0NM1',
    reviewerRevisionAssessment: '01KXW2T7J450QP8CXHN5KD8N1Y',
    editorialLicensing: '01JXW2T7J4G5X2B9FC248NZ1RS',
    externalEarlyAssessment: '01JXW2T7J5MMQDTXCXJEZY01CT',
    expertAssessment: '01JXW2T7J5X7DE3YJ7CRJE1NWF',
    externalAdjudication: '01JXW2T7J5TAKHAV6V1C6HWTE1',
    adjudicationAssessment: '01JXW3T7J57H26HSGXZ1RFAZVN',
    authorCopyrightSubmission: '01JXW2T7J52W0NV7DWKMV9PE1R',
    editorialUploadCopyright: '01JXW2T7J6JB2SFQGQRE9B1TCB',
    editorialUploadICMJE: '01JXW2T7J60TNCHDT3M1FPAUON',
    inviteCoReviewer: '01JXW2T7J60TNCHDT3M1FPAXTS',
    authorSubmission: 'unused?',
    authorRevision: 'unused?',
    authorUploadCopyright: '01JXW2T7J6JB2SFQGQRE9B1PCM',
    authorUploadICMJE: '01JXW2T7J6JB2SFQGQRE9B1PCB'
  },
  articleWorkflows: {
    'Original Article': {
      id: '01JXW2T8036P9JP1VF8P1DSX5S',
      formSchemas: {
        authorSubmission: '01K3QMRYH5TH9GHHN7FCB10X4S',
        authorRevision: '01K3QMRYHC406KKQKC9ZSTJ1QF',
        authorChangeRequest: '01K1QMRYHEXJXJX0SRANXSKE1E',
        reviewerFirstAssessment: '01K3QMRYHE46ATAD1EKV4GHRR1'
      },
      checklists: {
        initialAssessment: '01JXW2T70JF3X880P1VRA1TN1',
        immediateRevision: '01JXW2T70JXBGNTEBNPF1PPBNO',
        revision: '01JXW2T70JXBGNTEBNPF1PPBNP',
        revisionAssessment: '01JXW2T70J3MJ2Z3700HW1431D',
        preProduction: '01JXW2T70JSZAHG0YPVP1BNRJV'
      }
    },
    'Systematic Review': {
      id: '01JXW2T8CCZ081D82KB61C1GMC',
      formSchemas: {
        authorSubmission: '01K3QMRYHG1XQ22N4569X2YQK1',
        authorRevision: '01K3QMRYHGT64PN7ZJ1JF1APJC',
        authorChangeRequest: '01K3QMRYHGWG901D37S7VA91AS',
        reviewerFirstAssessment: '01K3QMRYHHKWV634DAQP6MM1GY'
      },
      checklists: {
        initialAssessment: '01JXW2T70JYN1ADZBCV4DGBNJ1',
        immediateRevision: '01JXW2T70JYN2ADZBCV4DGBNJ1',
        revision: '01JXW2T70JYN2ADZBCV4DGBNJ1',
        revisionAssessment: '01JXW2T70JYN2ADZBCV4DGBNJ1',
        preProduction: '01JXW2T70JYN2ADZBCV4DGBNJ1'
      }
    },
    'Meta-Analysis': {
      id: '4WTBVB7YZMDPTHTE1B8GGRQACB',
      formSchemas: {
        authorSubmission: '23A6ZWZPKGBRYKH35AKDA71A71',
        authorRevision: '5PWN2S4BDR68RH58AGS2SMKPR1',
        authorChangeRequest: '6M27WX2WA1JTXX5N2D13HJHT1P',
        reviewerFirstAssessment: '63KPVZV8SFSM6FFK15CC1VXS1M'
      },
      checklists: {
        initialAssessment: '6YNHPNG4CCJJSKPT8M91RZJYWX',
        immediateRevision: '6YNHPNG4CCJJSKPT8M91RZJYWY',
        revision: '4Z9H1991PX5BCAHVV7J7WGQ1WF',
        revisionAssessment: '0TJANEHW0Z3N8CEXKFX9H1VNRK',
        preProduction: '1RFV4SNK68J92XNEWW2Z3P5Y1N'
      }
    },
    Editorial: {
      id: '5Y19TNA2PS69NWHTYD9F9B691J',
      formSchemas: {
        authorSubmission: '1YFBXNHGRP3GZMN41DZYBNRHZR',
        authorRevision: '0D7BKG8NDXF1ADZXV0EY5J2TH1',
        authorChangeRequest: '0CJAABQ7T1Y0NPF9JFN1BY1XQB',
        reviewerFirstAssessment: '3E6N4DXKDPYDK7A27VWJKWRPD1'
      },
      checklists: {
        initialAssessment: '702JSXN2WVQ3NMWNY37E1KVEA1',
        immediateRevision: '702JSXN2WVQ3NMWNY37E1KVEA1',
        revision: '1NFX6576JY9QFCDWQAQYF7211C',
        revisionAssessment: '7KPDT4H69B7NG428GMWXHMZ1W1',
        preProduction: '17P5XYZTGEDV5BJ9V8KF5311GE'
      }
    },
    Others: {
      id: '3SE0BD0WC6A5RGHKF6GEKXM1G5',
      formSchemas: {
        authorSubmission: '32NXVY6KS83WASF3EFZBNM1WRT',
        authorRevision: '4Z6D51M3U0NQCM93WE8AB6QN1X',
        authorChangeRequest: '4VKY7DIXVJW0M82QTDKX4011DH',
        reviewerFirstAssessment: '7W750KFJI0MZFK4R0FSGMF11VN'
      },
      checklists: {
        initialAssessment: '0E3Z2JGX5MPHEH4A66VD651EKD',
        immediateRevision: '0E3Z2JGX5MPHEH4A66VD651EKF',
        revision: '3KCJ4R1C51TNZPXP1GWS0XNY0H',
        revisionAssessment: '22PF09O06XHXA66XYM91V01ETM',
        preProduction: '2Q4A7N4TT5KPCQ0N9HBP1C7HTX'
      }
    }
  }
};

export const jtwoStaticIds: SeedDataStaticIds<typeof jtwoData> = {
  baseFormSchemas: {
    editorRevisionRequest: '01JXW2T7HW6HQCKXMJP7JXB2AH',
    editorialWithdrawSubmission: '01JXW2T7HW87T8BQBMA2ZFZP2D',
    editorialOfferTransfer: '01JXW2T7HXMNDKZWDERS9PC2KG',
    editorialRejectSubmission: '01JXW2T7HXPCE56WJENRBY12H4',
    authorWithdrawSubmission: '01JXW2T7HXJK7YC9QR76K892QC',
    editorialUnsubmit: '01JXW2T7HXCW0Y5C1E4Q03P982',
    reviewerFirstAssessment: '01JXW2T7J1KX3CVDX1YH3F0NM2',
    reviewerRevisionAssessment: '01KXW2T7J450QP8CXHN5KD8N2Y',
    editorialLicensing: '01JXW2T7J4G5X2B9FC248NZ2RS',
    externalEarlyAssessment: '01JXW2T7J5MMQDTXCXJEZY02CT',
    expertAssessment: '01JXW2T7J5X7DE3YJ7CRJE2NWF',
    externalAdjudication: '01JXW2T7J5TAKHAV6V1C6HWTE2',
    adjudicationAssessment: '01JXW3T7J57H26HSGXZ2RFAZVN',
    authorCopyrightSubmission: '01JXW2T7J52W0NV7DWKMV9PE2R',
    editorialUploadCopyright: '01JXW2T7J6JB2SFQGQRE9B2TCB',
    editorialUploadICMJE: '01JXW2T7J60TNCHDT3M2FPAUON',
    inviteCoReviewer: '01JXW2T7J60TNCHDT3M2FPAXTS',
    authorSubmission: 'unused?',
    authorRevision: 'unused?',
    authorUploadCopyright: '01JXW2T7J6JB2SFQGQRE9B2PCM',
    authorUploadICMJE: '01JXW2T7J6JB2SFQGQRE9B2PCB'
  },
  articleWorkflows: {
    'Original Article': {
      id: '01JXW2T8036P9JP1VF8P2DSX5S',
      formSchemas: {
        authorSubmission: '01K3QMRYH5TH9GHHN7FCB20X4S',
        authorRevision: '01K3QMRYHC406KKQKC9ZSTJ2QF',
        authorChangeRequest: '01K1QMRYHEXJXJX0SRANXSKE2E',
        reviewerFirstAssessment: '01K3QMRYHE46ATAD1EKV4GHRR2'
      },
      checklists: {
        initialAssessment: '01JXW2T70JF3X880P1VRA1TN2',
        immediateRevision: '01JXW2T70JXBGNTEBNPF1PPBNO',
        revision: '01JXW2T70JXBGNTEBNPF2PPBNP',
        revisionAssessment: '01JXW2T70J3MJ2Z3700HW1422D',
        preProduction: '01JXW2T70JSZAHG0YPVP2BNRJV'
      }
    },
    'Systematic Review': {
      id: '01JXW2T8CCZ081D82KB61C2GMC',
      formSchemas: {
        authorSubmission: '01K3QMRYHG1XQ22N4569X2YQK2',
        authorRevision: '01K3QMRYHGT64PN7ZJ1JF2APJC',
        authorChangeRequest: '01K3QMRYHGWG901D37S7VA92AS',
        reviewerFirstAssessment: '01K3QMRYHHKWV634DAQP6MM2GY'
      },
      checklists: {
        initialAssessment: '01JXW2T70JYN1ADZBCV4DGBNJ2',
        immediateRevision: '01JXW2T70JYN2ADZBCV4DGBNJ2',
        revision: '01JXW2T70JYN2ADZBCV4DGBNJ2',
        revisionAssessment: '01JXW2T70JYN2ADZBCV4DGBNJ2',
        preProduction: '01JXW2T70JYN2ADZBCV4DGBNJ2'
      }
    },
    'Meta-Analysis': {
      id: '4WTBVB7YZMDPTHTE1B8GGRQWDB',
      formSchemas: {
        authorSubmission: '23A6ZWZPKGBRYKH35AKDA71A75',
        authorRevision: '5PWN2S4BDR68RH58AGS2SMKPR2',
        authorChangeRequest: '6M27WX2WA1JTXX5N2D13HJHT2P',
        reviewerFirstAssessment: '63KPVZV8SFSM6FFK15CC1VXS2M'
      },
      checklists: {
        initialAssessment: '6YNHPNG4CCJJSKPT8M92RZJYWX',
        immediateRevision: '6YNHPNG4CCJJSKPT8M92RZJYWY',
        revision: '4Z9H1991PX5BCAHVV7J7WGQ2WF',
        revisionAssessment: '0TJANEHW0Z3N8CEXKFX9H2VNRK',
        preProduction: '1RFV4SNK68J92XNEWW2Z3P5Y2N'
      }
    },
    Editorial: {
      id: '5Y19TNA2PS69NWHTYD9F9B692J',
      formSchemas: {
        authorSubmission: '1YFBXNHGRP3GZMN42DZYBNRHZR',
        authorRevision: '0D7BKG8NDXF1ADZXV0EY5J2TH2',
        authorChangeRequest: '0CJAABQ7T1Y0NPF9JFN1BY2XQB',
        reviewerFirstAssessment: '3E6N4DXKDPYDK7A27VWJKWRPD2'
      },
      checklists: {
        initialAssessment: '702JSXN2WVQ3NMWNY37E1KVEA2',
        immediateRevision: '702JSXN2WVQ3NMWNY37E1KVEA2',
        revision: '1NFX6576JY9QFCDWQAQYF7212C',
        revisionAssessment: '7KPDT4H69B7NG428GMWXHMZ1W2',
        preProduction: '17P5XYZTGEDV5BJ9V8KF5312GE'
      }
    },
    Others: {
      id: '3SE0BD0WC6A5RGHKF6GEKXM2G5',
      formSchemas: {
        authorSubmission: '32NXVY6KS83WASF3EFZBNM2WRT',
        authorRevision: '4Z6D51M3U0NQCM93WE8AB6QN2X',
        authorChangeRequest: '4VKY7DIXVJW0M82QTDKX4012DH',
        reviewerFirstAssessment: '7W750KFJI0MZFK4R0FSGMF12VN'
      },
      checklists: {
        initialAssessment: '0E3Z2JGX5MPHEH4A66VD652EKD',
        immediateRevision: '0E3Z2JGX5MPHEH4A66VD652EKF',
        revision: '3KCJ4R1C51TNZPXP1GWS0XNY2H',
        revisionAssessment: '22PF09O06XHXA66XYM91V02ETM',
        preProduction: '2Q4A7N4TT5KPCQ0N9HBP2C7HTX'
      }
    }
  }
};

export const jthreeStaticIds: SeedDataStaticIds<typeof jthreeData> = {
  baseFormSchemas: {
    editorRevisionRequest: '01JXW2T7HW6HQCKXTJP7JXB1AH',
    editorialWithdrawSubmission: '01JXW2T7HW87T9BQBMA2ZFZP1D',
    editorialOfferTransfer: '01JXW2T7HXMNDKZWCERS9PC1KG',
    editorialRejectSubmission: '01JXW2T7HXPCE46WJENRBY11H4',
    authorWithdrawSubmission: '01JXW2T7HXJK6YC9QR76K891QC',
    editorialUnsubmit: '01JXW2T7HXCW0Y4C1E4Q03P981',
    reviewerFirstAssessment: '01JXW2T7J1KX2CVDX1YH3F0NM1',
    reviewerRevisionAssessment: '01KXW2T7J450QJ8CXHN5KD8N1Y',
    editorialLicensing: '01JXW2T7J4G5X2C9FC248NZ1RS',
    externalEarlyAssessment: '01JXW3T7J5MMQDTXCXJEZY01CT',
    expertAssessment: '01JXW2T3J5X7DE3YJ7CRJE1NWF',
    externalAdjudication: '01JXW2T7J3TAKHAV6V1C6HWTE1',
    adjudicationAssessment: '01JXW3T7J57H36HSGXZ1RFAZVN',
    authorCopyrightSubmission: '01JXW3T7J52W0NV7DWKMV9PE1R',
    editorialUploadCopyright: '01JXW3T7J6JB2SFQGQRE9B1TCB',
    editorialUploadICMJE: '01JXW2T7J30TNCHDT3M1FPAUON',
    inviteCoReviewer: '01JXW2T7J30TNCHDT3M1FPAXTS',
    authorSubmission: 'unused?',
    authorRevision: 'unused?',
    authorUploadCopyright: '01JXW3T7J6JB2SFQGQRE9B1PCM',
    authorUploadICMJE: '01JXW3T7J6JB2SFQGQRE9B1PCB'
  },
  articleWorkflows: {
    'Research Article': {
      id: '01JXW2T8036P3JP1VF8P1DSX6S',
      formSchemas: {
        authorSubmission: '01K3QMRYH5TH3GHHN7FCB10X5S',
        authorRevision: '01K3QMRYHC406KKQKC3ZSTJ2QF',
        authorChangeRequest: '01K1QMRYHEXJXJX3SRANXSKE2E',
        reviewerFirstAssessment: '01K3QMRYHE36ATAD1EKV4GHRR2'
      },
      checklists: {
        initialAssessment: '01JXW2T70JF3X380P1VRA2TN1',
        immediateRevision: '01JXW2T70JXBG3TEBNPF2PPBNQ',
        revision: '01JXW2T70JXBGNTEBNPF4PPBNP',
        revisionAssessment: '01JXW2T70J3MJ3Z3700HW1441D',
        preProduction: '01JXW2T70JSZAHG3YPVP2BNRJV'
      }
    },
    'Review Article': {
      id: '01JXW2T8036P3JP1VF8P1DSX7S',
      formSchemas: {
        authorSubmission: '01K3QMRYH5TH3GHHN7FCB10X6S',
        authorRevision: '01K3QMRYHC406KKQKC3ZSTJ3QF',
        authorChangeRequest: '01K1QMRYHEXJXJX3SRANXSKE3E',
        reviewerFirstAssessment: '01K3QMRYHE36ATAD1EKV4GHRR3'
      },
      checklists: {
        initialAssessment: '01JXW2T70JF3X380P1VRA3TN1',
        immediateRevision: '01JXW2T70JXBG3TEBNPF3PPBNQ',
        revision: '01JXW2T70JXBGNTEBNPF5PPBNP',
        revisionAssessment: '01JXW2T70J3MJ3Z3700HW1451D',
        preProduction: '01JXW2T70JSZAHG3YPVP3BNRJV'
      }
    },
    Hypothesis: {
      id: '01JXW2T8036P3JP1VF8P1DSX8S',
      formSchemas: {
        authorSubmission: '01K3QMRYH5TH3GHHN7FCB10X7S',
        authorRevision: '01K3QMRYHC406KKQKC3ZSTJ4QF',
        authorChangeRequest: '01K1QMRYHEXJXJX3SRANXSKE5E',
        reviewerFirstAssessment: '01K3QMRYHE36ATAD1EKV4GHRR4'
      },
      checklists: {
        initialAssessment: '01JXW2T70JF3X380P1VRA3TN2',
        immediateRevision: '01JXW2T70JXBG3TEBNPF4PPBNQ',
        revision: '01JXW2T70JXBGNTEBNPF6PPBNP',
        revisionAssessment: '01JXW2T70J3MJ3Z3700HW1461D',
        preProduction: '01JXW2T70JSZAHG3YPVP4BNRJV'
      }
    },
    'Methods and Protocols': {
      id: '01JXW2T8036P3JP1VF8P1DSX9S',
      formSchemas: {
        authorSubmission: '01K3QMRYH5TH3GHHN7FCB10X8S',
        authorRevision: '01K3QMRYHC406KKQKC3ZSTJ5QF',
        authorChangeRequest: '01K1QMRYHEXJXJX3SRANXSKE6E',
        reviewerFirstAssessment: '01K3QMRYHE36ATAD1EKV4GHRR7'
      },
      checklists: {
        initialAssessment: '01JXW2T70JF3X380P1VRA3TN3',
        immediateRevision: '01JXW2T70JXBG3TEBNPF5PPBNQ',
        revision: '01JXW2T70JXBGNTEBNPF7PPBNP',
        revisionAssessment: '01JXW2T70J3MJ3Z3700HW1471D',
        preProduction: '01JXW2T70JSZAHG3YPVP5BNRJV'
      }
    },
    'Research Reproducibility Report': {
      id: '01JXW2T8036P3JP1VF9P1DSX9S',
      formSchemas: {
        authorSubmission: '01K3QMRYH5TH3GHHN7FCB11X8S',
        authorRevision: '01K3QMRYHC406KKQKC3ZSTJ6QF',
        authorChangeRequest: '01K1QMRYHEXJXJX3SRANXSKE7E',
        reviewerFirstAssessment: '01K3QMRYHE36ATAD1EKV4GHRR8'
      },
      checklists: {
        initialAssessment: '01JXW2T70JF3X380P1VRA3TN4',
        immediateRevision: '01JXW2T70JXBG3TEBNPF6PPBNQ',
        revision: '01JXW2T70JXBGNTEBNPF8PPBNP',
        revisionAssessment: '01JXW2T70J3MJ3Z3700HW1481D',
        preProduction: '01JXW2T70JSZAHG3YPVP6BNRJV'
      }
    },
    Perspective: {
      id: '01JXW2T8036P3JP1VF9P2DSX9S',
      formSchemas: {
        authorSubmission: '01K3QMRYH5TH3GHHN7FCB12X8S',
        authorRevision: '01K3QMRYHC406KKQKC3ZSTJ7QF',
        authorChangeRequest: '01K1QMRYHEXJXJX3SRANXSKE8E',
        reviewerFirstAssessment: '01K3QMRYHE36ATAD1EKV4GHRR9'
      },
      checklists: {
        initialAssessment: '01JXW2T70JF3X380P1VRA3TN5',
        immediateRevision: '01JXW2T70JXBG3TEBNPF7PPBNQ',
        revision: '01JXW3T70JXBGNTEBNPF8PPBNP',
        revisionAssessment: '01JXW2T70J3MJ3Z3700HW1482D',
        preProduction: '01JXW2T70JSZAHG3YPVP7BNRJV'
      }
    },
    'Research Letter': {
      id: '01JXW2T8036P3JP2VF9P2DSX9S',
      formSchemas: {
        authorSubmission: '01K3QMRYH5TH3GHHN7FCB13X8S',
        authorRevision: '01K3QMRYHC406KKQKC3ZSTJ9QF',
        authorChangeRequest: '01K1QMRYHEXJXJX3SRANXSKE9E',
        reviewerFirstAssessment: '01K3QMRYHE36ATAD1EKV5GHRR9'
      },
      checklists: {
        initialAssessment: '01JXW2T70JF3X380P1VRA4TN5',
        immediateRevision: '01JXW2T70JXBG3TEBNPF8PPBNQ',
        revision: '01JXW3T70JXBGNTEBNPF9PPBNP',
        revisionAssessment: '01JXW2T70J3MJ3Z3700HW1582D',
        preProduction: '01JXW2T70JSZAHG3YPVP8BNRJV'
      }
    }
  }
};

export const baseStaticIds: SeedDataStaticIds<typeof baseData> = {
  baseFormSchemas: {
    editorRevisionRequest: '01JXW2T7HW6HQCKXTJP7JXB1ZZ',
    editorialWithdrawSubmission: '01JXW2T7HW87T9BQBMA2ZFZP2A',
    editorialOfferTransfer: '01JXW2T7HXMNDKZWCERS9PC1KH',
    editorialRejectSubmission: '01JXW2T7HXPCE46WJENRBY11H5',
    authorWithdrawSubmission: '01JXW2T7HXJK6YC9QR76K891QD',
    editorialUnsubmit: '01JXW2T7HXCW0Y4C1E4Q03P982',
    reviewerFirstAssessment: '01JXW2T7J1KX2CVDX1YH3F0NM2',
    reviewerRevisionAssessment: '01KXW2T7J450QJ8CXHN5KD8N1Z',
    editorialLicensing: '01JXW2T7J4G5X2C9FC248NZ1RT',
    externalEarlyAssessment: '01JXW3T7J5MMQDTXCXJEZY01CU',
    expertAssessment: '01JXW2T3J5X7DE3YJ7CRJE1NXG',
    externalAdjudication: '01JXW2T7J3TAKHAV6V1C6HWTE2',
    adjudicationAssessment: '01JXW3T7J57H36HSGXZ1RFAZVO',
    authorCopyrightSubmission: '01JXW3T7J52W0NV7DWKMV9PE2S',
    editorialUploadCopyright: '01JXW3T7J6JB2SFQGQRE9B1TCC',
    editorialUploadICMJE: '01JXW2T7J30TNCHDT3M1FPAUOP',
    inviteCoReviewer: '01JXW2T7J30TNCHDT3M1FPAXTU',
    authorSubmission: 'unused?',
    authorRevision: 'unused?',
    authorUploadCopyright: '01JXW3T7J6JB2SFQGQRE9B1PCN',
    authorUploadICMJE: '01JXW3T7J6JB2SFQGQRE9B1PCC'
  },
  articleWorkflows: {
    'Base Article': {
      id: '01JXW2T8036P3JP1VF8P1DSX5T',
      formSchemas: {
        authorSubmission: '01K3QMRYH5TH3GHHN7FCB10X4T',
        authorRevision: '01K3QMRYHC406KKQKC3ZSTJ1QG',
        authorChangeRequest: '01K1QMRYHEXJXJX3SRANXSKE1F',
        reviewerFirstAssessment: '01K3QMRYHE36ATAD1EKV4GHRR2'
      },
      checklists: {
        initialAssessment: '01JXW2T70JF3X380P1VRA1TN2',
        immediateRevision: '01JXW2T70JXBG3TEBNPF1PPBNR',
        revision: '01JXW2T70JXBGNTEBNPF3PPBNQ',
        revisionAssessment: '01JXW2T70J3MJ3Z3700HW1431E',
        preProduction: '01JXW2T70JSZAHG3YPVP1BNRJW'
      }
    }
  }
};

export const nsfQCStaticIds: SeedDataStaticIds<typeof nsfQCData> = {
  baseFormSchemas: {
    editorRevisionRequest: '02JXW2T7HW6HQCKXMJP7JXB9BG',
    editorialWithdrawSubmission: '02JXW2T7HW87T8BQBMA2ZFZQ9E',
    editorialOfferTransfer: '02JXW2T7HXMNDKZWDERS9PC9CH',
    editorialRejectSubmission: '02JXW2T7HXPCE56WJENRBY19P5',
    authorWithdrawSubmission: '02JXW2T7HXJK7YC9QR76K898QD',
    editorialUnsubmit: '02JXW2T7HXCW0Y5C1E4Q03P978',
    reviewerFirstAssessment: '02JXW2T7J1KX3CVDX1YH3F0NQ9',
    reviewerRevisionAssessment: '02KXW2T7J450QP8CXHN5KD8P8Z',
    editorialLicensing: '02JXW2T7J4G5X2B9FC248NZ7QT',
    externalEarlyAssessment: '02JXW2T7J5MMQDTXCXJEZY03CK',
    expertAssessment: '02JXW2T7J5X7DE3YJ7CRJE8NMG',
    externalAdjudication: '02JXW2T7J5TAKHAV6V1C6HWTN6',
    adjudicationAssessment: '02JXW3T7J57H26HSGXZ7RFAZQK',
    authorCopyrightSubmission: '02JXW2T7J52W0NV7DWKMV9PP3S',
    editorialUploadCopyright: '02JXW2T7J6JB2SFQGQRE9B7QCC',
    editorialUploadICMJE: '02JXW2T7J60TNCHDT3M9FPAPPM',
    inviteCoReviewer: '02JXW2T7J60TNCHDT3M9FPAXWT',
    authorSubmission: 'unused?',
    authorRevision: 'unused?',
    authorUploadCopyright: '02JXW2T7J6JB2SFQGQRE9B8PTN',
    authorUploadICMJE: '02JXW2T7J6JB2SFQGQRE9B9PJC'
  },
  articleWorkflows: {
    'Article for Peer Review': {
      id: '02JXW2T8036P9JP1VF8P6DSY5T',
      formSchemas: {
        authorSubmission: '02K3QMRYH5TH9GHHN7FCB50N4T',
        authorRevision: '02K3QMRYHC406KKQKC9ZSTJ3QG',
        authorChangeRequest: '02K3QMRYHEXJXJX0SRANXSKW1F',
        reviewerFirstAssessment: '02K3QMRYHE46ATAD1EKV4GHMR4'
      },
      checklists: {
        initialAssessment: '02JXW2T70JF3X880P1VRA1TK0',
        immediateRevision: '02JXW2T70JXBGNTEBNPF9PPJMP',
        revision: '02JXW2T70JXBGNTEBNPF9PPBNT',
        revisionAssessment: '02JXW2T70J3MJ2Z3700HW1436E',
        preProduction: '02JXW2T70JSZAHG0YPVP7BNTJW'
      }
    },
    'Protocol for Peer Review': {
      id: '02JXW2T8036P9JP1VF8P6DST5S',
      formSchemas: {
        authorSubmission: '02K3QMRYH5TH9GHHN7FCB50T4S',
        authorRevision: '02K3QMRYHC406KKQKC9ZSTJ5QF',
        authorChangeRequest: '02K3QMRYHEXJXJX0SRANXSKF2E',
        reviewerFirstAssessment: '02K3QMRYHE46ATAD1EKV4GHSR4'
      },
      checklists: {
        initialAssessment: '02JXW2T70JF3X880P1VRA1QN9',
        immediateRevision: '02JXW2T70JXBGNTEBNPF9PPBT',
        revision: '02JXW2T70JXBGNTEBNPF9PPC2P',
        revisionAssessment: '02JXW2T70J3MJ2Z3700HW1465D',
        preProduction: '02JXW2T70JSZAHG0YPVP7BN6JV'
      }
    },
    Editorial: {
      id: '5WTBVB7YZMDPTHTE2B8GGRQABC',
      formSchemas: {
        authorSubmission: '33A6ZWZPKGBRYKH35AKDA74A79',
        authorRevision: '6PWN2S4BDR68RH58AGS2SMKPR8',
        authorChangeRequest: '7M27WX2WA1JTXX5N2D13HJHT8Q',
        reviewerFirstAssessment: '73KPVZV8SFSM6FFK15CC1VXQ9N'
      },
      checklists: {
        initialAssessment: '7YNHPNG4CCJJSKPT8M92RZJY2Z',
        immediateRevision: '7YNHPNG4CCJJSKPT8M92RZJY3Z',
        revision: '5Z9H5991PX5BCAHVV7J7WGQ14G',
        revisionAssessment: '1TJANEHW0Z3N8CEXKFX9H2VN5Q',
        preProduction: '2RFV4SNK68J92XNEWW2Z3P5Y6Q'
      }
    }
  }
};

export const tfbQCStaticIds: SeedDataStaticIds<typeof tfbQCData> = {
  baseFormSchemas: {
    editorRevisionRequest: '02JXW2T7HW6HQCKXMJP7JXB9AG',
    editorialWithdrawSubmission: '02JXW2T7HW87T8BQBMA2ZFZP9E',
    editorialOfferTransfer: '02JXW2T7HXMNDKZWDERS9PC9KH',
    editorialRejectSubmission: '02JXW2T7HXPCE56WJENRBY19H5',
    authorWithdrawSubmission: '02JXW2T7HXJK7YC9QR76K899QD',
    editorialUnsubmit: '02JXW2T7HXCW0Y5C1E4Q03P988',
    reviewerFirstAssessment: '02JXW2T7J1KX3CVDX1YH3F0NM9',
    reviewerRevisionAssessment: '02KXW2T7J450QP8CXHN5KD8N8Z',
    editorialLicensing: '02JXW2T7J4G5X2B9FC248NZ7RT',
    externalEarlyAssessment: '02JXW2T7J5MMQDTXCXJEZY03CU',
    expertAssessment: '02JXW2T7J5X7DE3YJ7CRJE8NWG',
    externalAdjudication: '02JXW2T7J5TAKHAV6V1C6HWTE6',
    adjudicationAssessment: '02JXW3T7J57H26HSGXZ7RFAZVO',
    authorCopyrightSubmission: '02JXW2T7J52W0NV7DWKMV9PE3S',
    editorialUploadCopyright: '02JXW2T7J6JB2SFQGQRE9B7TCC',
    editorialUploadICMJE: '02JXW2T7J60TNCHDT3M9FPAUOM',
    inviteCoReviewer: '02JXW2T7J60TNCHDT3M9FPAXTT',
    authorSubmission: 'unused?',
    authorRevision: 'unused?',
    authorUploadCopyright: '02JXW2T7J6JB2SFQGQRE9B8PCN',
    authorUploadICMJE: '02JXW2T7J6JB2SFQGQRE9B9PCC'
  },
  articleWorkflows: {
    'Article for Peer Review': {
      id: '02JXW2T8036P9JP1VF8P6DSX5T',
      formSchemas: {
        authorSubmission: '02K3QMRYH5TH9GHHN7FCB50X4T',
        authorRevision: '02K3QMRYHC406KKQKC9ZSTJ2QG',
        authorChangeRequest: '02K3QMRYHEXJXJX0SRANXSKE1F',
        reviewerFirstAssessment: '02K3QMRYHE46ATAD1EKV4GHRR4'
      },
      checklists: {
        initialAssessment: '02JXW2T70JF3X880P1VRA1TO0',
        immediateRevision: '02JXW2T70JXBGNTEBNPF9PPBMP',
        revision: '02JXW2T70JXBGNTEBNPF9PPBNQ',
        revisionAssessment: '02JXW2T70J3MJ2Z3700HW1435E',
        preProduction: '02JXW2T70JSZAHG0YPVP7BNRJW'
      }
    },
    Article: {
      id: '02JXW2T8036P9JP1VF8P6DSY5S',
      formSchemas: {
        authorSubmission: '02K3QMRYH5TH9GHHN7FCB50Y4S',
        authorRevision: '02K3QMRYHC406KKQKC9ZSTJ3QF',
        authorChangeRequest: '02K3QMRYHEXJXJX0SRANXSKF1E',
        reviewerFirstAssessment: '02K3QMRYHE46ATAD1EKV4GHSR3'
      },
      checklists: {
        initialAssessment: '02JXW2T70JF3X880P1VRA1PN9',
        immediateRevision: '02JXW2T70JXBGNTEBNPF9PPCNT',
        revision: '02JXW2T70JXBGNTEBNPF9PPCNP',
        revisionAssessment: '02JXW2T70J3MJ2Z3700HW1445D',
        preProduction: '02JXW2T70JSZAHG0YPVP7BNSJV'
      }
    },
    'Research Commentary/Essay': {
      id: '02JXW2T8CCZ081D82KB61C7GMD',
      formSchemas: {
        authorSubmission: '02K3QMRYHG1XQ22N4569X2YQR0',
        authorRevision: '02K3QMRYHGT64PN7ZJ3JF1APJD',
        authorChangeRequest: '02K3QMRYHGWG901D37S7VA93AT',
        reviewerFirstAssessment: '02K3QMRYHHKWV634DAQP6MM3GZ'
      },
      checklists: {
        initialAssessment: '02JXW2T70JYN2ADZBCV4DGBNK2',
        immediateRevision: '02JXW2T70JYN2ADZBCV4DGBNK6',
        revision: '02JXW2T70JYN2ADZBCV4DGBNK3',
        revisionAssessment: '02JXW2T70JYN2ADZBCV4DGBNK5',
        preProduction: '02JXW2T70JYN2ADZBCV4DGBNK4'
      }
    },
    'Book Review': {
      id: '5WTBVB7YZMDPTHTE2B8GGRQACC',
      formSchemas: {
        authorSubmission: '33A6ZWZPKGBRYKH35AKDA74A69',
        authorRevision: '6PWN2S4BDR68RH58AGS2SMKPR7',
        authorChangeRequest: '7M27WX2WA1JTXX5N2D13HJHT7Q',
        reviewerFirstAssessment: '73KPVZV8SFSM6FFK15CC1VXS9N'
      },
      checklists: {
        initialAssessment: '7YNHPNG4CCJJSKPT8M92RZJYZZ',
        immediateRevision: '7YNHPNG4CCJJSKPT8M92RZJYWZ',
        revision: '5Z9H5991PX5BCAHVV7J7WGQ1WG',
        revisionAssessment: '1TJANEHW0Z3N8CEXKFX9H2VNRQ',
        preProduction: '2RFV4SNK68J92XNEWW2Z3P5Y5Q'
      }
    },
    Editorial: {
      id: '6Y19TNA2PS69NWHTYD9F9B693K',
      formSchemas: {
        authorSubmission: '2YFBXNHGRP3GZMN44DZYBNRHZS',
        authorRevision: '1D7BKG8NDXF1ADZXV0EY5J2TH8',
        authorChangeRequest: '1CJAABQ7T1Y0NPF9JFN1BY4XRC',
        reviewerFirstAssessment: '4E6N4DXKDPYDK7A27VWJKWRPD7'
      },
      checklists: {
        initialAssessment: '802JSXN2WVQ3NMWNY37E1KVEB6',
        immediateRevision: '802JSXN2WVQ3NMWNY37E1KVEA7',
        revision: '2NFX6576JY9QFCDWQAQYF7291D',
        revisionAssessment: '8KPDT4H69B7NG428GMWXHMZ1W4',
        preProduction: '27P5XYZTGEDV5BJ9V8KF5319GF'
      }
    }
  }
};

export const bjmhStaticIds: SeedDataStaticIds<typeof bjmhData> = {
  baseFormSchemas: {
    editorRevisionRequest: '03JXW2T7HW6HQCKXMJP7JXB9BG',
    editorialWithdrawSubmission: '03JXW2T7HW87T8BQBMA2ZFZQ9E',
    editorialOfferTransfer: '03JXW2T7HXMNDKZWDERS9PC9CH',
    editorialRejectSubmission: '03JXW2T7HXPCE56WJENRBY19P5',
    authorWithdrawSubmission: '03JXW2T7HXJK7YC9QR76K898QD',
    editorialUnsubmit: '03JXW2T7HXCW0Y5C1E4Q03P978',
    reviewerFirstAssessment: '03JXW2T7J1KX3CVDX1YH3F0NQ9',
    reviewerRevisionAssessment: '03KXW2T7J450QP8CXHN5KD8P8Z',
    editorialLicensing: '03JXW2T7J4G5X2B9FC248NZ7QT',
    externalEarlyAssessment: '03JXW2T7J5MMQDTXCXJEZY03CK',
    expertAssessment: '03JXW2T7J5X7DE3YJ7CRJE8NMG',
    externalAdjudication: '03JXW2T7J5TAKHAV6V1C6HWTN6',
    adjudicationAssessment: '03JXW3T7J57H26HSGXZ7RFAZQK',
    authorCopyrightSubmission: '03JXW2T7J52W0NV7DWKMV9PP3S',
    editorialUploadCopyright: '03JXW2T7J6JB2SFQGQRE9B7QCC',
    editorialUploadICMJE: '03JXW2T7J60TNCHDT3M9FPAPPM',
    inviteCoReviewer: '03JXW2T7J60TNCHDT3M9FPAXWT',
    authorSubmission: 'unused?',
    authorRevision: 'unused?',
    authorUploadCopyright: '03JXW2T7J6JB2SFQGQRE9B8PTN',
    authorUploadICMJE: '03JXW2T7J6JB2SFQGQRE9B9PJC'
  },

  articleWorkflows: {
    Research: {
      id: '03JXW2T8036P9JP1VF8P6DSY5T',
      formSchemas: {
        authorSubmission: '03K3QMRYH5TH9GHHN7FCB50N4T',
        authorRevision: '03K3QMRYHC406KKQKC9ZSTJ3QG',
        authorChangeRequest: '03K3QMRYHEXJXJX0SRANXSKW1F',
        reviewerFirstAssessment: '03K3QMRYHE46ATAD1EKV4GHMR4'
      },
      checklists: {
        initialAssessment: '03JXW2T70JF3X880P1VRA1TK0',
        immediateRevision: '03JXW2T70JXBGNTEBNPF9PPJMP',
        revision: '03JXW2T70JXBGNTEBNPF9PPBNT',
        revisionAssessment: '03JXW2T70J3MJ2Z3700HW1436E',
        preProduction: '03JXW2T70JSZAHG0YPVP7BNTJW'
      }
    },
    'Literature review': {
      id: '03JXW2T8036P9JP1VF8P6DST5S',
      formSchemas: {
        authorSubmission: '03K3QMRYH5TH9GHHN7FCB50T4S',
        authorRevision: '03K3QMRYHC406KKQKC9ZSTJ5QF',
        authorChangeRequest: '03K3QMRYHEXJXJX0SRANXSKF2E',
        reviewerFirstAssessment: '03K3QMRYHE46ATAD1EKV4GHSR4'
      },
      checklists: {
        initialAssessment: '03JXW2T70JF3X880P1VRA1QN9',
        immediateRevision: '03JXW2T70JXBGNTEBNPF9PPBT',
        revision: '03JXW2T70JXBGNTEBNPF9PPC2P',
        revisionAssessment: '03JXW2T70J3MJ2Z3700HW1465D',
        preProduction: '03JXW2T70JSZAHG0YPVP7BN6JV'
      }
    },
    'Service Improvement': {
      id: '53WTBVB7YZMDPTHTE2B8GRQABD',
      formSchemas: {
        authorSubmission: '33A6ZWZPKGBRYKH35AKDA75A79',
        authorRevision: '63PWN2S4BDR78RH58AGS2TMKPR8',
        authorChangeRequest: '73M27WX2WA1JTXX5N2C13HJHT8Q',
        reviewerFirstAssessment: '73KPVZV8SFSM6FFR15CC1VXQ9N'
      },
      checklists: {
        initialAssessment: '73YNHPNG3CCJJSKPT8N92RZJY2Z',
        immediateRevision: '73YNHPNG4CCJJSKPT8M12RZJY3Z',
        revision: '53Z9H5991PX5BCAHVV7J7WGT14G',
        revisionAssessment: '13TJANEHW0Z3N8CEXKFX9H3VN5Q',
        preProduction: '23RFV4SNK68J92XNEWW2Z4P5Y6Q'
      }
    },
    Practice: {
      id: '53WTBVB7YZMDPTHTE2B8GRQABE',
      formSchemas: {
        authorSubmission: '33A6ZWZPKGBRYKH35BKDA74A79',
        authorRevision: '63PWN2S4BDR68RH58AGV2SMKPR8',
        authorChangeRequest: '73M27WX2WA1JTXX5M2D13HJHT8Q',
        reviewerFirstAssessment: '73KPVZV8SFSM5FFK15CC1VXQ9N'
      },
      checklists: {
        initialAssessment: '73YNHPNG4CCJJSKPT9M92RZJY2Z',
        immediateRevision: '73YNHPNG4CCJJSKPT7M92RZJY3Z',
        revision: '53Z9H5991PX5BCAHVV7J7WGQ13G',
        revisionAssessment: '13TJANEHW0Z3N8CEXKFX9H2VN6Q',
        preProduction: '23RFV4SNK68J92XNEWW2Z3P5Y7Q'
      }
    },
    Comment: {
      id: '53WTBVB7YZMDPTHTE2B8GRQABF',
      formSchemas: {
        authorSubmission: '33A6ZWZPKGBRYKH35AKCA74A79',
        authorRevision: '63PWN2S4BDR68RH58AGS2TMKPR8',
        authorChangeRequest: '73M27WX2WA1KTXX5M2D13HJHT8Q',
        reviewerFirstAssessment: '73KPVZV8SFSM6QFK15CC1VXQ9N'
      },
      checklists: {
        initialAssessment: '73YNHPNG4CCJJSKPT8N92RZJY2Z',
        immediateRevision: '73YNHPNG4CCJJSKPT9M92RZJY3Z',
        revision: '53Z9H5991PX5BCAHVV7J7WGQ24G',
        revisionAssessment: '13TJANEHW0Z3N8CEXKGX9H2VN5Q',
        preProduction: '23RFV4SNK68J92XNEWW2Z3Q5Y6Q'
      }
    },
    Fundamentals: {
      id: '53WTBVB7YZMDPTHTE2B8GRQABG',
      formSchemas: {
        authorSubmission: '33A6ZWZPKGBRNKH35AKDA74A79',
        authorRevision: '63PWN2S4BDR68RH68AGS2SMKPR8',
        authorChangeRequest: '73M27WX2WA2JTXX5N2D13HJHT8Q',
        reviewerFirstAssessment: '73KPVZV9SFSM6FFK15CC1VXQ9N'
      },
      checklists: {
        initialAssessment: '73YNHPNG4CCJJTKPT8M92RZJY2Z',
        immediateRevision: '73YNHPNG4CCCJSKPT8M92RZJY3Z',
        revision: '53Z9H5991PX5BCAHVR7J7WGQ14G',
        revisionAssessment: '13TJANEHW0Z3N8CEXKFX8H2VN5Q',
        preProduction: '23RFV4SNK69J92XNEWW2Z3P5Y7Q'
      }
    }
  }
};

export const magBaseStaticIds: SeedDataStaticIds<typeof magBaseData> = {
  baseFormSchemas: {
    editorRevisionRequest: '05JXW2T7HW6HQCKXTJP7JXB1ZZ',
    editorialWithdrawSubmission: '05JXW2T7HW87T9BQBMA2ZFZP2A',
    editorialOfferTransfer: '05JXW2T7HXMNDKZWCERS9PC1KH',
    editorialRejectSubmission: '05JXW2T7HXPCE46WJENRBY11H5',
    authorWithdrawSubmission: '05JXW2T7HXJK6YC9QR76K891QD',
    editorialUnsubmit: '05JXW2T7HXCW0Y4C1E4Q03P982',
    reviewerFirstAssessment: '05JXW2T7J1KX2CVDX1YH3F0NM2',
    reviewerRevisionAssessment: '05KXW2T7J450QJ8CXHN5KD8N1Z',
    editorialLicensing: '05JXW2T7J4G5X2C9FC248NZ1RT',
    externalEarlyAssessment: '05JXW3T7J5MMQDTXCXJEZY01CU',
    expertAssessment: '05JXW2T3J5X7DE3YJ7CRJE1NXG',
    externalAdjudication: '05JXW2T7J3TAKHAV6V1C6HWTE2',
    adjudicationAssessment: '05JXW3T7J57H36HSGXZ1RFAZVO',
    authorCopyrightSubmission: '05JXW3T7J52W0NV7DWKMV9PE2S',
    editorialUploadCopyright: '05JXW3T7J6JB2SFQGQRE9B1TCC',
    editorialUploadICMJE: '05JXW2T7J30TNCHDT3M1FPAUOP',
    inviteCoReviewer: '05JXW2T7J30TNCHDT3M1FPAXTU',
    authorSubmission: 'unused?',
    authorRevision: 'unused?',
    authorUploadCopyright: '05JXW3T7J6JB2SFQGQRE9B1PCN',
    authorUploadICMJE: '05JXW3T7J6JB2SFQGQRE9B1PCC'
  },
  articleWorkflows: {
    'Base Article': {
      id: '05JXW2T8036P3JP1VF8P1DSX5T',
      formSchemas: {
        authorSubmission: '05K3QMRYH5TH3GHHN7FCB10X4T',
        authorRevision: '05K3QMRYHC406KKQKC3ZSTJ1QG',
        authorChangeRequest: '05K1QMRYHEXJXJX3SRANXSKE1F',
        reviewerFirstAssessment: '05K3QMRYHE36ATAD1EKV4GHRR2'
      },
      checklists: {
        initialAssessment: '05JXW2T70JF3X380P1VRA1TN2',
        immediateRevision: '05JXW2T70JXBG3TEBNPF1PPBNR',
        revision: '05JXW2T70JXBGNTEBNPF3PPBNQ',
        revisionAssessment: '05JXW2T70J3MJ3Z3700HW1431E',
        preProduction: '05JXW2T70JSZAHG3YPVP1BNRJW'
      }
    }
  }
};

export const berghahnBaseStaticIds: SeedDataStaticIds<typeof berghahnBaseData> =
  {
    baseFormSchemas: {
      editorRevisionRequest: '06KZX3T8JX7FQHDY5K08KYC2AA',
      editorialWithdrawSubmission: '06KZX3T8JX7FQHDY5K08KYC2BB',
      editorialOfferTransfer: '06KZX3T8JX7FQHDY5K08KYC2CC',
      editorialRejectSubmission: '06KZX3T8JX7FQHDY5K08KYC2DD',
      authorWithdrawSubmission: '06KZX3T8JX7FQHDY5K08KYC2EE',
      editorialUnsubmit: '06KZX3T8JX7FQHDY5K08KYC2FF',
      reviewerFirstAssessment: '06KZX3T8JX7FQHDY5K08KYC2GG',
      reviewerRevisionAssessment: '06KZX3T8JX7FQHDY5K08KYC2HH',
      editorialLicensing: '06KZX3T8JX7FQHDY5K08KYC2JJ',
      externalEarlyAssessment: '06KZX3T8JX7FQHDY5K08KYC2KK',
      expertAssessment: '06KZX3T8JX7FQHDY5K08KYC2MM',
      externalAdjudication: '06KZX3T8JX7FQHDY5K08KYC2NN',
      adjudicationAssessment: '06KZX3T8JX7FQHDY5K08KYC2PP',
      authorCopyrightSubmission: '06KZX3T8JX7FQHDY5K08KYC2QQ',
      editorialUploadCopyright: '06KZX3T8JX7FQHDY5K08KYC2RR',
      editorialUploadICMJE: '06KZX3T8JX7FQHDY5K08KYC2SS',
      inviteCoReviewer: '06KZX3T8JX7FQHDY5K08KYC2TT',
      authorSubmission: 'unused?',
      authorRevision: 'unused?',
      authorUploadCopyright: '06KZX3T8JX7FQHDY5K08KYC2VV',
      authorUploadICMJE: '06KZX3T8JX7FQHDY5K08KYC2WW'
    },
    articleWorkflows: {
      'Base Article': {
        id: '06KZX3T8KY8JSMEZHZQ9HZD6XX',
        formSchemas: {
          authorSubmission: '06KZX3T8KY8JSMEZHZQ9HZD6YY',
          authorRevision: '06KZX3T8KY8JSMEZHZQ9HZD6ZZ',
          authorChangeRequest: '06KZX3T8KY8JSMEZHZQ9HZD6AA',
          reviewerFirstAssessment: '06KZX3T8KY8JSMEZHZQ9HZD6BB'
        },
        checklists: {
          initialAssessment: '06KZX3T8KY8JSMEZHZQ9HZD6CC',
          immediateRevision: '06KZX3T8KY8JSMEZHZQ9HZD6DD',
          revision: '06KZX3T8KY8JSMEZHZQ9HZD6EE',
          revisionAssessment: '06KZX3T8KY8JSMEZHZQ9HZD6FF',
          preProduction: '06KZX3T8KY8JSMEZHZQ9HZD6GG'
        }
      }
    }
  };

export const projStaticIds: SeedDataStaticIds<typeof projData> = {
  baseFormSchemas: {
    editorRevisionRequest: '07KZX3T8JX7FQHDY5K08KYC2AA',
    editorialWithdrawSubmission: '07KZX3T8JX7FQHDY5K08KYC2BB',
    editorialOfferTransfer: '07KZX3T8JX7FQHDY5K08KYC2CC',
    editorialRejectSubmission: '07KZX3T8JX7FQHDY5K08KYC2DD',
    authorWithdrawSubmission: '07KZX3T8JX7FQHDY5K08KYC2EE',
    editorialUnsubmit: '07KZX3T8JX7FQHDY5K08KYC2FF',
    reviewerFirstAssessment: '07KZX3T8JX7FQHDY5K08KYC2GG',
    reviewerRevisionAssessment: '07KZX3T8JX7FQHDY5K08KYC2HH',
    editorialLicensing: '07KZX3T8JX7FQHDY5K08KYC2JJ',
    externalEarlyAssessment: '07KZX3T8JX7FQHDY5K08KYC2KK',
    expertAssessment: '07KZX3T8JX7FQHDY5K08KYC2MM',
    externalAdjudication: '07KZX3T8JX7FQHDY5K08KYC2NN',
    adjudicationAssessment: '07KZX3T8JX7FQHDY5K08KYC2PP',
    authorCopyrightSubmission: '07KZX3T8JX7FQHDY5K08KYC2QQ',
    editorialUploadCopyright: '07KZX3T8JX7FQHDY5K08KYC2RR',
    editorialUploadICMJE: '07KZX3T8JX7FQHDY5K08KYC2SS',
    inviteCoReviewer: '07KZX3T8JX7FQHDY5K08KYC2TT',
    authorSubmission: 'unused?',
    authorRevision: 'unused?',
    authorUploadCopyright: '07KZX3T8JX7FQHDY5K08KYC2VV',
    authorUploadICMJE: '07KZX3T8JX7FQHDY5K08KYC2WW'
  },
  articleWorkflows: {
    'Research Article': {
      id: '07KZX3T8KY8JSMEZHZQ9HZD6XX',
      formSchemas: {
        authorSubmission: '07KZX3T8KY8JSMEZHZQ9HZD6YY',
        authorRevision: '07KZX3T8KY8JSMEZHZQ9HZD6ZZ',
        authorChangeRequest: '07KZX3T8KY8JSMEZHZQ9HZD6AA',
        reviewerFirstAssessment: '07KZX3T8KY8JSMEZHZQ9HZD6BB'
      },
      checklists: {
        initialAssessment: '07KZX3T8KY8JSMEZHZQ9HZD6CC',
        immediateRevision: '07KZX3T8KY8JSMEZHZQ9HZD6DD',
        revision: '07KZX3T8KY8JSMEZHZQ9HZD6EE',
        revisionAssessment: '07KZX3T8KY8JSMEZHZQ9HZD6FF',
        preProduction: '07KZX3T8KY8JSMEZHZQ9HZD6GG'
      }
    },
    'Book Review': {
      id: '07KZX3T8KY8JSMEZHZQ9HZD6HH',
      formSchemas: {
        authorSubmission: '07KZX3T8KY8JSMEZHZQ9HZD6JJ',
        authorRevision: '07KZX3T8KY8JSMEZHZQ9HZD6KK',
        authorChangeRequest: '07KZX3T8KY8JSMEZHZQ9HZD6MM',
        reviewerFirstAssessment: '07KZX3T8KY8JSMEZHZQ9HZD6NN'
      },
      checklists: {
        initialAssessment: '07KZX3T8KY8JSMEZHZQ9HZD6PP',
        immediateRevision: '07KZX3T8KY8JSMEZHZQ9HZD6QQ',
        revision: '07KZX3T8KY8JSMEZHZQ9HZD6RR',
        revisionAssessment: '07KZX3T8KY8JSMEZHZQ9HZD6SS',
        preProduction: '07KZX3T8KY8JSMEZHZQ9HZD6TT'
      }
    }
  }
};

export const gssStaticIds: SeedDataStaticIds<typeof gssData> = {
  baseFormSchemas: {
    editorRevisionRequest: '07KZX3T8MYBKJWR0VEEBGP84G4',
    editorialWithdrawSubmission: '07KZX3T8MYBKJWR0VEEBGP84H5',
    editorialOfferTransfer: '07KZX3T8MYBKJWR0VEEBGP84J6',
    editorialRejectSubmission: '07KZX3T8MYBKJWR0VEEBGP84K7',
    authorWithdrawSubmission: '07KZX3T8MYBKJWR0VEEBGP84M8',
    editorialUnsubmit: '07KZX3T8MYBKJWR0VEEBGP84N9',
    reviewerFirstAssessment: '07KZX3T8MYBKJWR0VEEBGP84PA',
    reviewerRevisionAssessment: '07KZX3T8MYBKJWR0VEEBGP84QB',
    editorialLicensing: '07KZX3T8MYBKJWR0VEEBGP84RC',
    externalEarlyAssessment: '07KZX3T8MYBKJWR0VEEBGP84SD',
    expertAssessment: '07KZX3T8MYBKJWR0VEEBGP84TE',
    externalAdjudication: '07KZX3T8MYBKJWR0VEEBGP84VF',
    adjudicationAssessment: '07KZX3T8MYBKJWR0VEEBGP84WG',
    authorCopyrightSubmission: '07KZX3T8MYBKJWR0VEEBGP84XH',
    editorialUploadCopyright: '07KZX3T8MYBKJWR0VEEBGP84YJ',
    editorialUploadICMJE: '07KZX3T8MYBKJWR0VEEBGP84ZK',
    inviteCoReviewer: '07KZX3T8MYBKJWR0VEEBGP84AK',
    authorSubmission: 'unused?',
    authorRevision: 'unused?',
    authorUploadCopyright: '07KZX3T8MYBKJWR0VEEBGP84BM',
    authorUploadICMJE: '07KZX3T8MYBKJWR0VEEBGP84CN'
  },
  articleWorkflows: {
    'Research Article': {
      id: '07KZX3T8MYBKJWR0VEEBGP84DP',
      formSchemas: {
        authorSubmission: '07KZX3T8MYBKJWR0VEEBGP84EQ',
        authorRevision: '07KZX3T8MYBKJWR0VEEBGP84FR',
        authorChangeRequest: '07KZX3T8MYBKJWR0VEEBGP84GS',
        reviewerFirstAssessment: '07KZX3T8MYBKJWR0VEEBGP84HT'
      },
      checklists: {
        initialAssessment: '07KZX3T8MYBKJWR0VEEBGP84JV',
        immediateRevision: '07KZX3T8MYBKJWR0VEEBGP84KW',
        revision: '07KZX3T8MYBKJWR0VEEBGP84KX',
        revisionAssessment: '07KZX3T8MYBKJWR0VEEBGP84MY',
        preProduction: '07KZX3T8MYBKJWR0VEEBGP84NZ'
      }
    },
    'Book Review': {
      id: '07KZX3T8MYBKJWR0VEEBGP86A1',
      formSchemas: {
        authorSubmission: '07KZX3T8MYBKJWR0VEEBGP86B2',
        authorRevision: '07KZX3T8MYBKJWR0VEEBGP86C3',
        authorChangeRequest: '07KZX3T8MYBKJWR0VEEBGP86D4',
        reviewerFirstAssessment: '07KZX3T8MYBKJWR0VEEBGP86E5'
      },
      checklists: {
        initialAssessment: '07KZX3T8MYBKJWR0VEEBGP86F6',
        immediateRevision: '07KZX3T8MYBKJWR0VEEBGP86G7',
        revision: '07KZX3T8MYBKJWR0VEEBGP86H8',
        revisionAssessment: '07KZX3T8MYBKJWR0VEEBGP86J9',
        preProduction: '07KZX3T8MYBKJWR0VEEBGP86K0'
      }
    }
  }
};

export const theoriaStaticIds: SeedDataStaticIds<typeof theoriaData> = {
  baseFormSchemas: {
    editorRevisionRequest: '07KZX3T8MZNQHXT4C41VER0Q7W',
    editorialWithdrawSubmission: '07KZX3T8MZNQHXT4C41VER0Q8X',
    editorialOfferTransfer: '07KZX3T8MZNQHXT4C41VER0Q9Y',
    editorialRejectSubmission: '07KZX3T8MZNQHXT4C41VER0QA0',
    authorWithdrawSubmission: '07KZX3T8MZNQHXT4C41VER0QB1',
    editorialUnsubmit: '07KZX3T8MZNQHXT4C41VER0QC2',
    reviewerFirstAssessment: '07KZX3T8MZNQHXT4C41VER0QD3',
    reviewerRevisionAssessment: '07KZX3T8MZNQHXT4C41VER0QE4',
    editorialLicensing: '07KZX3T8MZNQHXT4C41VER0QF5',
    externalEarlyAssessment: '07KZX3T8MZNQHXT4C41VER0QG6',
    expertAssessment: '07KZX3T8MZNQHXT4C41VER0QH7',
    externalAdjudication: '07KZX3T8MZNQHXT4C41VER0QJ8',
    adjudicationAssessment: '07KZX3T8MZNQHXT4C41VER0QK9',
    authorCopyrightSubmission: '07KZX3T8MZNQHXT4C41VER0QMA',
    editorialUploadCopyright: '07KZX3T8MZNQHXT4C41VER0QNB',
    editorialUploadICMJE: '07KZX3T8MZNQHXT4C41VER0QPC',
    inviteCoReviewer: '07KZX3T8MZNQHXT4C41VER0QQD',
    authorSubmission: 'unused?',
    authorRevision: 'unused?',
    authorUploadCopyright: '07KZX3T8MZNQHXT4C41VER0QRE',
    authorUploadICMJE: '07KZX3T8MZNQHXT4C41VER0QSF'
  },
  articleWorkflows: {
    'Research Article': {
      id: '07KZX3T8MZNQHXT4C41VER0QTG',
      formSchemas: {
        authorSubmission: '07KZX3T8MZNQHXT4C41VER0QTH',
        authorRevision: '07KZX3T8MZNQHXT4C41VER0QVJ',
        authorChangeRequest: '07KZX3T8MZNQHXT4C41VER0QWK',
        reviewerFirstAssessment: '07KZX3T8MZNQHXT4C41VER0QXK'
      },
      checklists: {
        initialAssessment: '07KZX3T8MZNQHXT4C41VER0QYM',
        immediateRevision: '07KZX3T8MZNQHXT4C41VER0QZN',
        revision: '07KZX3T8MZNQHXT4C41VER0RAP',
        revisionAssessment: '07KZX3T8MZNQHXT4C41VER0RBQ',
        preProduction: '07KZX3T8MZNQHXT4C41VER0RCR'
      }
    },
    'Book Review': {
      id: '07KZX3T8MZNQHXT4C41VER0SDS',
      formSchemas: {
        authorSubmission: '07KZX3T8MZNQHXT4C41VER0SET',
        authorRevision: '07KZX3T8MZNQHXT4C41VER0SFV',
        authorChangeRequest: '07KZX3T8MZNQHXT4C41VER0SGW',
        reviewerFirstAssessment: '07KZX3T8MZNQHXT4C41VER0SHX'
      },
      checklists: {
        initialAssessment: '07KZX3T8MZNQHXT4C41VER0SJY',
        immediateRevision: '07KZX3T8MZNQHXT4C41VER0SKZ',
        revision: '07KZX3T8MZNQHXT4C41VER0SMA',
        revisionAssessment: '07KZX3T8MZNQHXT4C41VER0SNB',
        preProduction: '07KZX3T8MZNQHXT4C41VER0SPC'
      }
    }
  }
};
